// Direct imports to avoid Customer.io analytics dependency issues
import * as Sentry from "@sentry/browser";
import mixpanel from 'mixpanel-browser';
import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
const analytics = AnalyticsBrowser.load({ writeKey: "b697936a820366b49025" });

// Analytics availability check and dual tracking function
const hasCustomerIO = typeof analytics !== 'undefined' && analytics && typeof analytics.track === 'function';
const hasMixpanel = typeof mixpanel !== 'undefined' && typeof mixpanel.track === 'function';

console.log('Analytics availability:', { customerIO: hasCustomerIO, mixpanel: hasMixpanel });

// Crash-proof dual analytics tracking function - handles all errors gracefully
function trackEvent(eventName, properties = {}) {
    // CustomerIO tracking (primary)
    try {
        if (typeof analytics !== 'undefined' && analytics && analytics.track) {
            analytics.track(eventName, properties);
        }
    } catch(e) {
        console.warn('CustomerIO tracking failed:', e);
    }

    // Mixpanel tracking (secondary/existing) - convert event name for compatibility
    try {
        if (typeof mixpanel !== 'undefined' && mixpanel.track) {
            const mixpanelEventName = eventName.replace('learnerplus_', '').replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            mixpanel.track(mixpanelEventName, properties);
        }
    } catch(e) {
        console.warn('Mixpanel tracking failed:', e);
    }
}

var jquery = require("jquery");
$ = window.$ = window.jQuery = jquery; // notice the definition of global variables here

import axios from 'axios';
import { createPopup } from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';

import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';

import LearnerPlusWhatsAppQRCode from '../img/learnerplus-app-whatsapp-qr.png';
import LearnerPlusWhatsAppQRCode_GPTrainees from '../img/W3EOZ5ATX6LFO1.png';

//
const Mustache = require('mustache');
//
import firebase from "firebase/compat/app";

import "firebase/compat/auth";
import "firebase/compat/analytics";
import "firebase/compat/database";
import "firebase/compat/firestore";

// import our utils
import { getQueryParamsAsObject, getQueryParamsAsString, removeURLParameters } from "../lib/util-standardfunctions.js";

// Import reflective insights class (secure internal import)
import ReflectiveInsights from './learnerplus-reflective-insights.js';

// DSIB (Dynamic Streak/Insight Button) system - now handled inline

//
if(window.document.documentMode){
    document.getElementById('main-preloader').innerHTML = '<div class="col s8 offset-s2"><h3>This browser is not supported. Please use Apple Safari, Mozilla Firefox, Microsoft Edge or Google Chrome</h3></div>';
}
if (window.location.href.indexOf("http://localhost") === -1){
    window.console.log = function(){
        console.info('© 2024 SCAD.Ventures');
        window.console.log = function() {
            return false;
        }
    }
}

console.log("JSKJM");

// Global error handler for analytics tracking
window.addEventListener('error', function(event) {
    try {
        if (typeof analytics !== 'undefined' && analytics && analytics.track) {
            analytics.track('learnerplus_client_error', {
                error_message: event.message,
                error_source: event.filename,
                error_line: event.lineno,
                error_column: event.colno,
                user_agent: navigator.userAgent,
                page_url: window.location.href,
                timestamp: new Date().toISOString()
            });
        }
    } catch(e) {
        console.warn('Failed to track client error:', e);
    }
});

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', function(event) {
    try {
        if (typeof analytics !== 'undefined' && analytics && analytics.track) {
            analytics.track('learnerplus_unhandled_rejection', {
                reason: event.reason ? event.reason.toString() : 'Unknown',
                user_agent: navigator.userAgent,
                page_url: window.location.href,
                timestamp: new Date().toISOString()
            });
        }
    } catch(e) {
        console.warn('Failed to track unhandled rejection:', e);
    }
});

!(function() {
    var CURR_USER = false;
    var CURR_USERPROFILE = false;
    var CURR_STRIPESTATUS = false;
    var CURR_STRIPEPACKET = false;
    var CURR_ENTERPRISEMODE_IS_ACTIVE = false; // if enterprise mode was detected
    var CURR_ENTERPRISEMODE_STATUS = ""; // message for enterprise mode
    var CURR_FREECERTS = false; // free-certs roster check (fetched during cert generation)
    var CURR_LEARNERSTATE = {
        creditBalance: 0,
        reflections: [],
        reflection_ids: [],
        certificates: []
    }
    var CURR_REFLECTIONKIT = false;
    var CURR_CLARITY_RESULTS = false; // Store clarity engine results
    var CURR_SMART_NUDGES = []; // Store current smart nudges 
    window.CURR_SMART_NUDGES = CURR_SMART_NUDGES; // Expose for DSIB integration
    var CURR_SESSION_ID = null; // Store current conversation session ID
    var HIDDEN_REFLECTIVE_GAP = null; // Store reflective gap internally
    var completeAnalysisStep = null; // Store analysis completion function internally
    
    // Initialize reflective insights system (secure internal instance)
    var reflectiveInsights = new ReflectiveInsights();
    window.reflectiveInsights = reflectiveInsights; // Make accessible for analysis tasks
    console.log("Reflective insights system initialized");

    // Initialize DSIB system (Dynamic Streak/Insight Button) - now handled inline
    initializeDSIB();
    console.log("DSIB system initialized");

    // Initialize Reflectivity Meter system
    var reflectivityMeter = {
        lastReflectionDate: null,
        reflectionStreak: 0,
        totalReflections: 0,
        currentLevel: 1,
        progressPercent: 0,
        state: 'ready', // 'ready' or 'needs' - default to ready
        nudgeInterval: null,
        
        // Growth stages and badges
        growthStages: [
            { level: 1, emoji: '🌱', name: 'Seedling', minReflections: 0 },
            { level: 2, emoji: '🌿', name: 'Sprout', minReflections: 5 },
            { level: 3, emoji: '🌳', name: 'Growing', minReflections: 15 },
            { level: 4, emoji: '🧠', name: 'Thoughtful', minReflections: 30 },
            { level: 5, emoji: '✨', name: 'Enlightened', minReflections: 50 }
        ],
        
        // Initialize the meter
        init() {
            this.updateMeterState();
            this.bindEvents();
            this.startNudgeTimer();
        },
        
        // Update meter based on current reflection data
        updateMeterState() {
            this.calculateReflectionMetrics();
            
            this.updateProgressAndState();
            this.updateVisuals();
        },
        
        // Calculate reflection metrics from current data
        calculateReflectionMetrics() {
            // Get real data from CURR_LEARNERSTATE
            if (CURR_LEARNERSTATE && CURR_LEARNERSTATE.reflections) {
                this.totalReflections = CURR_LEARNERSTATE.reflections.length;
                
                // Calculate streak based on actual reflection dates
                const today = new Date();
                if (this.totalReflections > 0) {
                    // Get most recent reflection date
                    const sortedReflections = CURR_LEARNERSTATE.reflections
                        .filter(r => r.claimedOn)
                        .sort((a, b) => new Date(b.claimedOn) - new Date(a.claimedOn));
                    
                    if (sortedReflections.length > 0) {
                        this.lastReflectionDate = new Date(sortedReflections[0].claimedOn);
                        
                        // Calculate current streak
                        let streak = 0;
                        const dayMs = 24 * 60 * 60 * 1000;
                        let checkDate = new Date(today);
                        
                        for (let i = 0; i < sortedReflections.length; i++) {
                            const reflectionDate = new Date(sortedReflections[i].claimedOn);
                            const daysDiff = Math.floor((checkDate - reflectionDate) / dayMs);
                            
                            if (daysDiff <= 1) { // Allow for same day or next day
                                streak++;
                                checkDate = new Date(reflectionDate);
                            } else {
                                break;
                            }
                        }
                        
                        this.reflectionStreak = streak;
                    } else {
                        this.reflectionStreak = 0;
                        this.lastReflectionDate = null;
                    }
                } else {
                    this.reflectionStreak = 0;
                    this.lastReflectionDate = null;
                }
            } else {
                // No data available
                this.totalReflections = 0;
                this.reflectionStreak = 0;
                this.lastReflectionDate = null;
            }
        },
        
        // Update progress percentage and determine state
        updateProgressAndState() {
            // Calculate total reflection data from both sources
            const totalReflectionData = this.getTotalReflectionData();
            
            // State logic based on sufficient reflection data
            if (totalReflectionData >= 5) {
                this.state = 'ready';
                this.progressPercent = Math.min(100, (totalReflectionData / 20) * 100); // Progress based on data richness
            } else {
                this.state = 'needs';
                this.progressPercent = Math.max(20, (totalReflectionData / 5) * 100); // Progress toward minimum threshold
            }
            
            // Update current level
            this.currentLevel = this.calculateLevel();
        },
        
        // Get total reflection data points from both reflective-thinking and reflective-practice
        getTotalReflectionData() {
            // Default to ready state for most users - only show needs if insufficient data
            // In future, this will check actual Firebase collections for reflective-thinking + reflective-practice entries
            const thinkingEntries = CURR_LEARNERSTATE?.reflections?.length || 0;
            const practiceEntries = this.totalReflections || 0;
            const totalEntries = thinkingEntries + practiceEntries;
            
            // Default to 10 entries for now (ready state) - real implementation will fetch from Firebase
            return totalEntries > 0 ? totalEntries : 10;
        },
        
        // Get days since last reflection
        getDaysSinceLastReflection() {
            if (!this.lastReflectionDate) return 999;
            const today = new Date();
            const timeDiff = today.getTime() - this.lastReflectionDate.getTime();
            return Math.floor(timeDiff / (1000 * 3600 * 24));
        },
        
        // Calculate current level based on total reflections
        calculateLevel() {
            for (let i = this.growthStages.length - 1; i >= 0; i--) {
                if (this.totalReflections >= this.growthStages[i].minReflections) {
                    return this.growthStages[i].level;
                }
            }
            return 1;
        },
        
        // Update all visual elements
        updateVisuals() {
            const button = document.getElementById('reflectivity-button');
            const progressFill = document.getElementById('progress-fill');
            const tooltipText = document.getElementById('tooltip-text');
            
            if (!button || !progressFill || !tooltipText) return;
            
            // Update button state classes
            button.className = button.className.replace(/state-\w+/g, '');
            button.classList.add(`state-${this.state}`);
            progressFill.classList.add(`state-${this.state}`);
            
            // Update progress ring
            const circumference = 2 * Math.PI * 28; // radius = 28
            const offset = circumference - (this.progressPercent / 100) * circumference;
            progressFill.style.strokeDashoffset = offset;
            
            // Update tooltip based on state
            if (this.state === 'ready') {
                tooltipText.textContent = `Your reflective learning insights are ready for analysis!`;
            } else {
                const totalData = this.getTotalReflectionData();
                const remaining = 5 - totalData;
                if (totalData === 0) {
                    tooltipText.textContent = "Start your reflective learning journey - capture your first insights!";
                } else {
                    tooltipText.textContent = `${remaining} more reflection${remaining === 1 ? '' : 's'} needed to unlock insights analysis.`;
                }
            }
        },
        
        // Bind events
        bindEvents() {
            const button = document.getElementById('reflectivity-button');
            if (button) {
                button.addEventListener('click', () => this.onMeterClick());
            }
        },
        
        // Handle meter click
        onMeterClick() {
            // Always show the reflective insights modal (previously transcript modal)
            showReflectiveInsightsModal();
            
            // Add subtle click feedback
            this.animateClick();
        },
        
        // Show encouragement for needs state
        showEncouragement() {
            const messages = [
                "Every reflection captures your authentic thinking process.",
                "Your thought patterns are unique and valuable to document.",
                "Building your thinking transcript starts with one reflection.",
                "Authentic human reasoning deserves to be preserved.",
                "Your cognitive process is proof of genuine human intelligence."
            ];
            
            const randomMessage = messages[Math.floor(Math.random() * messages.length)];
            showNotification("Build Your Thought Process", randomMessage, "info", 4000);
            
            // Could trigger reflection interface here if needed
            // For now, just show encouragement
        },
        
        // Animate click with subtle feedback
        animateClick() {
            const button = document.getElementById('reflectivity-button');
            if (button) {
                button.style.transform = 'scale(0.95)';
                setTimeout(() => {
                    button.style.transform = '';
                }, 150);
            }
        },
        
        // Start periodic nudging for needs state
        startNudgeTimer() {
            // Clear existing timer
            if (this.nudgeInterval) {
                clearInterval(this.nudgeInterval);
            }
            
            // Set up nudging every 15 seconds when in needs state
            this.nudgeInterval = setInterval(() => {
                if (this.state === 'needs') {
                    this.performNudge();
                }
            }, 15000);
        },
        
        // Perform gentle nudge animation
        performNudge() {
            const button = document.getElementById('reflectivity-button');
            if (button && this.state === 'needs') {
                button.classList.add('nudge');
                setTimeout(() => {
                    button.classList.remove('nudge');
                }, 1000);
            }
        },
        
        // Real reflection capture is handled by the existing reflection system
        // This meter will update when actual reflections are saved
        
        // Check if user leveled up and celebrate
        checkLevelUp() {
            const newLevel = this.calculateLevel();
            if (newLevel > this.currentLevel) {
                this.currentLevel = newLevel;
                const stage = this.growthStages.find(s => s.level === newLevel);
                if (stage) {
                    setTimeout(() => {
                        showNotification(
                            `Thinking Level Up!`, 
                            `You've reached ${stage.name} (Level ${newLevel})! Your thought process transcript deepens.`, 
                            "success", 
                            5000
                        );
                        this.animateClick();
                    }, 1000);
                }
            }
        },
        
        // State changes are handled by real data updates
    };
    console.log("Reflectivity Meter initialized");
    //
    var CURR_QueryParams_Str = getQueryParamsAsString();
    var CURR_QueryParams_Obj = getQueryParamsAsObject();
    console.log("CURR_QueryParams_Obj", CURR_QueryParams_Obj);
    
    // Check for learnerhub parameter and redirect to /hub if present
    if (CURR_QueryParams_Obj.learnerhub === '1') {
        console.log("learnerhub=1 detected, redirecting to /hub");
        window.location.href = '/hub?learnerhub=1';
        return;
    }
    
    // add a function that checks and removes the console if the URL is not localhost
    removeURLParameters(Object.keys(CURR_QueryParams_Obj));
    console.log("MIJI JSKJM!");
    console.log("JSK JM MIJI");
    console.log("Learner+ Liminal Engine Loaded | JSKJM");
    console.log("Firebase available:", typeof firebase !== 'undefined');
    console.log("jQuery available:", typeof $ !== 'undefined');
    console.log("Axios available:", typeof axios !== 'undefined');
    
    // Initialize Sentry
    Sentry.init({
        dsn: "https://3fdb0c41327a83e4cb56d5b4b90581d0@o4506895983706112.ingest.us.sentry.io/4506895986524160",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
    });
    console.log('Sentry initialized for Learner+ Go');
    
    // Initialize Mixpanel
    mixpanel.init('cf94a02e44ddf7e05d5845558f9f89df', {debug: true, track_pageview: true, persistence: 'localStorage'});
    console.log('Mixpanel initialized for Learner+ Go');

    // Lightweight analytics helper for consistent, safe tracking
    const MP = {
        track: function(event, props = {}) {
            try {
                mixpanel.track(event, props);
            } catch (e) {
                console.warn('Mixpanel track failed', event, e);
            }
        },
        register: function(props = {}) {
            try {
                mixpanel.register(props);
            } catch (e) {
                console.warn('Mixpanel register failed', e);
            }
        }
    };
    // One-time flag for spark typing event
    let SPARK_TYPED_ONCE = false;
    
    // Firebase configuration
    const firebaseConfig = {
        apiKey: "AIzaSyAkOAXn8FEH1PKjf_aghihKEamNddBQB18",
        authDomain: "learner-plus.firebaseapp.com",
        projectId: "learner-plus",
        storageBucket: "learner-plus.appspot.com",
        messagingSenderId: "812434383550",
        appId: "1:812434383550:web:d2cda1285d3e3199a134ef"
    };
    
    // Initialize Firebase
    showLoadingOverlay("Loading Learner+");
    //
    console.log("%cLearner+ Go vs Learner Hub free -- we need to hide reflect now button for non-subscribers (stripe check)", "color:red; background:white; font-size:1.26em;")
    //
    let app;
    try {
        // Check if Firebase app already exists
        app = firebase.app();
        console.log("Firebase app already initialized");
    } catch (error) {
        // Initialize Firebase if it doesn't exist
        console.log("Initializing new Firebase app");
        app = firebase.initializeApp(firebaseConfig);
    }
    firebase.auth().onAuthStateChanged((user)=>{
        try {
            console.log("Auth state changed:", user);
            if (user){
                // we have a user
                console.log("User authenticated with UID:", user.uid);
                UI_BindActions();
                //
                CURR_USER = user;
                // we see if the profile is filled out otherwise move forward
                firebase.firestore().collection('userprofiles').doc(user.uid).get().then((doc)=>{
                    if (doc.exists){
                        showLoadingOverlay("Setting up reflective guides, your dashboard and more...");
                        CURR_USERPROFILE = doc.data();
                        CURR_REFLECTIONKIT = "reflective-practice";
                        if (CURR_USERPROFILE.reflectionkits){
                            CURR_REFLECTIONKIT = CURR_USERPROFILE.reflectionkits[0]?CURR_USERPROFILE.reflectionkits[0]: "reflective-practice";                    
                        }
                        //
                        Sentry.setContext("CURR_USER", CURR_USER);
                        Sentry.setContext("CURR_USERPROFILE", CURR_USERPROFILE);
                        Sentry.setContext("CURR_REFLECTIONKIT", CURR_REFLECTIONKIT);
                        //
                        mixpanel.identify(CURR_USER.uid);
                        mixpanel.people.set({
                            "$email": CURR_USERPROFILE.email,
                            "$name": CURR_USERPROFILE.firstname + " " + CURR_USERPROFILE.lastname,
                            "credential": CURR_USERPROFILE.credential,
                        });
                        trackEvent('learnerplus_dashboard_loaded', {
                            query_params: CURR_QueryParams_Obj,
                            subscription_status: CURR_STRIPESTATUS,
                            enterprise_mode: CURR_ENTERPRISEMODE_IS_ACTIVE,
                            user_profile: CURR_USERPROFILE
                        });
                        // Register baseline super properties for session context
                        try {
                            const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
                            MP.register({
                                app: 'learnerplus-go',
                                env: (window.location.hostname || '').includes('localhost') ? 'local' : 'prod',
                                device: isMobile ? 'mobile' : 'desktop',
                                user_agent: navigator.userAgent || '',
                                reflection_kit: CURR_REFLECTIONKIT || 'reflective-practice',
                                credential: CURR_USERPROFILE.credential || '',
                                specialty: CURR_USERPROFILE.specialty || '',
                                primary_location: CURR_USERPROFILE.primarylocation || ''
                            });
                        } catch(e){ console.warn('Failed to register baseline super props', e); }
                        //
                        CURR_STRIPESTATUS = false;
                        CURR_ENTERPRISEMODE_IS_ACTIVE = false;
                        CURR_ENTERPRISEMODE_STATUS = "";
                        //
                        fetchStripeStatus(()=>{
                            mixpanel.track('Fetch Enterprise and Stripe Status', {CURR_STRIPESTATUS, CURR_ENTERPRISEMODE_IS_ACTIVE, CURR_ENTERPRISEMODE_STATUS});
                            // Update super properties with billing/enterprise context
                            MP.register({
                                stripe_status: CURR_STRIPESTATUS ? 'active' : 'free',
                                enterprise_mode: CURR_ENTERPRISEMODE_IS_ACTIVE ? 'active' : 'none'
                            });
                            try { mixpanel.people.set({ stripe_status: CURR_STRIPESTATUS ? 'active' : 'free' }); } catch(e) {}
                            InitiateMainApp();
                        });
                        
                    }else{
                        console.log("issue with doc in the userprofiles section");
                        const returnUrl = CURR_QueryParams_Str ? `?${CURR_QueryParams_Str}` : '';
                        window.location.href = `/login?return_url=${encodeURIComponent(returnUrl)}`;
                    }
                }).catch((error)=>{
                    showNotification('Profile Fetch Error', 'There was an error fetching your profile - '+error+'.', 'error', 3000);
                    const returnUrl = CURR_QueryParams_Str ? `?${CURR_QueryParams_Str}` : '';
                    window.location.href = `/login?return_url=${encodeURIComponent(returnUrl)}`;
                });
            //
        }else{
            // no user
            console.log("issue with user logged in");
            var includeSubscriptionHook = '';
            if (CURR_QueryParams_Obj.navigate_to_subscribe){
                includeSubscriptionHook = '&navigate_to_subscribe=true';
            }
            const returnUrl = CURR_QueryParams_Str ? `?${CURR_QueryParams_Str}` : '';
            window.location.href = `/login?return_url=${encodeURIComponent(returnUrl)}${includeSubscriptionHook}`;
        }
        } catch (authError) {
            console.error("Error in auth state change handler:", authError);
            showNotification('Authentication Error', 'Failed to handle authentication: ' + authError.message, 'error', 5000);
        }
    });
    
    function fetchStripeStatus(callback) {
        firebase.firestore().collection('stripe').doc(CURR_USER.uid).get().then((doc) => {
            if (doc.data()) {
                var stripePacket = doc.data();
                CURR_STRIPEPACKET = stripePacket;
                if (stripePacket.subscription_status === 'active') {
                    CURR_STRIPESTATUS = true;
                    return callback();
                } else {
                    return checkEnterpriseStripeOverride(callback);
                }
            } else {
                return checkEnterpriseStripeOverride(callback);
            }
        }).catch(stripeErr => {
            console.error(stripeErr);
            CURR_STRIPESTATUS = false;
            callback();
        });
    }
    
    // we check email in domain OR actual email in roster! :) 
    function checkEnterpriseStripeOverride(callback) {
        console.log('checking check-enterprise-membership')

        // ✅ GET FIREBASE AUTH TOKEN
        if (!firebase.auth().currentUser) {
            console.error('No authenticated user for enterprise check');
            CURR_STRIPESTATUS = false;
            CURR_ENTERPRISEMODE_IS_ACTIVE = false;
            return callback();
        }

        firebase.auth().currentUser.getIdToken().then(idToken => {
            // ✅ INCLUDE TOKEN IN AUTHORIZATION HEADER
            axios.post(`/check-enterprise-membership`,
                {email: CURR_USERPROFILE.email},
                {headers: {'Authorization': `Bearer ${idToken}`}}
            ).then((response) => {
                const { status, team, expirationDate } = response.data;
                if (status === "active") {
                    CURR_STRIPESTATUS = true;
                    CURR_ENTERPRISEMODE_IS_ACTIVE = true;
                    CURR_ENTERPRISEMODE_STATUS = `Team: ${team}`;
                } else if (status === "expired") {
                    CURR_STRIPESTATUS = false;
                    CURR_ENTERPRISEMODE_IS_ACTIVE = true;
                    CURR_ENTERPRISEMODE_STATUS = `Team: ${team} | Seat expired (${expirationDate})`;
                } else {
                    CURR_STRIPESTATUS = false;
                    CURR_ENTERPRISEMODE_IS_ACTIVE = false;
                    CURR_ENTERPRISEMODE_STATUS = "";
                }
                return callback();
            }).catch((error) => {
                console.error("Error checking enterprise membership:", error);
                if (error.response && error.response.status === 401) {
                    console.error('Authentication failed for enterprise check');
                }
                CURR_STRIPESTATUS = false;
                CURR_ENTERPRISEMODE_IS_ACTIVE = false;
                CURR_ENTERPRISEMODE_STATUS = "";
                return callback();
            });
        }).catch(tokenError => {
            console.error('Failed to get Firebase token:', tokenError);
            CURR_STRIPESTATUS = false;
            CURR_ENTERPRISEMODE_IS_ACTIVE = false;
            return callback();
        });
    }

    function startTour(){
        const tour = new Shepherd.Tour({
            useModalOverlay: false,
            defaultStepOptions: {
                classes: 'bg-black text-white rounded-lg',
                cancelIcon: {
                    enabled: true
                },
                scrollTo: { behavior: 'smooth', block: 'center' }
            },
        });

        //
        tour.addStep({
            id: 'step-1',
            title: "Start with your learning inspiration",
            text: 'Share a topic that inspired you, paste a link to a podcast or article, add your clinical notes, or describe your observations in this text box.',
            attachTo: {
                element: '#liminal-spark-form',
                on: 'bottom'
            },
            buttons: [
                {
                text: 'Next',
                action: tour.next
                }
            ]
        });

        tour.addStep({
            id: 'step-2',
            title: "Need Ideas?",
            text: 'Not sure where to start? Click here for a helpful list of examples you can reflect on.',
            attachTo: {
                element: '#liminalHelpBtn',
                on: 'right'
            },
            buttons:[
                {
                    text: 'Back',
                    action: tour.back
                },
                {
                    text: 'Next',
                    action: tour.next
                }
            ]
        });

        tour.addStep({
            id: 'step-3',
            title: "Start Reflecting",
            text: 'Ready to start reflecting? Hit the arrow, and Learner+ will highlight key insights, clean up PHI/brand names, and guide your reflection — whether you want to continue now or save it for later.',
            attachTo: {
                element: '#start-button',
                on: 'left'
            },
            buttons:[
                {
                    text: 'Back',
                    action: tour.back
                },
                {
                    text: 'Next',
                    action: tour.next
                }
            ]
        })

        tour.addStep({
            id: 'step-4',
            title: "Track Credits & Profile",
            text: 'Looking for your credits and certificates? Use the menu to review your credits, update your profile and subscription information.',
            attachTo: {
                element: '#creditCheckBtn',
                on: 'top'
            },
            buttons:[
                {
                    text: 'Back',
                    action: tour.back
                },
                {
                    text: 'Next',
                    action: tour.next
                }
            ]
        })

        tour.addStep({
            id: 'step-5',
            title: "Your Nudges & Drafts",
            text: 'Find your recommended nudges, saved topics, and drafts here.',
            attachTo: {
                element: '#dsib-button',
                on: 'left'
            },
            buttons:[
                {
                    text: 'Back',
                    action: tour.back
                }
                
            ]
        })


        try { MP.track('Tour Started', {}); } catch(e){}
        tour.start();
    }
    
    // Helper function to determine reflection kit from credential
    function getReflectionkitFromCredential(credential) {
        if (!credential || credential === 'not-selected') {
            return 'reflective-practice';
        }
        const REFLECTIVE_THINKING_CREDENTIALS = [
            'Lifelong-Learner',
            'Student',
            'Fellow',
            'Resident'
        ];
        if (REFLECTIVE_THINKING_CREDENTIALS.includes(credential)) {
            return 'reflective-thinking';
        }
        return 'reflective-practice';
    }

    function InitiateMainApp() {
        // REDIRECT CHECK: Reflective-thinking users should use my-reflective-insights
        const userKit = CURR_USERPROFILE.reflectionkits?.[0] ||
                        getReflectionkitFromCredential(CURR_USERPROFILE.credential);
        if (userKit === 'reflective-thinking') {
            console.log('Redirecting reflective-thinking user from index to my-reflective-insights');
            window.location.href = '/my-reflective-insights';
            return; // Stop initialization since we're redirecting
        }

        document.getElementById('mainApp').classList.remove('hiddenOff');
        hideLoadingOverlay();

        // Handle Stripe subscription success parameter (ported from learnerplus-profile.js)
        if (CURR_QueryParams_Obj.subscription === "success") {
            console.log("subscription=success detected, triggering Rewardful conversion");
            try {
                if (typeof rewardful !== 'undefined') {
                    rewardful('ready', function() {
                        if(Rewardful.referral) {
                            // The current website visitor is a referral from an affiliate.
                            rewardful('convert', { email: CURR_USERPROFILE.email });
                        }
                    });
                }
            } catch(ex) {
                console.error("Error with Rewardful conversion:", ex);
            }
        }
        
        setProfileUI();
        updateNotificationBadge(); // Initialize notification badge
        
        //
        console.log("Stripe Status", {CURR_STRIPESTATUS});
        //
        // Initialize reflective insights system (secure internal access)
        reflectiveInsights.initialize(CURR_USER, CURR_USERPROFILE, CURR_REFLECTIONKIT, CURR_LEARNERSTATE);
        
        // Check for coaching intro modal
        if (CURR_QueryParams_Obj['coaching-intro'] === 'true') {
            // Show coaching intro modal after a short delay to ensure UI is ready
            setTimeout(() => {
                showCoachingIntroModal();
            }, 500);
        }
        
        // Check for navigate_to_subscribe parameter
        if (CURR_QueryParams_Obj.navigate_to_subscribe){
            performTask('smart-manage-subscription');
        }
        
        // Initialize user-focused features and wait for data loading to complete
        Promise.all([
            // Fetch ALL reflections for DSIB streak calculations
            fetchAllReflections(),
            // Fetch credit balance data (unclaimed reflections)
            updateCreditDisplay(),
            // Fetch smart nudges data  
            initSmartNudges()
        ]).then((results) => {
            // Store all reflections in CURR_LEARNERSTATE for DSIB
            const allReflections = results[0];
            CURR_LEARNERSTATE.allReflections = allReflections;
            // Start the tour if there are less than 2 reflections
            // TODO: Push on startTour() if user has never seen the app;
            // Initialize DSIB system after all user data is fully loaded
            console.log("All data loaded, updating DSIB with complete reflection data:");
            console.log("- Total reflections:", allReflections.length);
            console.log("- Credit data:", results[1]);
            console.log("- Nudges data:", results[2]);
            
            // Update DSIB badge with fresh data
            updateDSIBBadgeCount();
            console.log("DSIB badge updated with fresh data");
        }).catch((error) => {
            console.error("Data loading failed:", error);
        });
        
        console.log("Learner+ Go App Initiated | JSKJM");
    }

    function setLearnerPlusGoStatus(){
        console.log("Setting Learner+ Go Elements");
    }
    
    // Fetch ALL reflections for DSIB streak calculations
    function fetchAllReflections() {
        return new Promise((resolve, reject) => {
            firebase.firestore().collection('reflections').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT).get()
                .then((docSnapshot) => {
                    const allReflections = [];
                    docSnapshot.docs.forEach((doc) => {
                        const reflection = doc.data();
                        reflection.id = doc.id;
                        allReflections.push(reflection);
                    });
                    
                    // Sort by reflectedOn timestamp (most recent first)
                    allReflections.sort((a, b) => (b.reflectedOn || 0) - (a.reflectedOn || 0));
                    
                    console.log(`Fetched ${allReflections.length} total reflections for DSIB`);
                    resolve(allReflections);
                })
                .catch((error) => {
                    console.error('Error fetching all reflections:', error);
                    reject(error);
                });
        });
    }

    function updateCreditDisplay() {
        return new Promise((resolve, reject) => {
            fetchReflectionsAndCreditBalance((creditBalance) => {
                const creditElements = document.querySelectorAll('[data-credit-display]');
                const creditButton = document.getElementById('creditCheckBtn');
                
                if (creditBalance.error) {
                    console.error('Error fetching credit balance:', creditBalance.error);
                    reject(creditBalance.error);
                    return;
                }
                
                const unclaimedCredits = creditBalance.totalUnclaimedCredts || 0;
                const totalCredits = creditBalance.totalCredits || 0;

            // Update all elements with data-credit-display attribute
            creditElements.forEach(element => {
                if (unclaimedCredits === 0) {
                    // Show "View Certificates" if they have historic credits, otherwise "0 Credits"
                    element.innerHTML = totalCredits > 0 ? 'View Certificates' : '0 Credits';
                } else if (unclaimedCredits === 1) {
                    element.innerHTML = '1 Credit';
                } else {
                    element.innerHTML = `${unclaimedCredits} Credits`;
                }
            });

            // Hide/show the credit button based on credit count
            // Show button if user has unclaimed credits OR historic credits
            if (creditButton) {
                if (unclaimedCredits === 0 && totalCredits === 0) {
                    creditButton.classList.add('hidden');
                    creditButton.classList.remove('inline-flex');
                } else {
                    creditButton.classList.remove('hidden');
                    creditButton.classList.add('inline-flex');
                }
            }
            
            // Update CURR_LEARNERSTATE for consistency
            CURR_LEARNERSTATE.creditBalance = unclaimedCredits;
            
            console.log('Credit display updated:', unclaimedCredits, 'unclaimed credits');
            resolve(creditBalance);
            });
        });
    }
    
    // Update personal greeting based on user profile
    function updatePersonalGreeting() {
        const greetingElement = document.getElementById('personal-greeting');
        if (!greetingElement) return;
        
        if (CURR_USERPROFILE && CURR_USERPROFILE.firstname) {
            greetingElement.textContent = `Welcome back, ${CURR_USERPROFILE.firstname}`;
        } else {
            greetingElement.textContent = 'Hi there';
        }
        
        // Show the greeting
        greetingElement.classList.remove('hidden');
    }

    function setProfileUI() {
        // Set user info if elements exist
        if (CURR_USERPROFILE) {
            var userElements = document.querySelectorAll('[data-user-info]');
            userElements.forEach(el => {
                var infoType = el.getAttribute('data-user-info');
                if (infoType === 'email') el.textContent = CURR_USERPROFILE.email;
                if (infoType === 'name') el.textContent = CURR_USERPROFILE.firstname + ' ' + CURR_USERPROFILE.lastname;
            });
        }
        
        // Update personal greeting
        updatePersonalGreeting();
    }
    
    function UI_BindActions(){
        // Show the overlay when a request starts
        axios.interceptors.request.use(function (config) {
            showLoadingOverlay();
            return config;
        }, function (error) {
            return Promise.reject(error);
        });

        // Hide the overlay when a response is received
        axios.interceptors.response.use(function (response) {
            hideLoadingOverlay();
            return response;
        }, function (error) {
            hideLoadingOverlay();
            return Promise.reject(error);
        });

        // Bind ui-action-btn click handlers
        document.getElementById('learnerplus').addEventListener('click', function(event) {
            // Check if the clicked element or its parent has the class 'ui-action-btn'
            var actionButton = event.target.closest('.ui-action-btn');
            if (actionButton) {
              // Ignore disabled buttons to prevent double actions
              if (actionButton.hasAttribute('disabled') || actionButton.classList.contains('disabled') || actionButton.classList.contains('pointer-events-none')) {
                return;
              }
              event.preventDefault();
              // Track the last clicked action button for contextual cleanup
              window.LAST_UI_ACTION_BUTTON = actionButton;
              var uiTask = actionButton.getAttribute('data-task');
              console.log('UI action button clicked:', uiTask, 'element:', actionButton);
              //
              if (!uiTask) {
                console.warn('ui-action-btn clicked but no data-task attribute found');
                return;
              }
              // Generic UI action tracking
              try {
                MP.track('UI Action Clicked', {
                    ui_task: uiTask,
                    element_id: actionButton.id || '',
                    element_classes: actionButton.className || '',
                    element_text: (actionButton.innerText || '').trim().slice(0, 80)
                });
              } catch(e) {}
              //
              performTask(uiTask);
            }
        });

        document.getElementById('appnotifier-close-btn').addEventListener('click', function(event) {
            performTask('appnotifier-dismiss');
        });
        
        console.log("UI Actions Bound");
    }
    
    function showLoadingOverlay(message) {
        var overlay = document.getElementById('axios_loading_overlay');
        var messageEl = document.getElementById('axios_loading_message');
        if (overlay) {
            overlay.classList.remove('hidden');
            if (messageEl && message) {
                messageEl.textContent = message;
            }
        } else {
            console.warn("Axios loading overlay element not found");
        }
        console.log("Loading:", message);
    }
    
    function hideLoadingOverlay() {
        var overlay = document.getElementById('axios_loading_overlay');
        if (overlay) {
            overlay.classList.add('hidden');
        } else {
            console.warn("Axios loading overlay element not found");
        }
        console.log("Loading complete");
    }
    
    function showProgressBar() {
        var progressBar = document.getElementById('axios-progress-bar');
        if (progressBar) {
            progressBar.classList.add('active');
        }
        console.log("Background axios activity started");
    }
    
    function hideProgressBar() {
        var progressBar = document.getElementById('axios-progress-bar');
        if (progressBar) {
            progressBar.classList.remove('active');
        }
        console.log("Background axios activity completed");
    }
    
    function showNotification(title, message, type, duration) {
        console.log(`[${type}] ${title}: ${message}`);
        
        var notifier = document.getElementById('appnotifier');
        var titleEl = document.getElementById('appnotifier-title');
        var contentEl = document.getElementById('appnotifier-content');
        var notificationContainer = notifier?.querySelector('.overflow-hidden.rounded-lg');
        var iconEl = notifier?.querySelector('.fa-bell');
        
        if (!notifier || !titleEl || !contentEl || !notificationContainer) {
            console.warn("Notification elements not found, falling back to console");
            return;
        }
        
        titleEl.textContent = title;
        contentEl.innerHTML = message;
        
        // Remove existing type classes from container
        notificationContainer.classList.remove(
            'bg-white', 'bg-green-50', 'bg-red-50', 'bg-yellow-50', 'bg-blue-50',
            'ring-black', 'ring-green-400', 'ring-red-400', 'ring-yellow-400', 'ring-blue-400',
            'border-l-4', 'border-green-400', 'border-red-400', 'border-yellow-400', 'border-blue-400'
        );
        
        // Apply type-specific styling
        switch (type) {
            case 'success':
                notificationContainer.classList.add('bg-green-50', 'ring-green-400', 'border-l-4', 'border-green-400');
                if (iconEl) {
                    iconEl.className = 'fa-solid fa-check-circle text-green-500';
                }
                break;
            case 'error':
                notificationContainer.classList.add('bg-red-50', 'ring-red-400', 'border-l-4', 'border-red-400');
                if (iconEl) {
                    iconEl.className = 'fa-solid fa-exclamation-circle text-red-500';
                }
                break;
            case 'warning':
                notificationContainer.classList.add('bg-yellow-50', 'ring-yellow-400', 'border-l-4', 'border-yellow-400');
                if (iconEl) {
                    iconEl.className = 'fa-solid fa-exclamation-triangle text-yellow-500';
                }
                break;
            case 'info':
                notificationContainer.classList.add('bg-blue-50', 'ring-blue-400', 'border-l-4', 'border-blue-400');
                if (iconEl) {
                    iconEl.className = 'fa-solid fa-info-circle text-blue-500';
                }
                break;
            default:
                notificationContainer.classList.add('bg-white', 'ring-black');
                if (iconEl) {
                    iconEl.className = 'fa-solid fa-bell text-learner-teal';
                }
        }
        
        notifier.classList.remove('hidden', 'opacity-0', 'scale-95');
        notifier.classList.add('opacity-100', 'scale-100');
        
        if (duration && duration > 0) {
            setTimeout(function(){
                performTask('appnotifier-dismiss');
            }, duration);
        }
    }

    function showReflectiveThinkingSavedCelebration(thinqbits) {
        // This will now be handled in the results display instead of a toast
        console.log("Reflective thinking celebration will be shown in results", thinqbits);
    }

    function showValidationModal(title, content, actionText, actionCallback, cancelText, cancelCallback) {
        var modal = document.getElementById('validationmodal');
        var titleEl = document.getElementById('validationmodal-title');
        var contentEl = document.getElementById('validationmodal-content');
        var actionBtn = document.getElementById('validationmodal-actionbtn');
        var actionTextEl = document.getElementById('validationmodal-action');
        var cancelBtn = document.getElementById('validationmodal-cancelbtn');
        
        if (!modal || !titleEl || !contentEl || !actionBtn || !cancelBtn) {
            console.warn("Validation modal elements not found");
            return;
        }
        
        titleEl.textContent = title;
        contentEl.innerHTML = content;
        
        if (actionText && actionCallback) {
            actionTextEl.textContent = actionText;
            actionBtn.style.display = 'inline-flex';
            actionBtn.onclick = actionCallback;
        } else {
            actionBtn.style.display = 'none';
        }
        
        if (cancelText) {
            cancelBtn.textContent = cancelText;
            cancelBtn.style.display = 'inline-flex';
            if (cancelCallback) {
                cancelBtn.onclick = cancelCallback;
            } else {
                cancelBtn.onclick = () => {
                    performTask('validationmodal-dismiss');
                };
            }
        } else {
            cancelBtn.onclick = () => {
                performTask('validationmodal-dismiss');
            };
        }
        
        modal.classList.remove('hidden');
    }

    function showCoachingIntroModal() {
        var modal = document.getElementById('coaching-intro-modal');
        
        if (!modal) {
            console.warn("Coaching intro modal element not found");
            return;
        }
        
        console.log("Showing coaching intro modal");
        modal.classList.remove('hidden');
        
        // Track the modal view
        mixpanel.track('Coaching Intro Modal Viewed', {
            source: 'url_parameter',
            timestamp: new Date().toISOString()
        });
    }

    function closeCoachingIntroModal() {
        console.log("Closing coaching intro modal");
        var modal = document.getElementById('coaching-intro-modal');
        if (modal) {
            modal.classList.add('hidden');
            // Track the modal close
            mixpanel.track('Coaching Intro Modal Closed', {
                timestamp: new Date().toISOString()
            });
        } else {
            console.error("Coaching intro modal element not found");
        }
    }

    // Notification System
    var APP_NOTIFICATIONS = [
        {
            id: 1,
            title: "Welcome to Learner+ Go",
            message: "Start capturing clinical sparks and earn credits instantly.",
            type: "info",
            timestamp: new Date().toISOString(),
            read: false
        },
        {
            id: 2,
            title: "New Feature: Reflective Insights",
            message: "Discover patterns in your learning journey with AI-powered insights.",
            type: "feature",
            timestamp: new Date(Date.now() - 86400000).toISOString(), // 1 day ago
            read: false
        },
        {
            id: 3,
            title: "Credit Reminder",
            message: "You have unclaimed credits. Generate your certificate to claim them.",
            type: "reminder",
            timestamp: new Date(Date.now() - 172800000).toISOString(), // 2 days ago
            read: true
        }
    ];

    function updateNotificationBadge() {
        var badge = document.getElementById('notification-badge');
        var unreadCount = APP_NOTIFICATIONS.filter(n => !n.read).length;
        
        if (badge) {
            if (unreadCount > 0) {
                badge.textContent = unreadCount;
                badge.classList.remove('hidden');
            } else {
                badge.classList.add('hidden');
            }
        }
    }

    function showNotificationsModal() {
        var notificationsHtml = '';
        
        if (APP_NOTIFICATIONS.length === 0) {
            notificationsHtml = '<p class="text-gray-500 text-center py-4">No notifications yet</p>';
        } else {
            notificationsHtml = '<div class="space-y-3 max-h-96 overflow-y-auto">';
            APP_NOTIFICATIONS.forEach(notification => {
                var iconClass = notification.type === 'info' ? 'fa-info-circle text-blue-500' : 
                               notification.type === 'feature' ? 'fa-sparkles text-purple-500' : 
                               notification.type === 'reminder' ? 'fa-clock text-orange-500' : 'fa-bell text-gray-500';
                var bgClass = notification.read ? 'bg-gray-50' : 'bg-blue-50';
                var date = new Date(notification.timestamp).toLocaleDateString();
                
                notificationsHtml += `
                    <div class="${bgClass} p-3 rounded-lg border ${notification.read ? 'border-gray-200' : 'border-blue-200'}">
                        <div class="flex items-start space-x-3">
                            <i class="fa-solid ${iconClass} mt-1"></i>
                            <div class="flex-1">
                                <h4 class="font-semibold text-gray-900">${notification.title}</h4>
                                <p class="text-sm text-gray-600 mt-1">${notification.message}</p>
                                <p class="text-xs text-gray-400 mt-2">${date}</p>
                            </div>
                        </div>
                    </div>
                `;
            });
            notificationsHtml += '</div>';
        }
        
        showValidationModal(
            "Notifications", 
            notificationsHtml, 
            "Mark All Read", 
            () => {
                APP_NOTIFICATIONS.forEach(n => n.read = true);
                updateNotificationBadge();
                performTask('validationmodal-dismiss');
                showNotification("Notifications", "All notifications marked as read", "success", 2000);
            }, 
            "Close", 
            null
        );
    }

    function performTask(uiTask) {
        console.log("performTask called with:", uiTask);
        
        // Handle common modal dismissals
        if (uiTask === 'validationmodal-dismiss') {
            var modal = document.getElementById('validationmodal');
            if (modal) {
                modal.classList.add('hidden');
            }
            return;
        }
        
        if (uiTask === 'appnotifier-dismiss') {
            var notifier = document.getElementById('appnotifier');
            if (notifier) {
                notifier.classList.remove('opacity-100', 'scale-100');
                notifier.classList.add('opacity-0', 'scale-95', 'hidden');
            }
            return;
        }

        // Extract base task name (before any colon separators)
        var baseTask = uiTask.split(':')[0];
        
        // Handle specific tasks
        switch (baseTask) {
            case "quickpick":
                console.log('🎯 performTask: quickpick case triggered with button:', window.LAST_UI_ACTION_BUTTON);
                handleQuickPick(window.LAST_UI_ACTION_BUTTON);
                break;
            case "analyze-spark":
                AnalyzeSpark();
                break;
            case "test-notification":
                showNotification("Test", "This is a test notification", "info", 3000);
                break;
            case "test-modal":
                showValidationModal("Test Modal", "This is a test modal", "OK", () => {
                    performTask('validationmodal-dismiss');
                }, "Cancel", null);
                break;
            case "reflective-insights":
                // This is handled by reflectivityMeter.onMeterClick() now
                break;
            case "close-transcript-modal":
                closeTranscriptModal();
                break;
            case "show-notifications":
                showNotificationsModal();
                break;
            case "show-alerts-feed":
                toggleAlertsFeed();
                break;
            case "reflect-now":
                if (uiTask === "reflect-now") {
                    trackEvent('learnerplus_reflection_initiated', {
                        source: 'general_button',
                        user_profile: CURR_USERPROFILE,
                        subscription_status: CURR_STRIPESTATUS
                    });
                    handleReflectNow();
                } else if (uiTask.startsWith('reflect-now::')) {
                    const parts = uiTask.replace('reflect-now::', '').split('::');
                    const keyword = parts[0];
                    const index = parts[1] ? parseInt(parts[1]) : 0;
                    trackEvent('learnerplus_reflection_initiated', {
                        source: 'nudge_panel',
                        keyword: keyword,
                        nudge_index: index,
                        user_profile: CURR_USERPROFILE,
                        subscription_status: CURR_STRIPESTATUS
                    });
                    handleReflectOnKeyword(keyword, index);
                }
                break;
            case "save-reflective-insight":
                handleSaveReflectiveInsight();
                break;
            case "discover-more-credits":
                handleDiscoverMoreCredits();
                break;
            case "launch-agent-ui":
                handleLaunchAgentUI();
                break;
            case "launch-url-agent":
                handleLaunchUrlAgent();
                break;
            case "capture-quick-insight":
                handleCaptureQuickInsight();
                break;
            case "save-draft":
                handleContinueReflectingLater();
                break;
            case "clear-liminal-spark":
                clearLiminalSpark();
                break;
            case "show-help-modal":
                showHelpModal();
                break;
            case "close-help-modal":
                closeHelpModal();
                break;
            case "close-coaching-intro-modal":
                closeCoachingIntroModal();
                break;
            case "show-guide":
                handleShowGuide();
                break;
            case "request-help":
                handleRequestHelp();
                break;
            case "close-liminal-modal":
                hideLiminalModal();
                break;
            case "close-command-palette":
                console.log("=== CLOSE COMMAND PALETTE TASK CALLED ===");
                console.trace("Call stack for close command palette");
                closeCommandPalette();
                break;
            case "smart-manage-subscription":
                if (CURR_STRIPEPACKET.subscription_status === 'active'){
                    performTask('manage-subscription');
                }else{
                    performTask('start-subscription');
                }
                break;
            case "start-subscription":
                // check if the subscription is active, otherwise take them to the subscription page
                window.location.href = '/create-checkout-session?email='+CURR_USERPROFILE.email+'&uid='+CURR_USER.uid+'&primarylocation='+encodeURIComponent(CURR_USERPROFILE.primarylocation);
                break;
            case "manage-subscription":
                window.location.href = '/manage-subscription?customer='+CURR_STRIPEPACKET.customer + "&subscription="+CURR_STRIPEPACKET.subscription + "&uid="+CURR_USER.uid;
                break;
            case "palette-generate-certificate":
                handlePaletteGenerateCertificate();
                break;
            case "palette-export-portfolio":
                handlePaletteExportPortfolio();
                break;
            case "palette-learning-patterns":
                handlePaletteAnalyzePatterns();
                break;
            case "palette-ask-what-patterns":
                handlePaletteAskPatterns();
                break;
            case "palette-ask-knowledge-gaps":
                handlePaletteAskGaps();
                break;
            case "palette-ask-growth-areas":
                handlePaletteAskGrowth();
                break;
            case "palette-ask-connections":
                handlePaletteAskConnections();
                break;
            case "palette-create-summary":
                handlePaletteCreateSummary();
                break;
            case "palette-create-action-plan":
                handlePaletteCreatePlan();
                break;
            case "palette-create-presentation":
                handlePaletteCreateCaseStudy();
                break;
            case "toggle-credit-drawer":
                toggleCreditDrawer();
                break;
            case "generate-certificate":
                if (uiTask.indexOf("generate-certificate::") === 0) {
                    // Download existing certificate
                    var certificateId = uiTask.split("generate-certificate::")[1];
                    console.log('Download existing certificate for ID:', certificateId);
                    trackEvent('learnerplus_certificate_download_initiated', {
                        certificate_id: certificateId,
                        user_profile: CURR_USERPROFILE,
                        subscription_status: CURR_STRIPESTATUS
                    });
                    return GenerateAndDownloadCertificate(certificateId);
                } else {
                    // Generate new certificate
                    console.log('Generate new certificate action triggered');
                    trackEvent('learnerplus_certificate_generation_started', {
                        user_profile: CURR_USERPROFILE,
                        subscription_status: CURR_STRIPESTATUS,
                        source: 'dashboard_button'
                    });
                    LaunchPrecertEvaluationFlow();
                }
                break;
            case "download-certificate":
                var certificateId = uiTask.split(':')[1];
                console.log('Download certificate action triggered for ID:', certificateId);
                if (certificateId) {
                    GenerateAndDownloadCertificate(certificateId);
                } else {
                    console.error('No certificate ID provided for download');
                }
                break;
            case "view-transcript":
                var certificateId = uiTask.split(':')[1];
                console.log('View transcript action triggered for ID:', certificateId);
                if (certificateId) {
                    LaunchLearnerPlusTranscript(certificateId);
                } else {
                    console.error('No certificate ID provided for transcript');
                }
                break;
            case "launch-transcript":
                // Handle original format
                if (uiTask.indexOf("launch-transcript::") === 0) {
                    var certificateId = uiTask.split("launch-transcript::")[1];
                    console.log('Launch transcript (original format) for ID:', certificateId);
                    return LaunchLearnerPlusTranscript(certificateId);
                }
                break;
            case "share-narrative":
                // Handle narrative sharing with stakeholder type
                if (uiTask.indexOf("share-narrative::") === 0) {
                    var stakeholderType = uiTask.split("share-narrative::")[1];
                    console.log('Share narrative action triggered for stakeholder:', stakeholderType);
                    handleShareNarrative(stakeholderType);
                } else {
                    console.error('Invalid share-narrative task format');
                }
                break;
            case "generate-context-summary":
                console.log('Generate context summary action triggered');
                handleContextSummary();
                break;
            case "view-more-certificates":
                console.log('View more certificates action triggered');
                window.location.href = '/hub?profilemode=true';
                break;
            case "toggle-alerts-feed":
                toggleAlertsFeed();
                break;
            case "hide-liminal-modal":
                hideLiminalModal();
                break;
            case "move-to-liminal-final-step":
                moveToLiminalFinalStep();
                break;
            case "launch-calendar":
                showValidationModal('Invite Learner+', `Invite <b class="text-learner-blue font-bold underline">reflect@learner.plus</b> to your meetings and automatically get reminded to reflect!`, 'Copy to Clipboard', ()=>{
                    navigator.clipboard.writeText('reflect@learner.plus').then(() => {
                        showNotification("Learner+ Contact copied", "The email address has been copied to your clipboard - save them to your contacts and/or invite them to your meetings!", "success", 3600);
                        performTask('validationmodal-dismiss');
                    }).catch(err => {
                        console.error('Could not copy text: ', err);
                        performTask('validationmodal-dismiss');
                    });
                }, 'Done', null);
                break;
            case "launch-whatsapp":
                var whatsAppLink = 'https://wa.me/message/NKTISGGV6UB7B1';
                var whatsAppQR = LearnerPlusWhatsAppQRCode;
                if (CURR_USERPROFILE.credential === "General Practitioner Trainee"){
                    whatsAppLink = 'https://wa.me/message/W3EOZ5ATX6LFO1';
                    whatsAppQR = LearnerPlusWhatsAppQRCode_GPTrainees;
                }
                showValidationModal('Reflect via WhatsApp', `On the go? At a conference? Using in-flight wifi? Chat with Learner+ on WhatsApp to jot notes, capture ideas and ask questions. Learner+ uses your notes to prompt reflections so you can earn credits instantly. <br/><br/>Scan the QR below to start a conversation or click Launch WhatsApp to get started!<br/><br/><div class="flex items-center justify-center"><img src="${whatsAppQR}" class="rounded-md shadow-lg hover:border hover:border-blue-500 hover:border-4" style="width:144px; height:144px;"></div>`, 
                    'Launch WhatsApp', ()=>{
                    window.open(whatsAppLink, '_blank');
                    performTask('validationmodal-dismiss');
                }, 'Done', null);
                break;
            case "text-me":
                // ✅ SECURED: Get Firebase token and send with authentication
                (async () => {
                    try {
                        const idToken = await firebase.auth().currentUser.getIdToken();
                        const response = await axios.get('/tasks/text-me', {
                            params: {
                                uid: CURR_USER.uid,
                                message: '👋 Hi, this is Learner+! You can text this number to spark a reflection anytime :). Just say "Hi"'
                            },
                            headers: {
                                'Authorization': `Bearer ${idToken}`
                            }
                        });

                        if (response.data.status === 'success') {
                            showAppNotifier('SMS Sent', `Text message sent successfully! You have ${response.data.rate_limit.remaining} SMS remaining this hour.`, 'success');
                        }
                    } catch (error) {
                        console.error('Text-me error:', error);
                        if (error.response?.status === 429) {
                            showAppNotifier('Rate Limit', 'Too many SMS requests. Please try again later.', 'error');
                        } else if (error.response?.status === 401) {
                            showAppNotifier('Authentication Error', 'Please sign in again.', 'error');
                        } else {
                            showAppNotifier('Error', 'Failed to send SMS. Please try again.', 'error');
                        }
                    }
                })();
                break;
            case "start-subscription":
                // Redirect to subscription checkout page
                window.location.href = '/create-checkout-session?email='+CURR_USERPROFILE.email+'&uid='+CURR_USER.uid+'&primarylocation='+encodeURIComponent(CURR_USERPROFILE.primarylocation);
                break;

            // CPD Portfolio Task Handlers
            case "generate-gmc-narrative":
                generateCPDOutput('gmc-narrative');
                break;
            case "generate-cpd-log":
                generateCPDOutput('cpd-log');
                break;
            case "generate-pdp-objectives":
                generateCPDOutput('pdp-objectives');
                break;
            case "generate-appraisal-summary":
                generateCPDOutput('appraisal-summary');
                break;
            case "generate-capability-map":
                generateCPDOutput('capability-map');
                break;
            case "generate-nmc-accounts":
                generateCPDOutput('nmc-accounts');
                break;
            case "generate-nmc-discussion":
                generateCPDOutput('nmc-discussion');
                break;
            case "generate-nmc-cpd-hours":
                generateCPDOutput('nmc-cpd-hours');
                break;
            case "generate-nmc-feedback-guide":
                generateCPDOutput('nmc-feedback-guide');
                break;

            default:
                // Check if it's an accordion toggle task
                if (uiTask.startsWith('toggle-accordion::')) {
                    const accordionId = uiTask.replace('toggle-accordion::', '');
                    toggleAccordion(accordionId);
                    break;
                }
                // Check if it's a smart nudge task
                if (uiTask.startsWith('smart-nudge::')) {
                    const nudgeId = uiTask.replace('smart-nudge::', '');
                    handleSmartNudgeClick(nudgeId);
                } else if (uiTask.startsWith('delete-nudge::')) {
                    const nudgeId = uiTask.replace('delete-nudge::', '');
                    console.log('🗑️ Delete nudge task triggered for:', nudgeId);
                    handleDeleteNudge(nudgeId);
                } else if (uiTask.startsWith('delete-smart-nudge::')) {
                    const nudgeId = uiTask.replace('delete-smart-nudge::', '');
                    console.log('🗑️ Delete smart nudge task triggered for:', nudgeId);
                    deleteSmartNudge(nudgeId, 'ui-action');
                } else if (uiTask.startsWith('delete-saved-item::')) {
                    const nudgeId = uiTask.replace('delete-saved-item::', '');
                    console.log('🗑️ Delete saved item task triggered for:', nudgeId);
                    deleteSavedItem(nudgeId);
                } else if (uiTask.startsWith('open-finalize-reflection::')) {
                    const url = uiTask.replace('open-finalize-reflection::', '');
                    handleOpenFinalizeReflection(url);
                } else if (uiTask.startsWith('snooze::')) {
                    const parts = uiTask.replace('snooze::', '').split('::');
                    const keyword = parts[0];
                    const duration = parts[1];
                    handleSnoozeKeyword(keyword, duration);
                } else {
                    console.log("Unknown task:", uiTask);
                    showNotification("Task Handler", `Task '${uiTask}' not implemented yet`, "info", 3000);
                }
                break;
        }
    }

    // QuickPick Handler with smooth typing animation
    function handleQuickPick(element) {
        console.log('🎯 handleQuickPick called with element:', element);

        if (!element) {
            console.warn('❌ handleQuickPick called without element');
            return;
        }

        const template = element.getAttribute('data-template');
        console.log(`✅ QuickPick template selected: "${template}"`);

        // Get the liminal spark textarea
        const liminalSpark = document.getElementById('liminal_spark');
        if (!liminalSpark) {
            console.warn('❌ Liminal spark textarea not found');
            return;
        }

        console.log('✅ Found liminal spark textarea, starting typing effect...');

        // Add selection visual feedback
        element.classList.add('scale-95', 'opacity-75');

        // Clear existing content and focus
        liminalSpark.value = '';
        liminalSpark.focus();

        // Smooth type-in effect
        setTimeout(() => {
            let i = 0;
            const typeInterval = setInterval(() => {
                liminalSpark.value += template[i];
                i++;

                if (i >= template.length) {
                    clearInterval(typeInterval);
                    // Focus at the end for easy editing
                    liminalSpark.setSelectionRange(template.length, template.length);
                    console.log('✅ Typing animation completed');
                }
            }, 20);

            // Reset visual feedback
            element.classList.remove('scale-95', 'opacity-75');
        }, 100);
    }

    function fetchReflectionsAndCreditBalance(callback){
        // Reset arrays to prevent accumulation on multiple calls
        CURR_LEARNERSTATE.reflections = [];
        CURR_LEARNERSTATE.reflection_ids = [];

        firebase.firestore().collection('reflections').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT).get() // Use the count aggregation query
            .then((docSnapshot) => {
                var totalUnclaimedCredts = 0;
                var totalCredits = 0;
                var reflectiveContexts = [];
                var reflectiveCategories = [];
                var reflectivePathways = [];
                docSnapshot.docs.forEach((doc)=>{
                    totalCredits += doc.data().credit;
                    reflectivePathways = reflectivePathways.concat(doc.data().validation_deeper.learning_pathways);
                    reflectiveContexts.push(doc.data().ipoc_context);
                    reflectiveCategories.push(doc.data().reflection_based_reflective_category || "General Reflection");
                    if (!doc.data().claimedOn){
                        totalUnclaimedCredts += doc.data().credit;
                        CURR_LEARNERSTATE.reflections.push(doc.data());
                        CURR_LEARNERSTATE.reflection_ids.push(doc.id);
                    }
                });
                //
                CURR_LEARNERSTATE.creditBalance = totalUnclaimedCredts;
                CURR_LEARNERSTATE.reflections = CURR_LEARNERSTATE.reflections.sort((a, b) => (a.reflectedOn > b.reflectedOn) ? -1 : 1);
                //
                reflectiveContexts = [...new Set(reflectiveContexts)];
                reflectiveCategories = [...new Set(reflectiveCategories)];
                //
                return callback({totalUnclaimedCredts, totalCredits, reflectiveContexts, reflectiveCategories, reflectivePathways});
            })
            .catch((error) => {
                console.error('Error getting document count: ', error);
                return callback({error});
            });
    }

    // fetches certificates
    function fetchCertificates(callback){
        firebase.firestore().collection('certificates').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT).get()
            .then((docSnapshot) => {
                CURR_LEARNERSTATE.certificates = [];
                docSnapshot.docs.forEach((doc)=>{
                    var cert = doc.data();
                    cert.certificateId = doc.id;
                    CURR_LEARNERSTATE.certificates.push(cert);
                });
                //
                CURR_LEARNERSTATE.certificates.sort((a,b)=>{
                    return b.claimedOn-a.claimedOn;
                })
                //
                return callback({certificates: CURR_LEARNERSTATE.certificates});
            })
            .catch((error) => {
              console.error('Error getting document count: ', error);
              return callback({error});
            });
    }

    // Certificate generation functions
    var tfPopup = null;
    async function GenerateAndDownloadCertificate(certificateId){
        console.log('Downloading certificate with ID:', certificateId);
        try {
            const doc = await firebase.firestore().collection('certificates').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT).doc(certificateId).get();
            if (doc.exists){
                console.log('Certificate data found:', doc.data());
                trackEvent('learnerplus_certificate_download', {
                    user_profile: CURR_USERPROFILE,
                    certificate_id: certificateId,
                    subscription_status: CURR_STRIPESTATUS
                });
                showNotification("Downloading certificate...", "Check your downloads folder or ensure that your browser is not blocking downloads","",7200)
                var creditGenPacket = {
                    learner_name: CURR_USERPROFILE.firstname + " " + CURR_USERPROFILE.lastname,
                    credits_claimed: doc.data().creditCount,
                    credits_claimedon: (new Date(doc.data().claimedOn)).getTime(),
                    credential: CURR_USERPROFILE.credential,
                    specialty: CURR_USERPROFILE.specialty||""
                }
                console.log('Certificate download packet:', creditGenPacket);
                //
                // Get Firebase ID token and download with authentication
                const idToken = await firebase.auth().currentUser.getIdToken();
                const url = `/generate-certificate?learner_name=${encodeURIComponent(creditGenPacket.learner_name)}&credits_claimed=${creditGenPacket.credits_claimed}&credits_claimedon=${creditGenPacket.credits_claimedon}&credential=${encodeURIComponent(creditGenPacket.credential)}&specialty=${encodeURIComponent(creditGenPacket.specialty)}`;
                console.log('Certificate download URL:', url);

                const response = await fetch(url, {
                    headers: {
                        'Authorization': `Bearer ${idToken}`
                    }
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('A');
                    a.href = downloadUrl;
                    a.download = `cert-refprac_${CURR_USERPROFILE.lastname}-${CURR_USERPROFILE.credential}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(downloadUrl);
                    // refresh credit display
                    updateCreditDisplay();
                    updateCreditDrawerContent();
                } else {
                    console.error('Certificate download failed:', response.status);
                    showNotification("Certificate download failed", "Authentication error", "error", 5400);
                }
            }else{
                console.error('Certificate not found for ID:', certificateId);
                showNotification("Certificate not found","","error",5400);
            }
        } catch(error) {
            console.error('Certificate fetch error:', error);
            showNotification("Certificate fetch error", error.message || error, "error",5400);
        }
    }

    function LaunchLearnerPlusTranscript(certificateId){
        console.log('Launching transcript for certificate ID:', certificateId);
        firebase.firestore().collection('certificates').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT).doc(certificateId).get().then((doc)=>{
            if (doc.exists){
                console.log('Certificate data for transcript:', doc.data());
                var certificateResponseId = doc.data().evaluation.response_id;
                console.log('Certificate response ID:', certificateResponseId);
                if (CURR_STRIPESTATUS){
                    console.log('User is subscribed, launching transcript');
                    window.location.href = `/report-reflectivelearningtranscript?cert_response_id=${certificateResponseId}`;
                }else{
                    console.log('User not subscribed, showing subscription notice');
                    showNotification('⚠️ Only available to subscribers ⚠️', 'Learner+ transcripts showcase your learning impacts and reflective credit-earning journey. Subscribe to unlock unlimited reflections → credits → certificates & transcripts for $50/yr only.', 'info', 7200);
                }
            }else{
                console.error('Certificate not found for transcript, ID:', certificateId);
                showNotification("Invalid certificate - transcript not found","","error",5400);
            }
        }).catch((error)=>{
            console.error('Certificate fetch error for transcript:', error);
            showNotification("Certificate fetch error", error.message || error, "error",5400);
        });
    }

    // Returns true if the learner has cert generation included:
    // active roster member, active Stripe subscriber, or email-only user (amplifi/SSO - no phone number)
    // Returns false for free/non-paying phone-based users
    function isLearnerCertIncluded(){
        var isActiveSubscriber = CURR_STRIPESTATUS === true; // covers both Stripe and active roster
        var isEmailOnly = !CURR_USER.phoneNumber; // amplifi, SSO, email-based logins
        var hasCertFlag = CURR_USERPROFILE.certIncluded === true; // manual override flag in Firestore
        var onFreeCertsRoster = CURR_FREECERTS === true; // admin-config-jskjm/free-certs emails array
        return isActiveSubscriber || isEmailOnly || hasCertFlag || onFreeCertsRoster;
    }

    async function LaunchPrecertEvaluation(callback){
        if (CURR_LEARNERSTATE.creditBalance < 1){
            showNotification('No credits to claim', 'You do not have enough credits to claim and generate a certificate!', 'error', 3600);
            return callback(false);
        }
        // check free-certs roster before building the packet
        try {
            var idToken = await firebase.auth().currentUser.getIdToken();
            var freeCertsResponse = await axios.post('/check-free-certs',
                { email: CURR_USERPROFILE.email },
                { headers: { 'Authorization': `Bearer ${idToken}` } }
            );
            CURR_FREECERTS = freeCertsResponse.data.freeCerts === true;
        } catch (freeCertsErr) {
            console.warn('Free-certs check failed:', freeCertsErr);
            CURR_FREECERTS = false;
        }
        //
        var hiddenPacket_Cert = {
            learner_uid: CURR_USER.uid,
            learner_email: CURR_USERPROFILE.email,
            learner_credential: CURR_USERPROFILE.credential || "Lifelong Learner",
            learner_credit_balance: CURR_LEARNERSTATE.creditBalance + ".0",
            learner_first: CURR_USERPROFILE.firstname || "Learner First Name",
            learner_last: CURR_USERPROFILE.lastname || "Learner Last Name",
            moc_dob_mmdd: "no-moc",
            moc_board: "no-moc",
            moc_boardid: "no-moc",
            moc_npi: "no-moc",
            pay_for_cert: isLearnerCertIncluded() ? "0" : "1"
        };
        // check if the user has MOC parameters and we can fill it out
        if (CURR_USERPROFILE.moc){
            if (CURR_USERPROFILE.moc.moc_npi){
                hiddenPacket_Cert.moc_npi = CURR_USERPROFILE.moc.moc_npi;
            }
            if (CURR_USERPROFILE.moc.moc_dob){
                hiddenPacket_Cert.moc_dob_mmdd = CURR_USERPROFILE.moc.moc_dob;
            }
            if (CURR_USERPROFILE.moc.moc_boards){
                for (var board in CURR_USERPROFILE.moc.moc_boards){
                    if (CURR_USERPROFILE.moc.moc_boards[board]){
                        hiddenPacket_Cert.moc_board = board;
                    }
                }
            }
            if (CURR_USERPROFILE.moc.moc_learnerid){
                hiddenPacket_Cert.moc_boardid = CURR_USERPROFILE.moc.moc_learnerid;
            }
        }
        //
        tfPopup = createPopup('HotrLCrF',{
            hidden: hiddenPacket_Cert,
            onSubmit: function(submitPayload){
                console.log('form submitted, download certificate', submitPayload);
                callback(submitPayload);
            },
            onClose: function(){
                console.log('form closed - certificate not downloaded');
                callback(false);
            }
        });
        tfPopup.open();
        mixpanel.track('Certificate Evaluation Started', {CURR_USERPROFILE});
    }

    async function ConvertCreditsToCertificate(tfCertPacket, callback){
        // we check if this user has MOC turned on and CEBroker, AND they are a paying subscriber; and we add it here
        if (CURR_USERPROFILE.moc && CURR_STRIPESTATUS === true){
            tfCertPacket.moc = CURR_USERPROFILE.moc;
        }
        if (CURR_USERPROFILE.cebroker && CURR_STRIPESTATUS === true){
            tfCertPacket.cebroker = CURR_USERPROFILE.cebroker;
        }

        // Get Firebase authentication token
        let idToken;
        try {
            idToken = await CURR_USER.getIdToken();
        } catch (error) {
            console.error('Error getting auth token:', error);
            return callback({error: 'Authentication failed'});
        }

        // finalize-claim
        var payloadForClaim = {
            uid: CURR_USER.uid,
            reflectionkit: CURR_REFLECTIONKIT,
            certEvalPacket: tfCertPacket,
            reflection_ids: CURR_LEARNERSTATE.reflection_ids
        };
        //
        fetch('/finalize-claim', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            },
            body: JSON.stringify(payloadForClaim),
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            return callback(data);
        })
        .catch((error) => {
            console.error('Error:', error);
            return callback({error});
        });
    }

    function LaunchPrecertEvaluationFlow(){
        console.log('Starting certificate generation flow...');
        
        // Disable the generate certificate button and show loading state
        const generateCertButton = document.querySelector('[data-task="generate-certificate"]');
        if (generateCertButton) {
            generateCertButton.disabled = true;
            generateCertButton.innerHTML = '<i class="fa-solid fa-spinner fa-spin mr-2"></i>Processing...';
            generateCertButton.classList.add('opacity-75', 'cursor-not-allowed');
        }
        
        LaunchPrecertEvaluation((submitPayload)=>{
            if (submitPayload){
                console.log('TypeForm submitted, processing certificate:', submitPayload);
                tfPopup.close();
                ConvertCreditsToCertificate(submitPayload, (claimStatusAndCertificateId)=>{
                    console.log('Certificate conversion result:', claimStatusAndCertificateId);
                    mixpanel.track('Certificate Evaluation Completed', {CURR_USERPROFILE, claimStatusAndCertificateId});
                    //
                    if (claimStatusAndCertificateId.status === "success"){
                        console.log('Certificate generated successfully, downloading...');
                        GenerateAndDownloadCertificate(claimStatusAndCertificateId.certificateId);
                        
                        // Immediately hide the generate certificate button to prevent multiple generations
                        const generateCertButton = document.querySelector('[data-task="generate-certificate"]');
                        if (generateCertButton) {
                            generateCertButton.style.display = 'none';
                        }
                        
                        // refresh credit display and drawer content
                        updateCreditDisplay();
                        updateCreditDrawerContent();
                        showNotification("Certificate generated!", "Your certificate is downloading and your credits have been claimed.", "success", 5000);
                    }else{
                        console.error('Certificate generation failed:', claimStatusAndCertificateId);
                        
                        // Restore button state on failure
                        const generateCertButton = document.querySelector('[data-task="generate-certificate"]');
                        if (generateCertButton) {
                            generateCertButton.disabled = false;
                            generateCertButton.innerHTML = 'Generate Certificate';
                            generateCertButton.classList.remove('opacity-75', 'cursor-not-allowed');
                        }
                        
                        showNotification("Error in certificate generation", claimStatusAndCertificateId.message || "Unknown error", "error", 3600);
                    }
                });
            } else {
                console.log('TypeForm closed without submission');
                
                // Restore button state if user cancels
                const generateCertButton = document.querySelector('[data-task="generate-certificate"]');
                if (generateCertButton) {
                    generateCertButton.disabled = false;
                    generateCertButton.innerHTML = 'Generate Certificate';
                    generateCertButton.classList.remove('opacity-75', 'cursor-not-allowed');
                }
            }
        });
    }
    
    // Smart Nudges Firebase Functions
    function fetchInboxNudges(callback) {
        if (!CURR_USER || !CURR_USER.uid) {
            console.error('No authenticated user for inbox nudges');
            return callback([]);
        }
        
        firebase.firestore()
            .collection('smartnudges')
            .doc(CURR_USER.uid)
            .collection('inbox')
            .orderBy('created_at', 'desc')
            .get()
            .then((querySnapshot) => {
                const inboxNudges = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    // Only filter out 'reflected' status nudges
                    if (data.status !== 'reflected') {
                        inboxNudges.push({
                            nudge_id: doc.id,
                            content: data.content || '',
                            source_name: data.source_name || 'System',
                            tracking_id: data.tracking_id || doc.id,
                            status: data.status || 'unread',
                            created_at: data.created_at,
                            metadata: data.metadata || {},
                            auto_ipoc: data.auto_ipoc || null, // Only valid strings trigger reflective practice
                            type: 'inbox',
                            is_inbox: true,
                            display_content: data.content || '',
                            badge_color: 'bg-blue-500'
                        });
                    }
                });
                console.log(`Fetched ${inboxNudges.length} inbox nudges`);
                return callback(inboxNudges);
            })
            .catch((error) => {
                console.error('Error fetching inbox nudges:', error);
                return callback([]);
            });
    }
    
    function fetchSnoozedNudges(callback) {
        if (!CURR_USER || !CURR_USER.uid) {
            console.error('No authenticated user for snoozed nudges');
            return callback([]);
        }
        
        const now = Date.now();
        
        firebase.firestore()
            .collection('smartnudges')
            .doc(CURR_USER.uid)
            .collection('snoozed')
            .orderBy('created_at', 'desc') // Get all snoozed items, newest first
            .get()
            .then((querySnapshot) => {
                const snoozedNudges = [];
                
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    
                    // Preserve the original type if it exists (e.g., 'gist_continuation')
                    const itemType = data.type || 'snoozed';
                    const isGistContinuation = itemType === 'gist_continuation';
                    
                    snoozedNudges.push({
                        nudge_id: doc.id,
                        content: data.content || '',
                        source_name: isGistContinuation ? 'Saved Draft' : 'Snoozed',
                        tracking_id: data.tracking_id || doc.id,
                        original_nudge_id: data.original_nudge_id,
                        created_at: data.created_at,
                        metadata: data.metadata || {},
                        auto_ipoc: data.auto_ipoc || "Reflective Learning Moment",
                        
                        // Preserve all continuation data
                        type: itemType,
                        original_spark: data.original_spark || '',
                        display_preview: data.display_preview || data.content || '',
                        clarity_context: data.clarity_context || {},
                        
                        is_snoozed: true,
                        display_content: data.display_preview || data.content || '',
                        badge_color: isGistContinuation ? 'bg-blue-500' : 'bg-amber-500',
                        status: 'snoozed'
                    });
                });
                
                // Store snoozed items globally for DSIB access
                window.CURRENT_SNOOZED_ITEMS = snoozedNudges;
                console.log(`Fetched ${snoozedNudges.length} ready snoozed nudges (fetch only - no deletions)`);
                console.log('Stored snoozed items globally:', snoozedNudges);
                return callback(snoozedNudges);
            })
            .catch((error) => {
                console.error('Error fetching snoozed nudges:', error);
                return callback([]);
            });
    }
    
    function saveSnoozeToFirebase(content, duration, originalNudgeId = null, trackingId = null, ipocContext = null, continuationData = null) {
        if (!CURR_USER || !CURR_USER.uid) {
            console.error('No authenticated user to save snoozed nudge');
            return Promise.reject(new Error('No authenticated user'));
        }
        
        // Parse duration to timestamp
        const now = Date.now();
        let snoozeUntil = now;
        
        if (duration.includes('hour')) {
            const hours = parseInt(duration) || 1;
            snoozeUntil = now + (hours * 60 * 60 * 1000);
        } else if (duration.includes('day')) {
            const days = parseInt(duration) || 1;
            snoozeUntil = now + (days * 24 * 60 * 60 * 1000);
        } else if (duration.includes('week')) {
            const weeks = parseInt(duration) || 1;
            snoozeUntil = now + (weeks * 7 * 24 * 60 * 60 * 1000);
        }
        
        const snoozeData = {
            content: content,
            snoozed_until: snoozeUntil,
            created_at: now,
            tracking_id: trackingId || `snooze_${now}`,
            original_nudge_id: originalNudgeId,
            auto_ipoc: ipocContext || "Reflective Learning Moment",
            metadata: {
                duration_requested: duration,
                snooze_source: 'learner_plus_go'
            }
        };
        
        // Add continuation data if provided (for gist continuation)
        if (continuationData) {
            snoozeData.type = continuationData.type;
            snoozeData.original_spark = continuationData.original_spark;
            snoozeData.display_preview = continuationData.display_preview;
            snoozeData.clarity_context = continuationData.clarity_context;
            snoozeData.metadata.is_continuation = true;
            console.log('Enhanced snooze data with continuation context');
        }
        
        return firebase.firestore()
            .collection('smartnudges')
            .doc(CURR_USER.uid)
            .collection('snoozed')
            .add(snoozeData)
            .then((docRef) => {
                console.log('Snoozed nudge saved to Firebase:', docRef.id);
                
                // Track in mixpanel if available
                if (typeof mixpanel !== 'undefined') {
                    mixpanel.track('Nudge Snoozed', {
                        nudge_id: docRef.id,
                        tracking_id: trackingId,
                        duration: duration,
                        content_preview: content.substring(0, 50)
                    });
                }
                
                return docRef;
            })
            .catch((error) => {
                console.error('Error saving snoozed nudge:', error);
                throw error; // Re-throw for proper error handling
            });
    }
    
    function updateNudgeStatus(nudgeId, newStatus, trackingId = null) {
        if (!CURR_USER || !CURR_USER.uid || !nudgeId) {
            console.error('Cannot update nudge status - missing required data');
            return;
        }
        
        firebase.firestore()
            .collection('smartnudges')
            .doc(CURR_USER.uid)
            .collection('inbox')
            .doc(nudgeId)
            .update({
                status: newStatus,
                last_updated: Date.now()
            })
            .then(() => {
                console.log(`Nudge ${nudgeId} status updated to: ${newStatus}`);
                // Track in mixpanel if available
                if (typeof mixpanel !== 'undefined' && trackingId) {
                    mixpanel.track('Nudge Status Updated', {
                        nudge_id: nudgeId,
                        tracking_id: trackingId,
                        new_status: newStatus
                    });
                }
            })
            .catch((error) => {
                console.error('Error updating nudge status:', error);
            });
    }
    
    // Function to get Firebase auth token
    async function getFirebaseToken() {
        try {
            if (CURR_USER) {
                const token = await CURR_USER.getIdToken();
                return token;
            } else {
                console.error("No authenticated user found");
                return null;
            }
        } catch (error) {
            console.error("Error getting Firebase token:", error);
            return null;
        }
    }

    // Function to save reflective thinking if eligible
    async function saveReflectiveThinkingIfEligible(originalText, clarityResults) {
        try {
            if (!clarityResults) return;
            
            const gist = clarityResults.gist || "";
            const thinqbits = clarityResults.thinqbits || [];
            
            // Check criteria: gist has at least 5 words and at least 1 thinqbit
            const gistWordCount = gist.trim().split(/\s+/).filter(word => word.length > 0).length;
            
            if (gistWordCount >= 5 && thinqbits.length >= 1) {
                const user = firebase.auth().currentUser;
                if (!user) {
                    console.error("No authenticated user for reflective thinking save");
                    return;
                }
                
                // Check for duplicate gist before saving
                const isDupe = await isDuplicateGist(clarityResults.gist, user.uid);
                if (isDupe) {
                    console.log('Skipping duplicate gist save from clarity engine');
                    return;
                }
                
                // Generate unique packet ID
                const timestamp = Date.now();
                const packetId = `${timestamp}_${btoa(encodeURIComponent(originalText + timestamp)).substring(0, 8).replace(/[+/=]/g, '')}`;
                
                // Prepare reflective thinking packet
                const reflectivePacket = {
                    packetId: packetId,
                    timestamp: new Date().toISOString(),
                    learner_uid: user.uid,
                    original_text: originalText,
                    gist: clarityResults.gist,
                    intent: clarityResults.intent,
                    cognitive_query: clarityResults.cognitive_query,
                    ipoc_keywords: clarityResults.ipoc_keywords,
                    ipoc_context: clarityResults.ipoc_context,
                    thinqbits: clarityResults.thinqbits,
                    reflective_gap: clarityResults.reflective_gap
                };
                
                // Save to Firestore: reflections/{uid}/reflective-thinking/{packetId}
                await firebase.firestore()
                    .collection('reflections')
                    .doc(user.uid)
                    .collection('reflective-thinking')
                    .doc(packetId)
                    .set(reflectivePacket);
                
                console.log(`Saved reflective thinking packet ${packetId} for user ${user.uid}`);
                console.log("Packet contents:", reflectivePacket);
                
                // Show celebration notification to user
                showReflectiveThinkingSavedCelebration(thinqbits);
                
                // Also show sparkles effect
                showReflectiveInsightSparkles();
                
            } else {
                console.log(`Reflective thinking not saved - gist: ${gistWordCount} words, thinqbits: ${thinqbits.length}`);
            }
            
        } catch (error) {
            console.error("Error saving reflective thinking packet:", error);
        }
    }

    // Function to check for duplicate gist text in recent reflective-thinking entries
    async function isDuplicateGist(gistText, uid) {
        try {
            if (!gistText || !uid) return false;
            
            const normalizedGist = gistText.toLowerCase().trim().replace(/[^\w\s]/g, '');
            const recentCutoff = new Date(Date.now() - 5 * 24 * 60 * 60 * 1000); // Last 5 days
            
            const recent = await firebase.firestore()
                .collection('reflections')
                .doc(uid)
                .collection('reflective-thinking')
                .where('timestamp', '>', recentCutoff.toISOString())
                .get();
            
            for (const doc of recent.docs) {
                const existingGist = doc.data().gist?.toLowerCase().trim().replace(/[^\w\s]/g, '');
                if (existingGist === normalizedGist) {
                    console.log('Duplicate gist detected:', { 
                        existing: doc.data().gist, 
                        new: gistText,
                        docId: doc.id 
                    });
                    return true; // Duplicate found
                }
            }
            return false;
        } catch (error) {
            console.error('Duplicate check failed:', error);
            return false; // Allow save if check fails
        }
    }

    // Function to detect reflective insights from AI responses
    function detectReflectiveInsights(responseText) {
        const insights = [];
        
        // Regex to match: "Reflective insight detected [<thinqbit_code>]: <gist of the insight>"
        const insightRegex = /Reflective insight detected \[([^\]]+)\]: (.+?)(?=\n|$|Reflective insight detected)/g;
        
        let match;
        while ((match = insightRegex.exec(responseText)) !== null) {
            const thinqbitCode = match[1].trim();
            const gistText = match[2].trim();
            
            insights.push({
                code: thinqbitCode,
                reason: gistText
            });
        }
        
        return insights;
    }

    // Function to save detected reflective insights to Firestore
    async function saveDetectedInsights(insights, originalUserMessage) {
        try {
            if (!insights || insights.length === 0) return;
            
            const user = firebase.auth().currentUser;
            if (!user) {
                console.error("No authenticated user for reflective insight save");
                return;
            }
            
            // Generate unique packet ID
            const timestamp = Date.now();
            const packetId = `${timestamp}_${btoa(encodeURIComponent(originalUserMessage + timestamp)).substring(0, 8).replace(/[+/=]/g, '')}`;
            
            // Create gist from first insight or combine multiple
            const gist = insights.length === 1 
                ? insights[0].reason 
                : `Multiple insights: ${insights.map(i => i.reason).join('; ')}`;
            
            // Check for duplicate gist before saving
            const isDupe = await isDuplicateGist(gist, user.uid);
            if (isDupe) {
                console.log('Skipping duplicate gist save from reflective insights');
                return;
            }
            
            // Prepare reflective thinking packet for insights
            const reflectivePacket = {
                packetId: packetId,
                timestamp: new Date().toISOString(),
                learner_uid: user.uid,
                original_text: originalUserMessage || "",
                gist: gist,
                intent: "", // Empty per user request
                thinqbits: insights // Array of {code, reason} objects
            };
            
            // Save to Firestore: reflections/{uid}/reflective-thinking/{packetId}
            await firebase.firestore()
                .collection('reflections')
                .doc(user.uid)
                .collection('reflective-thinking')
                .doc(packetId)
                .set(reflectivePacket);
            
            console.log(`Saved reflective insights packet ${packetId} for user ${user.uid}`);
            console.log("Insights packet contents:", reflectivePacket);
            
            // Show sparkles effect
            showReflectiveInsightSparkles();
            
            return true;
            
        } catch (error) {
            console.error("Error saving reflective insights packet:", error);
            return false;
        }
    }

    // Function to show notification when insights are saved
    function showReflectiveInsightSparkles() {
        console.log("Insight saved - notification suppressed for auto-saves");
        
        // Hide the notification for auto-saves as requested
        // showNotification(
        //     "Insight Saved", 
        //     "Your reflective insight has been successfully saved", 
        //     "success", 
        //     3000
        // );
    }

    // Spark Analysis Functions
    function AnalyzeSpark(){
        try {
            console.log("Analyzing Spark...");
            // Track analyze intent
            try {
                const sparkInput = document.getElementById('liminal_spark');
                const val = (sparkInput && sparkInput.value) ? sparkInput.value.trim() : '';
                const urls = val.match(/https?:\/\/\S+/g) || [];
                trackEvent('learnerplus_spark_analysis_started', {
                    spark_length: val.length,
                    url_count: urls.length,
                    user_profile: CURR_USERPROFILE,
                    subscription_status: CURR_STRIPESTATUS
                });
                // mark start time for latency
                window.__sparkAnalyzeStartTs = Date.now();
            } catch(e) {}
            
            // Clear previous results to ensure clean state
            CURR_CLARITY_RESULTS = false;
            
            // Hide velocity hint if it's showing
            var velocityHint = document.getElementById('velocity-hint-above-textarea');
            if (velocityHint) {
                velocityHint.classList.add('hidden');
            }
            
            var sparkInput = document.getElementById('liminal_spark');
            var startButton = document.getElementById('start-button');
            
            if (!sparkInput) {
                console.error("liminal_spark input element not found");
                showNotification('Error', 'Input element not found', 'error', 5000);
                return;
            }
            
            var liminal_spark = sparkInput.value;
            if (!liminal_spark || liminal_spark.trim() === '') {
                console.warn("Empty spark input");
                showNotification('Warning', 'Oops! Please type your message or paste a valid link to continue.', 'warning', 3000);
                return;
            }
            
            // Show modal immediately when start is clicked
            showLiminalModal("liminal-step-1");
            
            // Start the step animation
            animateProcessingSteps();
            
            // Disable form elements during processing (no visual effects)
            // Removed liminal-processing gradient border effect
            if (sparkInput) {
                sparkInput.classList.add('textarea-disabled');
                sparkInput.disabled = true;
            }
            if (startButton) {
                startButton.disabled = true;
            }
            
            // Call clarity-engine endpoint
            callClarityEngine(liminal_spark, () => {
                console.log("Clarity engine analysis completed");
                // Reset button/textarea when processing is complete
                if (sparkInput) {
                    sparkInput.classList.remove('textarea-disabled');
                    sparkInput.disabled = false;
                }
                if (startButton) {
                    startButton.disabled = false;
                }
            });
            
        } catch (error) {
            console.error("Error in AnalyzeSpark:", error);
            // Reset button/textarea on error
            var sparkInput = document.getElementById('liminal_spark');
            var startButton = document.getElementById('start-button');
            if (sparkInput) {
                sparkInput.classList.remove('textarea-disabled');
                sparkInput.disabled = false;
            }
            if (startButton) {
                startButton.disabled = false;
            }
            showNotification('Error', 'Failed to analyze spark: ' + error.message, 'error', 5000);
        }
    }

    // Function to animate processing steps sequentially with enhanced UI
    function animateProcessingSteps() {
        const steps = [
            { iconId: 'status-icon-1', textId: 'status-step-1', delay: 0, bgColor: 'bg-learner-dark-blue', textColor: 'text-learner-dark-blue' },
            { iconId: 'status-icon-2', textId: 'status-step-2', delay: 600, bgColor: 'bg-learner-blue', textColor: 'text-learner-blue' },
            { iconId: 'status-icon-3', textId: 'status-step-3', delay: 0, bgColor: 'bg-learner-teal', textColor: 'text-learner-teal' } // Will be triggered by API completion
        ];
        
        // Reset all steps to initial state with enhanced transitions
        steps.forEach(step => {
            const icon = document.getElementById(step.iconId);
            const text = document.getElementById(step.textId);
            if (icon) {
                icon.className = 'w-4 h-4 rounded-full mr-3 flex items-center justify-center bg-gray-300 transition-all duration-700 ease-in-out';
                icon.innerHTML = '<i class="fa-solid fa-circle text-xs text-gray-500"></i>';
            }
            if (text) {
                text.classList.remove('text-learner-dark-blue', 'text-learner-blue', 'text-learner-teal', 'font-semibold');
                text.classList.add('text-gray-400', 'transition-all', 'duration-700', 'ease-in-out');
            }
        });
        
        // Animate only the first two steps - third waits for API completion
        steps.slice(0, 2).forEach((step) => {
            setTimeout(() => {
                const icon = document.getElementById(step.iconId);
                const text = document.getElementById(step.textId);
                
                if (icon && text) {
                    // Smooth transition without jarring scale effect
                    icon.className = `w-4 h-4 rounded-full mr-3 flex items-center justify-center ${step.bgColor} transition-all duration-700 ease-in-out`;
                    icon.innerHTML = '<i class="fa-solid fa-check text-xs text-white"></i>';
                    text.classList.remove('text-gray-400');
                    text.classList.add(step.textColor, 'font-semibold');
                }
            }, step.delay);
        });
        
        // Store the third step for completion after API calls
        completeAnalysisStep = () => {
            const step = steps[2];
            const icon = document.getElementById(step.iconId);
            const text = document.getElementById(step.textId);
            
            if (icon && text) {
                // Final step with teal color when API calls are done
                icon.className = `w-4 h-4 rounded-full mr-3 flex items-center justify-center ${step.bgColor} transition-all duration-700 ease-in-out`;
                icon.innerHTML = '<i class="fa-solid fa-check text-xs text-white"></i>';
                text.classList.remove('text-gray-400');
                text.classList.add(step.textColor, 'font-semibold');
            }
        };
    }

    // Function to call clarity-engine endpoint
    async function callClarityEngine(reflectionblob, callback) {
        try {
            console.log("Calling clarity-engine endpoint...");
            const __startTs = Date.now();
            
            // Generate new session ID for this reflection conversation
            CURR_SESSION_ID = `medweb_${Date.now()}_${Math.random().toString(36).substr(2, 8)}`;
            console.log("Generated new session ID:", CURR_SESSION_ID);
            
            const utoken = await getFirebaseToken();
            if (!utoken) {
                console.error("Failed to get Firebase auth token");
                showNotification('Error', 'Authentication token not available', 'error', 3000);
                // Reset button and textarea on auth error
                var sparkInput = document.getElementById('liminal_spark');
                var startButton = document.getElementById('start-button');
                if (sparkInput) {
                    sparkInput.classList.remove('textarea-disabled');
                    sparkInput.disabled = false;
                }
                if (startButton) {
                    startButton.disabled = false;
                }
                return;
            }

            // Create axios instance without interceptors to avoid loading overlay
            const axiosNoLoading = axios.create();
            
            // Show subtle progress bar for background activity
            showProgressBar();
            
            const response = await axiosNoLoading.post('/clarity-engine', {
                learner_reflectionblob: reflectionblob,
                utoken: utoken
            });

            console.log("Clarity engine response:", response.data);
            
            // Store the clarity results globally
            CURR_CLARITY_RESULTS = response.data;
            // Track success
            try {
                trackEvent('learnerplus_spark_analysis_completed', {
                    latency_ms: Date.now() - (window.__sparkAnalyzeStartTs || __startTs),
                    intent: (response.data && response.data.intent) || '',
                    status: 'success',
                    user_profile: CURR_USERPROFILE,
                    thinqbits_count: (response.data && response.data.thinqbits ? response.data.thinqbits.length : 0),
                    gist_present: !!(response.data && response.data.gist && response.data.gist.trim()),
                    ipoc_keywords_count: (response.data && response.data.ipoc_keywords ? response.data.ipoc_keywords.length : 0)
                });
            } catch(e) {}
            
            // Update DSIB badge with new data
            updateDSIBBadgeCount();
            
            // Save to reflective-thinking collection if criteria met
            await saveReflectiveThinkingIfEligible(reflectionblob, response.data);
            
            // Check for irrelevant_blabber intent and show notification instead of opening chat
            if (response.data && response.data.intent === 'irrelevant_blabber') {
                console.log("Detected irrelevant content - showing notification instead of opening chat");
                
                // Hide the processing modal
                hideLiminalModal();
                
                // Show notification that this looks like gibberish
                showNotification(
                    'Content Not Meaningful', 
                    'This content appears to be irrelevant. Please share something more meaningful to get insights and learning opportunities.', 
                    'warning', 
                    5000
                );
                
                // Call the callback to complete the process
                if (callback) {
                    callback();
                }
                return; // Exit early, don't open chat
            }
            
            // Check if we should fetch perspective: prefer gist, fallback to IPOC keywords
            const hasGist = response.data && response.data.gist && response.data.gist.trim() !== '';
            const hasIpocKeywords = response.data && response.data.ipoc_keywords && response.data.ipoc_keywords.length > 0;
            const isLearningCapture = response.data && response.data.intent === 'learning_capture';
            
            // Removed perspective search - not currently being displayed to users
            
            // Complete the final analysis step
            if (completeAnalysisStep) {
                completeAnalysisStep();
            }
            
            // Auto-launch chat with analysis results immediately
            setTimeout(() => {
                hideLiminalModal();
                
                // Launch chat with analysis results
                setTimeout(() => {
                    launchChatWithAnalysisResults();
                }, 300);
            }, 1000); // Wait a moment to let user see the analysis completed
            
            // Call the callback when clarity-engine completes
            if (callback) {
                callback();
            }
            
        } catch (error) {
            console.error("Error calling clarity-engine:", error);
            try {
                trackEvent('learnerplus_spark_analysis_completed', {
                    latency_ms: window.__sparkAnalyzeStartTs ? (Date.now() - window.__sparkAnalyzeStartTs) : undefined,
                    error: (error && (error.message || error.toString())) || 'unknown',
                    status: 'failed',
                    user_profile: CURR_USERPROFILE
                });
            } catch(e) {}
            // Don't show notification for this error to avoid interrupting the main flow
            // But still call the callback to continue the flow
            if (callback) {
                callback();
            }
        } finally {
            // Always hide progress bar when operation completes
            hideProgressBar();
        }
    }


    function showLiminalModal(liminalStep = "liminal-step-1") {
        document.querySelectorAll('.liminal-step').forEach((step) => {
            step.classList.add('hidden');
        });
        
        var stepEl = document.getElementById(liminalStep);
        var modalEl = document.getElementById('liminalmodal');
        
        if (stepEl) {
            stepEl.classList.remove('hidden');
        } else {
            console.warn(`Liminal step element '${liminalStep}' not found`);
        }
        
        if (modalEl) {
            modalEl.classList.remove('hidden');
        } else {
            console.warn("Liminal modal element not found");
        }
    }

    const hideLiminalModal = function() {
        var modalEl = document.getElementById('liminalmodal');
        if (modalEl) {
            modalEl.classList.add('hidden');
        } else {
            console.warn("Liminal modal element not found");
        }
    }

    const moveToLiminalFinalStep = function() {
        hideLiminalModal();
    }

    
    // New function to launch chat with analysis results
    function launchChatWithAnalysisResults() {
        console.log('Launching chat with analysis results');
        
        if (!CURR_CLARITY_RESULTS) {
            console.warn('No clarity results available for chat');
            return;
        }
        
        // Clean up any existing discovery mode containers before launching
        const existingDiscovery = document.getElementById('discovery-mode-container');
        if (existingDiscovery) {
            existingDiscovery.remove();
            console.log('Removed existing discovery container');
        }
        
        // Launch chat with structured analysis content
        showChatInterface();
    }
    
    function populateLiminalResults() {
        if (!CURR_CLARITY_RESULTS) {
            console.warn("No clarity results available");
            return;
        }

        // Clear previous state first
        clearLiminalResultsUI();

        // Update modal title based on content richness
        updateModalTitle();

        // 1. Hide perspective callout (feature removed)
        var perspectiveCallout = document.getElementById('perspective-callout');
        if (perspectiveCallout) {
            perspectiveCallout.style.display = 'none';
        }

        // 2. Show Thinqbits Saved Message (if available) - restored to original
        var thinqbitsSavedSection = document.getElementById('thinqbits-saved');
        var savedThinqbitsEl = document.getElementById('saved-thinqbits-list');
        if (thinqbitsSavedSection && savedThinqbitsEl && CURR_CLARITY_RESULTS.thinqbits) {
            if (CURR_CLARITY_RESULTS.thinqbits.length > 0) {
                var savedBadgesHtml = '';
                CURR_CLARITY_RESULTS.thinqbits.forEach(function(thinqbit) {
                    var icon = getThinqbitIcon(thinqbit.code);
                    var label = thinqbit.title || getThinqbitLabel(thinqbit.code);
                    var insight = thinqbit.insight || '';
                    savedBadgesHtml += `
                        <span class="inline-flex items-center rounded-full bg-gray-100 border border-gray-300 px-2 py-1 text-xs font-medium text-gray-800" title="${insight}">
                            <i class="${icon} mr-1"></i>
                            ${label}
                        </span>
                    `;
                });
                savedThinqbitsEl.innerHTML = savedBadgesHtml;
                thinqbitsSavedSection.style.display = 'block';
            } else {
                thinqbitsSavedSection.style.display = 'none';
            }
        }

        // 3. Hide Thinqbits Badges section (keeping only saved thinqbits at bottom)
        var thinqbitsSection = document.getElementById('thinqbits-badges');
        if (thinqbitsSection) {
            thinqbitsSection.style.display = 'none';
        }

        // 3. Create Action Buttons for IPOC Keywords
        var ipocSection = document.getElementById('ipoc-actions');
        var ipocActionsEl = document.getElementById('results-ipoc-actions');
        if (ipocSection && ipocActionsEl && CURR_CLARITY_RESULTS.ipoc_keywords) {
            if (CURR_CLARITY_RESULTS.ipoc_keywords.length > 0) {
                var actionsHtml = '';
                CURR_CLARITY_RESULTS.ipoc_keywords.forEach(function(keyword, index) {
                    actionsHtml += `
                        <div class="flex items-center justify-between p-3 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition-colors">
                            <div class="flex-1">
                                <span class="text-sm font-medium text-gray-900">${keyword}</span>
                            </div>
                            <div class="flex items-center space-x-2">
                                <button type="button" class="inline-flex items-center ml-2 px-4 py-2 border border-transparent text-sm font-medium rounded text-white bg-teal-500 hover:bg-teal-600 transition-colors ui-action-btn" data-task="reflect-now::${keyword}::${index}">
                                    Reflect for Credit
                                </button>
                                <button type="button" class="inline-flex items-center justify-center w-8 h-8 rounded border border-gray-300 text-gray-600 bg-white hover:bg-gray-50 hover:text-gray-700 transition-colors ui-action-btn" data-task="snooze::${keyword}::tomorrow" title="Snooze until tomorrow">
                                    <i class="fa-solid fa-clock text-xs"></i>
                                </button>
                            </div>
                        </div>
                    `;
                });
                ipocActionsEl.innerHTML = actionsHtml;
                ipocSection.style.display = 'block';
            } else {
                ipocSection.style.display = 'none';
            }
        }

        // 4. Show Start Reflective Chat Section (whenever reflective_gap is detected)
        var captureInsightSection = document.getElementById('capture-insight-section');
        var velocityHintInModal = document.getElementById('velocity-hint-in-modal');
        if (captureInsightSection && velocityHintInModal) {
            const hasReflectiveGap = CURR_CLARITY_RESULTS.reflective_gap && CURR_CLARITY_RESULTS.reflective_gap.trim() !== '';
            
            if (hasReflectiveGap) {
                velocityHintInModal.textContent = CURR_CLARITY_RESULTS.reflective_gap;
                captureInsightSection.style.display = 'block';
            } else {
                captureInsightSection.style.display = 'none';
            }
        }

        // 5. Show Save Draft Section (when we have substantial thinking to save)
        var continueLaterSection = document.getElementById('continue-later-section');
        if (continueLaterSection) {
            const gist = CURR_CLARITY_RESULTS.gist || '';
            const gistWordCount = gist.trim().split(/\s+/).filter(word => word.length > 0).length;
            const hasMeaningfulGist = gistWordCount >= 5;
            
            const hasThinqbits = CURR_CLARITY_RESULTS.thinqbits && CURR_CLARITY_RESULTS.thinqbits.length > 0;
            const hasOriginalSpark = document.getElementById('liminal_spark')?.value?.trim();
            
            // Only show if we have substantial thinking: meaningful gist length, thinqbits, or original spark
            const hasSubstantialContent = hasMeaningfulGist || hasThinqbits || hasOriginalSpark;
            
            if (hasSubstantialContent) {
                continueLaterSection.style.display = 'block';
            } else {
                continueLaterSection.style.display = 'none';
            }
        }

        // 6. Handle cases with no actionable content
        const hasIpocKeywords = CURR_CLARITY_RESULTS.ipoc_keywords && CURR_CLARITY_RESULTS.ipoc_keywords.length > 0;
        const hasReflectiveGap = CURR_CLARITY_RESULTS.reflective_gap && CURR_CLARITY_RESULTS.reflective_gap.trim() !== '';
        const hasThinqbits = CURR_CLARITY_RESULTS.thinqbits && CURR_CLARITY_RESULTS.thinqbits.length > 0;
        
        // This logic is now handled by launchChatWithAnalysisResults()
        
        // 6. Show chat agent placeholder if no keywords, reflective gap, or meaningful content
        var chatPlaceholderSection = document.getElementById('chat-agent-placeholder');
        if (chatPlaceholderSection) {
            if (!hasIpocKeywords && !hasReflectiveGap && !hasThinqbits) {
                chatPlaceholderSection.style.display = 'block';
                // Auto-launch chat agent here
            } else {
                chatPlaceholderSection.style.display = 'none';
            }
        }

        // 7. Update the bottom action buttons (simplified since main actions are now above)
        populateLiminalActions();
    }

    function updateModalTitle() {
        const modalTitle = document.getElementById('modal-title');
        if (!modalTitle) return;

        const hasThinqbits = CURR_CLARITY_RESULTS.thinqbits && CURR_CLARITY_RESULTS.thinqbits.length > 0;
        const hasGist = CURR_CLARITY_RESULTS.gist && CURR_CLARITY_RESULTS.gist.trim() !== '';
        const hasIpocKeywords = CURR_CLARITY_RESULTS.ipoc_keywords && CURR_CLARITY_RESULTS.ipoc_keywords.length > 0;

        // If all three are present, it's a great insight
        if (hasThinqbits && hasGist && hasIpocKeywords) {
            modalTitle.textContent = 'Great insight';
        } else {
            modalTitle.textContent = 'Reflect';
        }
    }

    function populateLiminalActions() {
        const actionsContainer = document.getElementById('liminal-actions-container');
        if (!actionsContainer) {
            return;
        }

        // Since main actions are now in the body, just show a simple Done button
        let actionsHtml = `
            <button type="button" class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto ui-action-btn" data-task="close-liminal-modal">
                <span>Done</span>
            </button>
        `;

        actionsContainer.innerHTML = actionsHtml;
    }

    function clearLiminalResultsUI() {
        // Hide all sections initially - they'll be shown if they have content
        var thinqbitsSection = document.getElementById('thinqbits-badges');
        var thinqbitsSavedSection = document.getElementById('thinqbits-saved');
        var ipocSection = document.getElementById('ipoc-actions');
        var captureInsightSection = document.getElementById('capture-insight-section');
        var continueLaterSection = document.getElementById('continue-later-section');
        var chatPlaceholderSection = document.getElementById('chat-agent-placeholder');
        if (thinqbitsSection) thinqbitsSection.style.display = 'none';
        if (thinqbitsSavedSection) thinqbitsSavedSection.style.display = 'none';
        if (ipocSection) ipocSection.style.display = 'none';
        if (captureInsightSection) captureInsightSection.style.display = 'none';
        if (continueLaterSection) continueLaterSection.style.display = 'none';
        if (chatPlaceholderSection) chatPlaceholderSection.style.display = 'none';

        // Clear content

        var thinqbitsEl = document.getElementById('results-thinqbits');
        if (thinqbitsEl) {
            thinqbitsEl.innerHTML = '';
        }

        var ipocActionsEl = document.getElementById('results-ipoc-actions');
        if (ipocActionsEl) {
            ipocActionsEl.innerHTML = '';
        }
    }

    function getThinqbitIcon(code) {
        const iconMap = {
            'obs': 'fa-solid fa-eye',
            'risk': 'fa-solid fa-triangle-exclamation',
            'q': 'fa-solid fa-question-circle',
            'idea': 'fa-solid fa-lightbulb',
            'dec': 'fa-solid fa-gavel',
            'bias': 'fa-solid fa-brain',
            'hypo': 'fa-solid fa-flask',
            'model': 'fa-solid fa-diagram-project',
            'eval': 'fa-solid fa-chart-line',
            'sys': 'fa-solid fa-cogs',
            'people': 'fa-solid fa-users',
            'ai': 'fa-solid fa-robot'
        };
        return iconMap[code] || 'fa-solid fa-circle';
    }

    function getThinqbitLabel(code) {
        const labelMap = {
            'obs': 'Clinical Observation',
            'risk': 'Risk Pattern',
            'q': 'Open Question',
            'idea': 'Idea/Insight',
            'dec': 'Decision Point',
            'bias': 'Cognitive Bias',
            'hypo': 'Hypothesis',
            'model': 'Mental Model',
            'eval': 'Post-Decision Evaluation',
            'sys': 'System/Workflow Insight',
            'people': 'People Insight',
            'ai': 'AI-Assisted Insight'
        };
        return labelMap[code] || code.toUpperCase();
    }


    // Close chat and other modals using existing UI actions (no force-hide)
    function closeChatAndOtherModalsUsingUI() {
        try {
            // Close chat via its close button if visible
            const chatInterface = document.getElementById('chat-interface');
            if (chatInterface && !chatInterface.classList.contains('hidden')) {
                const closeBtn = document.getElementById('close-chat');
                if (closeBtn) closeBtn.click();
            }

            // Close DSIB panel if open (prefer its close function/button)
            const dsibPanel = document.getElementById('dsib-panel');
            if (dsibPanel && !dsibPanel.classList.contains('hidden')) {
                if (typeof closeDSIBPanel === 'function') {
                    closeDSIBPanel();
                } else {
                    const dsibClose = document.getElementById('dsib-panel-close');
                    if (dsibClose) dsibClose.click();
                }
            }

            // Validation modal
            const validationModal = document.getElementById('validationmodal');
            if (validationModal && !validationModal.classList.contains('hidden')) {
                if (typeof performTask === 'function') performTask('validationmodal-dismiss');
            }

            // Help modal
            const helpModal = document.getElementById('helpmodal');
            if (helpModal && !helpModal.classList.contains('hidden') && typeof closeHelpModal === 'function') {
                closeHelpModal();
            }

            // Command palette
            const commandPaletteEl = document.getElementById('commandpalette');
            if (commandPaletteEl && !commandPaletteEl.classList.contains('hidden') && typeof closeCommandPalette === 'function') {
                closeCommandPalette();
            }

            // Transcript modal
            const transcriptModal = document.getElementById('transcript-modal');
            if (transcriptModal && !transcriptModal.classList.contains('hidden') && typeof closeTranscriptModal === 'function') {
                closeTranscriptModal();
            }

            // Liminal modal
            const liminalModal = document.getElementById('liminalmodal');
            if (liminalModal && !liminalModal.classList.contains('hidden') && typeof hideLiminalModal === 'function') {
                hideLiminalModal();
            }
        } catch (e) {
            console.warn('closeChatAndOtherModalsUsingUI: issue while dismissing', e);
        }
    }

    // Credit Modal functionality (converted from drawer)
    const toggleCreditDrawer = function() {
        const modal = document.getElementById('creditDrawer');
        const modalContent = document.getElementById('creditModalContent');
        
        if (modal.classList.contains('hidden')) {
            // Politely close chat and other open modals first
            closeChatAndOtherModalsUsingUI();
            // Opening modal - load content
            updateCreditDrawerContent();
            
            // Show modal
            modal.classList.remove('hidden');
            
            // Animate modal content in
            setTimeout(() => {
                modalContent.classList.remove('scale-95', 'opacity-0');
                modalContent.classList.add('scale-100', 'opacity-100');
            }, 10);
            // Track open
            MP.track('Credit Modal Opened', {});
        } else {
            // Animate modal content out
            modalContent.classList.remove('scale-100', 'opacity-100');
            modalContent.classList.add('scale-95', 'opacity-0');
            
            // Hide modal after animation
            setTimeout(() => {
                modal.classList.add('hidden');
            }, 300);
            // Track close
            MP.track('Credit Modal Closed', {});
        }
    }

    // Add click outside functionality for credit modal
    document.addEventListener('click', function(event) {
        const modal = document.getElementById('creditDrawer');
        const modalContent = document.getElementById('creditModalContent');
        
        // Check if modal is open and click was outside modal content
        if (!modal.classList.contains('hidden') && 
            !modalContent.contains(event.target) && 
            modal.contains(event.target)) {
            toggleCreditDrawer();
        }
    });

    // Add ESC key functionality for credit modal
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            const modal = document.getElementById('creditDrawer');
            if (!modal.classList.contains('hidden')) {
                toggleCreditDrawer();
            }
        }
    });

    // Function to update credit drawer content dynamically
    function updateCreditDrawerContent() {
        console.log('Updating credit drawer content...');

        // Update credit balance and fetch certificates
        fetchReflectionsAndCreditBalance((creditBalance) => {
            fetchCertificates((certificateData) => {
                const contentContainer = document.getElementById('creditModalContentArea');
                if (!contentContainer) return;

                const unclaimedCredits = creditBalance.totalUnclaimedCredts || 0;
                const certificates = certificateData.certificates || [];

                let contentHTML = ``;

                // Combined Credit Overview & Generate Certificate Section
                if (unclaimedCredits > 0) {
                    contentHTML += `
                    <!-- Combined Credit Overview & Claim Section -->
                    <div class="mb-6">
                        <div class="bg-learner-dark-blue rounded-lg p-6 text-white">
                            <div class="flex items-center justify-between mb-4">
                                <div>
                                    <p class="text-sm opacity-90">Available Credits</p>
                                    <p class="text-3xl font-bold">${unclaimedCredits}</p>
                                </div>
                                <i class="fa-solid fa-file-certificate text-3xl"></i>
                            </div>
                            <button class="w-full bg-white text-learner-dark-blue py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors font-medium ui-action-btn" data-task="generate-certificate">
                                Claim Credit(s) & Generate Certificate
                            </button>
                        </div>
                    </div>`;
                } else {
                    // Show just the credit overview if no unclaimed credits
                    contentHTML += `
                    <!-- Credit Overview Only -->
                    <div class="mb-6">
                        <div class="bg-learner-dark-blue rounded-lg p-6 text-white">
                            <div class="flex items-center justify-between">
                                <div>
                                    <p class="text-sm opacity-90">Available Credits</p>
                                    <p class="text-3xl font-bold">0</p>
                                </div>
                                <i class="fa-solid fa-certificate text-3xl opacity-75"></i>
                            </div>
                        </div>
                    </div>`;
                }

                // Section 2: Time-based Certificates with Accordion
                if (certificates.length === 0) {
                    // Track render with zero certs
                    MP.track('Credit Modal Content Rendered', {
                        credits_unclaimed: unclaimedCredits,
                        certificates_total: 0,
                        certificates_recent: 0,
                        certificates_previous: 0
                    });
                    contentHTML += `
                        <div class="mb-6">
                            <h3 class="text-sm font-medium text-gray-900 mb-3">Your Certificates & Transcripts</h3>
                            <div class="text-center py-6 text-gray-500">
                                <i class="fa-solid fa-certificate text-3xl mb-2 opacity-50"></i>
                                <p class="text-sm">No certificates generated yet</p>
                                <p class="text-xs mt-1">Start capturing reflections to earn credits!</p>
                            </div>
                        </div>`;
                } else {
                    // Separate certificates by time (3 months threshold)
                    const threeMonthsAgo = new Date();
                    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
                    
                    const recentCerts = certificates.filter(cert => new Date(cert.claimedOn) >= threeMonthsAgo);
                    const previousCerts = certificates.filter(cert => new Date(cert.claimedOn) < threeMonthsAgo);
                    
                    console.log(`Certificates organized: ${recentCerts.length} recent, ${previousCerts.length} previous`);
                    // Track render with counts
                    MP.track('Credit Modal Content Rendered', {
                        credits_unclaimed: unclaimedCredits,
                        certificates_total: certificates.length,
                        certificates_recent: recentCerts.length,
                        certificates_previous: previousCerts.length
                    });
                    
                    contentHTML += `<div class="mb-6">`;
                    
                    // Recent Certificates Section (Expanded by default)
                    if (recentCerts.length > 0) {
                        contentHTML += `
                            <div class="mb-4">
                                <h3 class="text-sm font-medium text-gray-900 mb-3 flex items-center">
                                    <i class="fa-solid fa-clock text-gray-400 mr-2"></i>
                                    Recent Certificates
                                    <span class="ml-2 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">${recentCerts.length}</span>
                                </h3>
                                <div id="recent-certificates-content">`;
                        
                        recentCerts.forEach(cert => {
                            const claimedDate = new Date(cert.claimedOn).toLocaleDateString('en-US', { 
                                year: 'numeric', 
                                month: 'short', 
                                day: 'numeric' 
                            });
                            
                            contentHTML += generateCertificateCard(cert, claimedDate);
                        });
                        
                        contentHTML += `</div></div>`;
                    }
                    
                    // Previous Certificates Section (Collapsed accordion)
                    if (previousCerts.length > 0) {
                        contentHTML += `
                            <div class="mb-4">
                                <button class="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors" 
                                        onclick="toggleCertificateAccordion('previous-certificates')">
                                    <div class="flex items-center">
                                        <i class="fa-solid fa-folder text-gray-400 mr-2"></i>
                                        <span class="text-sm font-medium text-gray-700">Past Certificates</span>
                                        <span class="ml-2 bg-gray-200 text-gray-600 text-xs px-2 py-1 rounded-full">${previousCerts.length}</span>
                                    </div>
                                    <i class="fa-solid fa-chevron-down text-gray-400 transform transition-transform duration-200" id="previous-certificates-icon"></i>
                                </button>
                                <div id="previous-certificates-content" class="hidden mt-2">`;
                        
                        previousCerts.forEach(cert => {
                            const claimedDate = new Date(cert.claimedOn).toLocaleDateString('en-US', { 
                                year: 'numeric', 
                                month: 'short', 
                                day: 'numeric' 
                            });
                            
                            contentHTML += generateCertificateCard(cert, claimedDate);
                        });
                        
                        contentHTML += `</div></div>`;
                    }
                    
                    contentHTML += `</div>`;
                }

                // Share Narrative Section - Accordion Style
                contentHTML += `
                    <!-- Share Narrative Section - Accordion -->
                    <div class="mb-6">
                        <div class="border border-blue-200 rounded-lg overflow-hidden">
                            <!-- Accordion Header -->
                            <button class="w-full px-3 py-2 text-left transition-colors focus:outline-none" 
                                    onclick="toggleNarrativeAccordion('narrative-section')">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <div>
                                            <h3 class="text-md font-semibold text-slate-900 mb-0">
                                                ✨ Narratives & Reports (Beta)
                                            </h3>
                                            <p class="text-xs text-gray-600 mt-1">Turn your reflections into narrative reports. Perfect for coaching, risk reviews, professional development and more!</p>
                                        </div>
                                    </div>
                                    <i class="fa-solid fa-chevron-down text-slate-400 transform transition-transform duration-200" id="narrative-section-icon"></i>
                                </div>
                            </button>
                            
                            <!-- Accordion Content -->
                            <div id="narrative-section-content" class="hidden bg-white">
                                <div class="px-3 py-2 border-t border-blue-100">
                                    <!-- Comprehensive Narratives (analyze all reflections) -->
                                    <div class="my-4">
                                        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
                                            <button class="flex flex-col items-center p-4 bg-white rounded-lg border hover:border-learner-plus-blue hover:shadow-sm transition-all ui-action-btn" data-task="share-narrative::coach">
                                                <i class="fa-solid fa-user-tie text-learner-plus-blue text-2xl mb-2"></i>
                                                <span class="text-sm font-medium text-slate-700">For Coach</span>
                                            </button>
                                            <button class="flex flex-col items-center p-4 bg-white rounded-lg border hover:border-learner-plus-blue hover:shadow-sm transition-all ui-action-btn" data-task="share-narrative::manager">
                                                <i class="fa-solid fa-briefcase text-learner-plus-blue text-2xl mb-2"></i>
                                                <span class="text-sm font-medium text-slate-700">For Manager</span>
                                            </button>
                                            <button class="flex flex-col items-center p-4 bg-white rounded-lg border hover:border-learner-plus-blue hover:shadow-sm transition-all ui-action-btn" data-task="share-narrative::risk">
                                                <i class="fa-solid fa-shield-exclamation text-learner-plus-blue text-2xl mb-2"></i>
                                                <span class="text-sm font-medium text-slate-700">Risk Analysis</span>
                                            </button>
                                            <button class="flex flex-col items-center p-4 bg-white rounded-lg border hover:border-learner-plus-blue hover:shadow-sm transition-all ui-action-btn" data-task="share-narrative::quality">
                                                <i class="fa-solid fa-medal text-learner-plus-blue text-2xl mb-2"></i>
                                                <span class="text-sm font-medium text-slate-700">Quality Review</span>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Context-Based Narrative (separate workflow) -->
                                    <div class="mb-4 p-1">
                                        <div class="mb-4">
                                            <h4 class="text-base font-semibold text-gray-900 mb-1">Context-Focused Narrative</h4>
                                            <p class="text-sm text-gray-600">Create a focused narrative by learning context (e.g. specific events)</p>
                                        </div>
                                        <div class="space-y-3">
                                            <div>
                                                <select id="narrative-context-dropdown" class="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-learner-plus-blue focus:border-transparent">
                                                    <option value="">Loading contexts...</option>
                                                </select>
                                            </div>
                                            <button class="w-full px-4 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-700 transition-all text-sm font-medium ui-action-btn" data-task="generate-context-summary" disabled>
                                                <i class="fa-solid fa-sparkles mr-2"></i>
                                                Generate Contextual Narrative
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div class="flex items-start text-xs text-gray-500">
                                        <i class="fa-solid fa-shield-halved mr-2 mt-0.5 flex-shrink-0"></i>
                                        <span>Intelligently curates contextually relevant insights from your learning journey. Your raw reflections remain private and are never shared.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`;

                
                contentHTML += `</div>`;

                
                // Enterprise Team Status Section
                if (CURR_ENTERPRISEMODE_IS_ACTIVE) {
                    contentHTML += `
                        <!-- Enterprise Team Status -->
                        <div class="mb-4">
                            <span class="inline-flex items-center gap-x-1.5 rounded-md bg-red-50 px-2.5 py-1.5 text-xs font-semibold text-red-600 shadow-sm">
                                <i class="fa-solid fa-users"></i>
                                <span>${CURR_ENTERPRISEMODE_STATUS}</span>
                            </span>
                        </div>`;
                }

                // Section 3: See More Button
                contentHTML += `
                    <!-- See More Section -->
                    <div class="border-t border-gray-200 pt-4">
                        <button class="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-200 transition-colors ui-action-btn" data-task="view-more-certificates">
                            <i class="fa-solid fa-external-link mr-2"></i>
                            Go to My Account
                        </button>
                    </div>`;

                // Add CPD section if applicable
                if (shouldShowCPDSection()) {
                    contentHTML += generateCPDSection();
                }

                // Update the content
                contentContainer.innerHTML = contentHTML;

                // Populate the context dropdown after content is rendered
                populateContextDropdown();

                console.log('Credit drawer content updated successfully');
            });
        });
    }

    // UK CPD Profile Detection Functions
    function shouldShowCPDSection() {
        // Only show CPD Portfolio for UK-based healthcare professionals
        // since GMC/NMC compliance is UK-specific

        // Get location from both possible property names (inconsistent casing in codebase)
        const location = CURR_USERPROFILE?.primaryLocation || CURR_USERPROFILE?.primarylocation || '';

        // UK location variations (case-insensitive matching)
        const ukLocations = [
            'UK', 'United Kingdom', 'Britain',
            'England', 'Scotland', 'Wales', 'Northern Ireland',
            'Great Britain', 'British Isles'
        ];

        const isUKLocation = ukLocations.some(ukLoc =>
            location.toLowerCase().includes(ukLoc.toLowerCase())
        );

        // Check for healthcare credentials that require GMC/NMC compliance
        const credential = CURR_USERPROFILE?.credential || '';
        const isHealthcareProfessional = (
            credential.includes('Nurse') || credential.includes('Midwife') ||
            credential.includes('Doctor') || credential.includes('Physician') ||
            credential.includes('General Practitioner') || credential.includes('GP') ||
            credential === 'RN' || credential === 'RGN' || credential === 'RM' ||
            credential === 'MD' || credential === 'MBBS' || credential === 'MBChB'
        );

        // Only show CPD section for UK healthcare professionals
        return isUKLocation && isHealthcareProfessional;
    }

    function getUserCPDMode() {
        if (!shouldShowCPDSection()) return null;

        const credential = CURR_USERPROFILE?.credential || '';

        // NMC credentials (nurses, midwives, nursing associates)
        if (credential.includes('Nurse') ||
            credential.includes('Midwife') ||
            credential.includes('Nursing Associate') ||
            credential === 'RN' ||
            credential === 'RGN' ||
            credential === 'RM') {
            return 'NMC';
        }

        // GMC/RCGP credentials (doctors, GPs)
        if (credential.includes('Doctor') ||
            credential.includes('Physician') ||
            credential.includes('General Practitioner') ||
            credential.includes('GP') ||
            credential === 'MD' ||
            credential === 'MBBS' ||
            credential === 'MBChB') {
            return 'GMC'; // Could be 'RCGP' for GPs specifically
        }

        return 'GMC'; // default for medical professionals
    }


    function generateCPDSection() {
        const cpdMode = getUserCPDMode();

        let actionsHTML = '';

        if (cpdMode === 'GMC' || cpdMode === 'RCGP') {
            actionsHTML = `
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-blue-200 hover:border-blue-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-gmc-narrative">
                        <i class="fa-solid fa-file-medical text-blue-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">GMC Reflective Narrative</span>
                        <span class="text-xs text-gray-500 mt-1">For appraisal & revalidation</span>
                    </button>

                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-green-200 hover:border-green-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-cpd-log">
                        <i class="fa-solid fa-list-check text-green-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">CPD Log Entry</span>
                        <span class="text-xs text-gray-500 mt-1">Learning → Impact tracking</span>
                    </button>

                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-purple-200 hover:border-purple-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-pdp-objectives">
                        <i class="fa-solid fa-bullseye text-purple-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">PDP SMART Objectives</span>
                        <span class="text-xs text-gray-500 mt-1">Personal development plan</span>
                    </button>

                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-teal-200 hover:border-teal-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-appraisal-summary">
                        <i class="fa-solid fa-chart-line text-teal-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">Appraisal Summary</span>
                        <span class="text-xs text-gray-500 mt-1">GMC domain mapping</span>
                    </button>
                </div>`;

            if (cpdMode === 'RCGP') {
                actionsHTML += `
                    <div class="mb-4">
                        <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-orange-200 hover:border-orange-400 hover:shadow-sm transition-all ui-action-btn w-full" data-task="generate-capability-map">
                            <i class="fa-solid fa-map text-orange-600 text-2xl mb-2"></i>
                            <span class="text-sm font-medium text-gray-900">MRCGP Capability Map</span>
                            <span class="text-xs text-gray-500 mt-1">RCGP curriculum alignment</span>
                        </button>
                    </div>`;
            }
        } else if (cpdMode === 'NMC') {
            actionsHTML = `
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-blue-200 hover:border-blue-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-nmc-accounts">
                        <i class="fa-solid fa-file-text text-blue-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">Five Reflective Accounts</span>
                        <span class="text-xs text-gray-500 mt-1">NMC revalidation requirement</span>
                    </button>

                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-green-200 hover:border-green-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-nmc-discussion">
                        <i class="fa-solid fa-comments text-green-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">Discussion Summary Scaffold</span>
                        <span class="text-xs text-gray-500 mt-1">NMC discussion framework</span>
                    </button>

                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-purple-200 hover:border-purple-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-nmc-cpd-hours">
                        <i class="fa-solid fa-clock text-purple-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">CPD Hours Tracker</span>
                        <span class="text-xs text-gray-500 mt-1">35 hours (20 participatory)</span>
                    </button>

                    <button class="flex flex-col items-center p-4 bg-white rounded-lg border border-orange-200 hover:border-orange-400 hover:shadow-sm transition-all ui-action-btn" data-task="generate-nmc-feedback-guide">
                        <i class="fa-solid fa-handshake text-orange-600 text-2xl mb-2"></i>
                        <span class="text-sm font-medium text-gray-900">Feedback Collection Guide</span>
                        <span class="text-xs text-gray-500 mt-1">5 pieces practice feedback</span>
                    </button>
                </div>`;
        }

        return `
            <!-- CPD Portfolio Section -->
            <div class="mb-6 mt-8">
                <div class="border border-blue-200 rounded-lg overflow-hidden">
                    <div class="px-4 py-3 bg-blue-50">
                        <div class="flex items-center space-x-3">
                            <span class="text-lg">🇬🇧</span>
                            <div>
                                <h3 class="text-md font-semibold text-gray-900">CPD Portfolio</h3>
                                <span class="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 rounded-full">UK | ${cpdMode}</span>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 bg-white">
                        <!-- Assist-only mode banner -->
                        <div class="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                            <div class="flex items-start space-x-2">
                                <i class="fa-solid fa-info-circle text-amber-600 mt-0.5"></i>
                                <div class="text-sm text-amber-800">
                                    <strong>Assist-Only Mode:</strong> AI supports your reflection—it doesn't replace it. All outputs are based on your real cases and require your attestation.
                                </div>
                            </div>
                        </div>

                        ${actionsHTML}

                        <!-- Compliance Note -->
                        <div class="pt-4 border-t border-gray-200">
                            <div class="flex items-start space-x-2 text-xs text-gray-600">
                                <i class="fa-solid fa-shield-check text-gray-400 mt-0.5"></i>
                                <div>
                                    <p><strong>Compliance:</strong> All outputs require your attestation that content is based on real cases with identifiers removed.</p>
                                    <p class="mt-1"><strong>AI Disclosure:</strong> Generated content includes appropriate AI assistance disclosure.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }


    // CPD Output Generation Functions
    function generateCPDOutput(outputType) {
        console.log(`Generating CPD output: ${outputType}`);

        // Check subscription status first
        if (!CURR_STRIPESTATUS) {
            showValidationModal('⚠️ Subscription Required ⚠️',
                `UK CPD Portfolio features require an active subscription.<br/>Access GMC/NMC compliant outputs, reflective narratives, and audit trail for £50/yr only.`,
                `Subscribe Now`,
                function() {
                    window.location.href = '/create-checkout-session?email='+CURR_USERPROFILE.email+'&uid='+CURR_USER.uid+'&primarylocation='+encodeURIComponent(CURR_USERPROFILE.primarylocation);
                },
                'Close',
                () => { performTask('validationmodal-dismiss'); }
            );
            return;
        }

        // Close credit modal
        const modal = document.getElementById('creditDrawer');
        if (modal && !modal.classList.contains('hidden')) {
            toggleCreditDrawer();
        }

        // Show compliance modal first
        showCPDComplianceModal(outputType);
    }

    function showCPDComplianceModal(outputType) {
        const outputNames = {
            'gmc-narrative': 'GMC Reflective Narrative',
            'cpd-log': 'CPD Log Entry',
            'pdp-objectives': 'PDP SMART Objectives',
            'appraisal-summary': 'Appraisal Summary',
            'capability-map': 'MRCGP Capability Map',
            'nmc-accounts': 'NMC Reflective Accounts',
            'nmc-discussion': 'NMC Discussion Summary',
            'nmc-cpd-hours': 'NMC CPD Hours Tracker',
            'nmc-feedback-guide': 'NMC Feedback Collection Guide'
        };

        const outputName = outputNames[outputType] || outputType;

        const complianceHTML = `
            <div class="space-y-4">
                <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-start space-x-2">
                        <i class="fa-solid fa-info-circle text-blue-600 mt-0.5"></i>
                        <div class="text-sm text-blue-800">
                            <strong>UK CPD Compliance Requirements</strong>
                            <p class="mt-1">Before generating your ${outputName}, please confirm:</p>
                        </div>
                    </div>
                </div>

                <div class="space-y-3">
                    <label class="flex items-start space-x-3 cursor-pointer">
                        <input type="checkbox" class="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded compliance-checkbox" data-check="real-cases">
                        <div class="text-sm text-gray-700">
                            <strong>Real Cases Only:</strong> This output is based on my own experience with real patient cases, not hypothetical scenarios.
                        </div>
                    </label>

                    <label class="flex items-start space-x-3 cursor-pointer">
                        <input type="checkbox" class="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded compliance-checkbox" data-check="deidentified">
                        <div class="text-sm text-gray-700">
                            <strong>De-identification:</strong> All patient identifiers have been removed and content is appropriately anonymised.
                        </div>
                    </label>

                    <label class="flex items-start space-x-3 cursor-pointer">
                        <input type="checkbox" class="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded compliance-checkbox" data-check="accurate">
                        <div class="text-sm text-gray-700">
                            <strong>Accuracy:</strong> Content is accurate, not misleading, and opinions are not presented as fact.
                        </div>
                    </label>

                    <label class="flex items-start space-x-3 cursor-pointer">
                        <input type="checkbox" class="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded compliance-checkbox" data-check="ai-disclosure">
                        <div class="text-sm text-gray-700">
                            <strong>AI Disclosure:</strong> I consent to appropriate AI assistance disclosure being included in the output.
                        </div>
                    </label>
                </div>

                <div class="bg-amber-50 border border-amber-200 rounded-lg p-3">
                    <div class="flex items-start space-x-2 text-xs text-amber-800">
                        <i class="fa-solid fa-exclamation-triangle text-amber-600 mt-0.5"></i>
                        <div>
                            <strong>Professional Standards:</strong> This output supports but does not replace your professional judgment.
                            You remain responsible for all clinical decisions and professional conduct.
                        </div>
                    </div>
                </div>
            </div>
        `;

        showValidationModal(
            `🇬🇧 Generate ${outputName}`,
            complianceHTML,
            'Generate Output',
            function() {
                // Check all checkboxes are selected
                const checkboxes = document.querySelectorAll('.compliance-checkbox');
                const allChecked = Array.from(checkboxes).every(cb => cb.checked);

                if (!allChecked) {
                    showNotification("Compliance Required", "Please confirm all compliance requirements before proceeding.", "error", 4000);
                    return;
                }

                // All checks passed, proceed with generation
                performTask('validationmodal-dismiss');
                processCPDGeneration(outputType);
            },
            'Cancel',
            () => { performTask('validationmodal-dismiss'); }
        );

        // Disable the action button initially
        setTimeout(() => {
            const actionBtn = document.getElementById('validationmodal-actionbtn');
            if (actionBtn) {
                actionBtn.disabled = true;
                actionBtn.classList.add('opacity-50', 'cursor-not-allowed');

                // Enable button when all checkboxes are checked
                const checkboxes = document.querySelectorAll('.compliance-checkbox');
                checkboxes.forEach(checkbox => {
                    checkbox.addEventListener('change', () => {
                        const allChecked = Array.from(checkboxes).every(cb => cb.checked);
                        actionBtn.disabled = !allChecked;
                        if (allChecked) {
                            actionBtn.classList.remove('opacity-50', 'cursor-not-allowed');
                        } else {
                            actionBtn.classList.add('opacity-50', 'cursor-not-allowed');
                        }
                    });
                });
            }
        }, 100);
    }

    function processCPDGeneration(outputType) {
        console.log(`Processing CPD generation for: ${outputType}`);
        // Show date range selection modal instead of certificate selection
        showDateRangeSelectionModal(outputType);
    }

    function showDateRangeSelectionModal(outputType) {
        const outputNames = {
            'gmc-narrative': 'GMC Reflective Narrative',
            'cpd-log': 'CPD Log Entry',
            'pdp-objectives': 'PDP SMART Objectives',
            'appraisal-summary': 'Appraisal Summary',
            'capability-map': 'MRCGP Capability Map',
            'nmc-accounts': 'NMC Reflective Accounts',
            'nmc-discussion': 'NMC Discussion Summary',
            'nmc-cpd-hours': 'NMC CPD Hours Tracker',
            'nmc-feedback-guide': 'NMC Feedback Collection Guide'
        };
        const outputName = outputNames[outputType] || outputType;

        // Set default date range to last 12 months
        const endDate = new Date();
        const startDate = new Date();
        startDate.setFullYear(startDate.getFullYear() - 1);

        const formatDate = (date) => date.toISOString().split('T')[0];

        const selectionHTML = `
            <div class="space-y-4">
                <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-start space-x-2">
                        <i class="fa-solid fa-calendar text-blue-600 mt-0.5"></i>
                        <div class="text-sm text-blue-800">
                            <strong>Select Date Range</strong>
                            <p class="mt-1">Choose the time period for your reflections to include in this ${outputName}.</p>
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
                        <input type="date" id="cpdStartDate" value="${formatDate(startDate)}"
                               class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">End Date</label>
                        <input type="date" id="cpdEndDate" value="${formatDate(endDate)}"
                               class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                    </div>
                </div>
                <div class="bg-amber-50 border border-amber-200 rounded-lg p-3">
                    <div class="flex items-start space-x-2">
                        <i class="fa-solid fa-lightbulb text-amber-600 mt-0.5 text-xs"></i>
                        <p class="text-xs text-amber-800">All reflections within this date range will be analyzed for CPD compliance and professional development insights.</p>
                    </div>
                </div>
            </div>
        `;

        showValidationModal(
            `Generate ${outputName}`,
            selectionHTML,
            'Generate',
            function() {
                const startDate = document.getElementById('cpdStartDate').value;
                const endDate = document.getElementById('cpdEndDate').value;

                if (!startDate || !endDate) {
                    showNotification("Date Range Required", "Please select both start and end dates.", "error", 3000);
                    return;
                }

                if (new Date(startDate) >= new Date(endDate)) {
                    showNotification("Invalid Date Range", "Start date must be before end date.", "error", 3000);
                    return;
                }

                performTask('validationmodal-dismiss');
                generateCPDOutputWithDateRange(outputType, startDate, endDate);
            },
            'Cancel',
            () => { performTask('validationmodal-dismiss'); }
        );
    }

    function generateCPDOutputWithDateRange(outputType, startDate, endDate) {
        showLoadingOverlay("Loading your reflection data...");

        LoadCPDReflectionDataByDateRange(startDate, endDate, (cpdPayload) => {
            if (!cpdPayload) {
                hideLoadingOverlay();
                showNotification("Data Loading Error", "Could not load your reflection data. Please try again.", "error", 4000);
                return;
            }

            hideLoadingOverlay();
            showLoadingOverlay("Generating your CPD output...");

            // Generate the output using the loaded data
            const apiEndpoints = {
                'gmc-narrative': '/generate-cpd-gmc-narrative',
                'cpd-log': '/generate-cpd-log-entry',
                'pdp-objectives': '/generate-cpd-pdp-objectives',
                'appraisal-summary': '/generate-cpd-appraisal-summary',
                'capability-map': '/generate-cpd-capability-map',
                'nmc-accounts': '/generate-cpd-nmc-accounts',
                'nmc-discussion': '/generate-cpd-nmc-discussion',
                'nmc-cpd-hours': '/generate-cpd-nmc-hours',
                'nmc-feedback-guide': '/generate-cpd-nmc-feedback-guide'
            };

            const endpoint = apiEndpoints[outputType];
            if (!endpoint) {
                hideLoadingOverlay();
                showNotification("Generation Error", "CPD output type not supported yet.", "error", 4000);
                return;
            }

            // Post to the CPD generation endpoint
            axios.post(endpoint, cpdPayload)
                .then((response) => {
                    hideLoadingOverlay();
                    console.log("CPD generation response:", response.data);

                    if (response.data.error) {
                        showNotification("Generation Failed", response.data.message || "Unable to generate CPD output at this time", "error", 6000);
                        return;
                    }

                    // Save and display the generated output
                    saveCPDOutput(outputType, null, response.data, cpdPayload);
                })
                .catch((error) => {
                    hideLoadingOverlay();
                    console.error('Error generating CPD output:', error);

                    let errorMessage = "Unable to generate CPD output at this time";
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }

                    showNotification("Generation Error", errorMessage, "error", 6000);
                });
        });
    }

    function saveCPDOutput(outputType, certificateId, generatedContent, cpdPayload) {
        // Generate unique document ID for date range approach
        const docId = certificateId ? `${outputType}_${certificateId}` : `${outputType}_${Date.now()}`;

        const outputDoc = {
            outputType: outputType,
            certificateId: certificateId,
            dateRange: cpdPayload.dateRange || null,
            content: generatedContent.content || generatedContent,
            generatedAt: new Date().getTime(),
            complianceData: cpdPayload.complianceData,
            metadata: {
                totalReflections: cpdPayload.totalReflections,
                caseBasedReflections: cpdPayload.caseBasedReflections.length,
                thinqBitsIncluded: cpdPayload.thinqBits.length,
                userProfile: {
                    specialty: CURR_USERPROFILE?.primarySpecialty || 'Unknown',
                    location: CURR_USERPROFILE?.primaryLocation || 'Unknown'
                }
            }
        };

        // Save to Firebase cpd-outputs collection
        firebase.firestore().collection('cpd-outputs').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT).doc(docId).set(outputDoc)
            .then(() => {
                console.log("CPD output saved successfully");
            })
            .catch((error) => {
                console.warn("CPD output save failed (this is optional):", error.message);
            });

        // Always display the output regardless of save success/failure
        displayCPDOutput(outputType, generatedContent);
    }

    function displayCPDOutput(outputType, generatedContent) {
        const outputNames = {
            'gmc-narrative': 'GMC Reflective Narrative',
            'cpd-log': 'CPD Log Entry',
            'pdp-objectives': 'PDP SMART Objectives',
            'appraisal-summary': 'Appraisal Summary',
            'capability-map': 'MRCGP Capability Map',
            'nmc-accounts': 'NMC Reflective Accounts',
            'nmc-discussion': 'NMC Discussion Summary',
            'nmc-cpd-hours': 'NMC CPD Hours Tracker',
            'nmc-feedback-guide': 'NMC Feedback Collection Guide'
        };

        const outputName = outputNames[outputType] || outputType;
        const content = generatedContent.content || generatedContent;

        const outputHTML = `
            <div class="cpd-output-preview p-4 bg-gray-50 rounded-lg">
                <h3 class="font-semibold mb-3">${outputName}</h3>
                <div class="prose max-w-none text-gray-800 leading-relaxed bg-white p-4 rounded border">
                    ${parseMarkdownToHTML(content)}
                </div>

                <div class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded text-xs text-blue-800">
                    <strong>AI Assistance Disclosure:</strong> This document was generated with AI assistance from Learner+
                    and has been reviewed and approved by the healthcare professional.
                </div>
            </div>
        `;

        showValidationModal(
            `✅ ${outputName} Generated`,
            outputHTML,
            'Copy to Clipboard',
            () => {
                navigator.clipboard.writeText(document.querySelector('.cpd-output-preview').innerText).then(() => {
                    showNotification("Output Copied", "Your CPD output has been copied to clipboard.", "success", 3000);
                    performTask('validationmodal-dismiss');
                });
            },
            'Close',
            () => { performTask('validationmodal-dismiss'); }
        );
    }

    // CPD Data Loading Functions (Following narrative pattern)
    function LoadCPDReflectionDataByDateRange(startDate, endDate, callback) {
        console.log("Loading CPD data for date range:", startDate, "to", endDate);

        // Convert dates to timestamps for comparison
        const startTimestamp = new Date(startDate).getTime();
        const endTimestamp = new Date(endDate + 'T23:59:59').getTime(); // End of day

        const cpdPayload = {
            dateRange: { startDate, endDate },
            reflectivePracticeData: [],
            reflectiveThinkingData: [],
            caseBasedReflections: [],
            totalReflections: 0,
            clinicalKeywords: [],
            impacts: [],
            thinqBits: [],
            complianceData: {
                userAttestation: new Date().getTime(),
                deidentificationConfirmed: true,
                aiAssistanceDisclosed: true
            }
        };

        // Load reflective-practice data within date range
        firebase.firestore().collection('reflections').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT)
            .where("reflectedOn", ">=", startTimestamp)
            .where("reflectedOn", "<=", endTimestamp)
            .orderBy("reflectedOn", "desc")
            .get()
            .then((docSnapshot) => {
                console.log("Found", docSnapshot.docs.length, "reflections in date range");

                docSnapshot.docs.forEach((doc) => {
                    const reflectionData = doc.data();

                    // Add to general reflective practice data
                    cpdPayload.reflectivePracticeData.push({
                        keyword: reflectionData.ipoc_keyword,
                        context: reflectionData.ipoc_context,
                        initialReflection: reflectionData.reflection_initial,
                        deeperReflection: reflectionData.reflection_deeper,
                        learningPathways: reflectionData.validation_deeper?.learning_pathways || [],
                        impacts: [...new Set((reflectionData.validation_initial?.impact_detection || [])
                            .concat(reflectionData.validation_deeper?.impact_detection || []))],
                        keywords: [...new Set((reflectionData.validation_initial?.extracted_keywords || [])
                            .concat(reflectionData.validation_deeper?.extracted_keywords || []))],
                        reflectedOn: reflectionData.reflectedOn
                    });

                    // Extract case-based reflections (those with clinical contexts)
                    if (reflectionData.ipoc_context &&
                        ['Case', 'Patient Care', 'Clinical Decision', 'Diagnosis', 'Treatment', 'Ward Round', 'Clinic'].includes(reflectionData.ipoc_context)) {
                        cpdPayload.caseBasedReflections.push({
                            keyword: reflectionData.ipoc_keyword,
                            context: reflectionData.ipoc_context,
                            reflection: reflectionData.reflection_deeper || reflectionData.reflection_initial,
                            impacts: reflectionData.validation_deeper?.impact_detection || [],
                            ceAssessment: reflectionData.ce_assessment || {}
                        });
                    }

                    // Aggregate data
                    cpdPayload.totalReflections++;
                    cpdPayload.clinicalKeywords = cpdPayload.clinicalKeywords.concat(
                        (reflectionData.validation_initial?.extracted_keywords || []).map(x => x.toLowerCase())
                    );
                    cpdPayload.impacts = cpdPayload.impacts.concat(
                        (reflectionData.validation_initial?.impact_detection || []).map(x => x.toLowerCase())
                    );
                });

                // Load reflective-thinking datapoints (ThinqBits) within date range - optional
                console.log("Attempting to load reflective-thinking data for date range...");

                firebase.firestore().collection('reflections').doc(CURR_USER.uid).collection('reflective-thinking')
                    .where("created_at", ">=", startTimestamp)
                    .where("created_at", "<=", endTimestamp)
                    .orderBy('created_at', 'desc')
                    .get()
                    .then((thinkingSnapshot) => {
                        console.log("Reflective thinking data loaded:", thinkingSnapshot.docs.length, "documents");

                        thinkingSnapshot.docs.forEach((thinkingDoc) => {
                            const thinkingData = thinkingDoc.data();

                            if (thinkingData.thinqbits && thinkingData.thinqbits.length > 0) {
                                cpdPayload.reflectiveThinkingData.push({
                                    gist: thinkingData.gist,
                                    thinqbits: thinkingData.thinqbits,
                                    context: thinkingData.context || 'General',
                                    createdAt: thinkingData.created_at
                                });

                                // Extract ThinqBits for analysis
                                thinkingData.thinqbits.forEach(tb => {
                                    cpdPayload.thinqBits.push({
                                        category: tb.category,
                                        insight: tb.insight,
                                        evidence: tb.evidence || '',
                                        context: thinkingData.context
                                    });
                                });
                            }
                        });

                        console.log("CPD payload loaded with thinking data:", cpdPayload);
                        callback(cpdPayload);
                    })
                    .catch((error) => {
                        console.warn("Reflective thinking data unavailable (this is optional):", error.message);
                        console.log("CPD payload loaded without thinking data:", cpdPayload);
                        callback(cpdPayload);
                    });
            })
            .catch((error) => {
                console.error("Error loading reflective practice data:", error);
                callback(false);
            });
    }

    function LoadCPDReflectionData(certificateId, callback) {
        console.log("Loading CPD data for certificate:", certificateId);

        GetCertificateResponseIdForMatching(certificateId, (certificateResponseId) => {
            if (!certificateResponseId) {
                console.error("No certificate response ID found");
                return callback(false);
            }

            const cpdPayload = {
                certificateId: certificateId,
                certificateResponseId: certificateResponseId,
                reflectivePracticeData: [],
                reflectiveThinkingData: [],
                caseBasedReflections: [],
                totalReflections: 0,
                clinicalKeywords: [],
                impacts: [],
                thinqBits: [],
                complianceData: {
                    userAttestation: new Date().getTime(),
                    deidentificationConfirmed: true,
                    aiAssistanceDisclosed: true
                }
            };

            // Load reflective-practice data with ipoc_context (case-related insights)
            firebase.firestore().collection('reflections').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT)
                .where("certificate.response_id", "==", certificateResponseId).get()
                .then((docSnapshot) => {
                    docSnapshot.docs.forEach((doc) => {
                        const reflectionData = doc.data();

                        // Add to general reflective practice data
                        cpdPayload.reflectivePracticeData.push({
                            keyword: reflectionData.ipoc_keyword,
                            context: reflectionData.ipoc_context,
                            initialReflection: reflectionData.reflection_initial,
                            deeperReflection: reflectionData.reflection_deeper,
                            learningPathways: reflectionData.validation_deeper?.learning_pathways || [],
                            impacts: [...new Set((reflectionData.validation_initial?.impact_detection || [])
                                .concat(reflectionData.validation_deeper?.impact_detection || []))],
                            keywords: [...new Set((reflectionData.validation_initial?.extracted_keywords || [])
                                .concat(reflectionData.validation_deeper?.extracted_keywords || []))],
                            reflectedOn: reflectionData.reflectedOn
                        });

                        // Extract case-based reflections (those with clinical contexts)
                        if (reflectionData.ipoc_context &&
                            ['Case', 'Patient Care', 'Clinical Decision', 'Diagnosis', 'Treatment', 'Ward Round', 'Clinic'].includes(reflectionData.ipoc_context)) {
                            cpdPayload.caseBasedReflections.push({
                                keyword: reflectionData.ipoc_keyword,
                                context: reflectionData.ipoc_context,
                                reflection: reflectionData.reflection_deeper || reflectionData.reflection_initial,
                                impacts: reflectionData.validation_deeper?.impact_detection || [],
                                ceAssessment: reflectionData.ce_assessment || {}
                            });
                        }

                        // Aggregate data
                        cpdPayload.totalReflections++;
                        cpdPayload.clinicalKeywords = cpdPayload.clinicalKeywords.concat(
                            (reflectionData.validation_initial?.extracted_keywords || []).map(x => x.toLowerCase())
                        );
                        cpdPayload.impacts = cpdPayload.impacts.concat(
                            (reflectionData.validation_initial?.impact_detection || []).map(x => x.toLowerCase())
                        );
                    });

                    // Load reflective-thinking datapoints (ThinqBits) - optional
                    // Note: This collection may not exist or have permission issues, so we make it optional
                    console.log("Attempting to load reflective-thinking data...");

                    firebase.firestore().collection('reflective-thinking').doc(CURR_USER.uid).collection('insights')
                        .orderBy('created_at', 'desc').limit(50).get()
                        .then((thinkingSnapshot) => {
                            console.log("Reflective thinking data loaded:", thinkingSnapshot.docs.length, "documents");

                            thinkingSnapshot.docs.forEach((thinkingDoc) => {
                                const thinkingData = thinkingDoc.data();

                                if (thinkingData.thinqbits && thinkingData.thinqbits.length > 0) {
                                    cpdPayload.reflectiveThinkingData.push({
                                        gist: thinkingData.gist,
                                        thinqbits: thinkingData.thinqbits,
                                        context: thinkingData.context || 'General',
                                        createdAt: thinkingData.created_at
                                    });

                                    // Extract ThinqBits for analysis
                                    thinkingData.thinqbits.forEach(tb => {
                                        cpdPayload.thinqBits.push({
                                            category: tb.category,
                                            insight: tb.insight,
                                            evidence: tb.evidence || '',
                                            context: thinkingData.context
                                        });
                                    });
                                }
                            });

                            console.log("CPD payload loaded with thinking data:", cpdPayload);
                            callback(cpdPayload);
                        })
                        .catch((error) => {
                            console.warn("Reflective thinking data unavailable (this is optional):", error.message);
                            console.log("CPD payload loaded without thinking data:", cpdPayload);
                            // Still return data without thinking insights - this is fine
                            callback(cpdPayload);
                        });
                })
                .catch((error) => {
                    console.error("Error loading reflective practice data:", error);
                    callback(false);
                });
        });
    }

    // Function to get certificate response ID (following existing pattern)
    function GetCertificateResponseIdForMatching(certificateId, callback) {
        console.log("Looking for certificate:", certificateId, "for user:", CURR_USER.uid, "in reflectionKit:", CURR_REFLECTIONKIT);

        firebase.firestore().collection('certificates').doc(CURR_USER.uid).collection(CURR_REFLECTIONKIT).doc(certificateId).get()
            .then((doc) => {
                if (doc.exists) {
                    console.log("Certificate data:", doc.data());
                    const certData = doc.data();

                    // Following the existing pattern from learnerplus-profile.js line 970
                    const responseId = certData.evaluation?.response_id || certData.response_id || certData.responseId;

                    if (responseId) {
                        console.log("Found response ID:", responseId);
                        callback(responseId);
                    } else {
                        console.error("Certificate exists but no response_id field found. Available fields:", Object.keys(certData));
                        console.error("Evaluation object:", certData.evaluation);
                        callback(false);
                    }
                } else {
                    console.error("Certificate document not found for ID:", certificateId);
                    console.log("Full path:", `certificates/${CURR_USER.uid}/${CURR_REFLECTIONKIT}/${certificateId}`);
                    callback(false);
                }
            })
            .catch((error) => {
                console.error("Error getting certificate:", error);
                callback(false);
            });
    }

    // Helper function to generate certificate card HTML
    function generateCertificateCard(cert, claimedDate) {
        console.log('Creating certificate buttons for cert:', cert.certificateId, cert);
        
        return `
            <div class="border border-gray-200 rounded-lg p-3 mb-3 hover:shadow-sm transition-shadow">
                <div class="flex items-center justify-between">
                    <div class="flex-1">
                        <div class="flex items-center mb-1">
                            <i class="fa-solid fa-certificate text-blue-500 mr-2"></i>
                            <span class="text-sm font-medium text-gray-900">${cert.creditCount}.0 Credits</span>
                        </div>
                        <p class="text-xs text-gray-500">${claimedDate}</p>
                    </div>
                    <div class="flex space-x-2">
                        <button class="text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded transition-colors ui-action-btn" data-task="generate-certificate::${cert.certificateId}" title="Download Certificate">
                            <i class="fa-solid fa-download"></i>
                        </button>
                        <button class="text-xs bg-blue-100 hover:bg-blue-200 text-blue-600 px-2 py-1 rounded transition-colors ui-action-btn" data-task="launch-transcript::${cert.certificateId}" title="View Transcript">
                            <i class="fa-solid fa-file-lines"></i>
                        </button>
                    </div>
                </div>
            </div>`;
    }

    // Certificate accordion toggle functionality
    window.toggleCertificateAccordion = function(sectionId) {
        const content = document.getElementById(sectionId + '-content');
        const icon = document.getElementById(sectionId + '-icon');
        
        if (!content || !icon) return;
        
        const isHidden = content.classList.contains('hidden');
        
        if (isHidden) {
            // Expand
            content.classList.remove('hidden');
            icon.style.transform = 'rotate(180deg)';
        } else {
            // Collapse
            content.classList.add('hidden');
            icon.style.transform = 'rotate(0deg)';
        }
    };

    // Narrative accordion toggle functionality
    window.toggleNarrativeAccordion = function(sectionId) {
        const content = document.getElementById(sectionId + '-content');
        const icon = document.getElementById(sectionId + '-icon');
        
        if (!content || !icon) return;
        
        const isHidden = content.classList.contains('hidden');
        
        if (isHidden) {
            // Expand
            content.classList.remove('hidden');
            icon.style.transform = 'rotate(180deg)';
        } else {
            // Collapse
            content.classList.add('hidden');
            icon.style.transform = 'rotate(0deg)';
        }
    };

    // Alerts Feed Panel functionality
    const toggleAlertsFeed = function() {
        const panel = document.getElementById('alertsFeedPanel');
        const overlay = document.getElementById('alertsFeedOverlay');
        
        if (panel.classList.contains('translate-x-full')) {
            // Opening panel - populate with content
            populateAlertsFeed();
            panel.classList.remove('translate-x-full');
            panel.classList.add('translate-x-0');
            overlay.classList.remove('opacity-0', 'pointer-events-none');
            overlay.classList.add('opacity-100');
            MP.track('Alerts Panel Opened', {});
        } else {
            panel.classList.remove('translate-x-0');
            panel.classList.add('translate-x-full');
            overlay.classList.remove('opacity-100');
            overlay.classList.add('opacity-0', 'pointer-events-none');
            MP.track('Alerts Panel Closed', {});
        }
    }

    function populateAlertsFeed() {
        const alertsContent = document.getElementById('alertsFeedContent');
        if (!alertsContent) {
            console.warn("Alerts feed content container not found");
            return;
        }

        let alertsHtml = '';

        // Smart nudges now handled by DSIB Smart Panel only
        // Add prompt to use DSIB if user has nudges
        if (CURR_SMART_NUDGES && CURR_SMART_NUDGES.length > 0) {
            const activeNudges = CURR_SMART_NUDGES.filter(nudge => 
                nudge.status !== 'reflected'
            );
            
            if (activeNudges.length > 0) {
                alertsHtml += `
                    <div class="mb-4 border border-blue-200 rounded-lg bg-blue-50 p-4">
                        <div class="flex items-center space-x-3">
                            <i class="fa-solid fa-lightbulb text-blue-600"></i>
                            <div class="flex-1">
                                <h3 class="text-sm font-semibold text-blue-900 mb-1">
                                    ${activeNudges.length} insights waiting for you
                                </h3>
                                <p class="text-xs text-blue-700 mb-2">
                                    Click the insight button below to view personalized nudges and progress
                                </p>
                                <div class="flex items-center text-xs text-blue-600">
                                    <i class="fa-solid fa-arrow-down mr-1"></i>
                                    <span>Look for the smart button at the bottom of your screen</span>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }
        }

        // Additional alerts can be added here
        alertsHtml += `
            <div class="mb-6">
                <h3 class="text-sm font-semibold text-gray-900 mb-3 flex items-center">
                    <i class="fa-solid fa-bell text-blue-500 mr-2"></i>
                    System Alerts
                </h3>
                <div class="text-center text-gray-500 py-4">
                    <i class="fa-solid fa-bell-slash text-xl mb-2"></i>
                    <p class="text-sm">No system alerts at this time</p>
                    <p class="text-xs text-gray-400 mt-1">Other alerts will appear here</p>
                </div>
            </div>
        `;

        alertsContent.innerHTML = alertsHtml;
    }

    // Accordion toggle functionality for alerts feed
    function toggleAccordion(accordionId) {
        const accordion = document.getElementById(accordionId);
        const icon = document.getElementById(accordionId + '-icon');
        
        if (!accordion || !icon) {
            console.warn(`Accordion elements not found: ${accordionId}`);
            return;
        }
        
        const isOpen = accordion.style.maxHeight && accordion.style.maxHeight !== '0px';
        
        if (isOpen) {
            // Close accordion
            accordion.style.maxHeight = '0px';
            icon.classList.remove('fa-chevron-up');
            icon.classList.add('fa-chevron-down');
            icon.style.transform = 'rotate(0deg)';
        } else {
            // Open accordion
            accordion.style.maxHeight = accordion.scrollHeight + 'px';
            icon.classList.remove('fa-chevron-down');
            icon.classList.add('fa-chevron-up');
            icon.style.transform = 'rotate(180deg)';
        }
    }

    // Smart Nudges System

    function fetchSmartNudges(callback) {
        console.log("Fetching smart nudges from Firebase for user:", CURR_USER ? CURR_USER.uid : 'no user');
        
        if (!CURR_USER || !CURR_USER.uid) {
            console.warn('No authenticated user, returning empty nudges array');
            setTimeout(() => callback([]), 100);
            return;
        }
        
        let allNudges = [];
        let completedRequests = 0;
        const totalRequests = 2; // inbox + snoozed
        
        function combineAndCallback() {
            completedRequests++;
            if (completedRequests === totalRequests) {
                // Sort nudges by priority (inbox > snoozed)
                allNudges.sort((a, b) => {
                    const priority = { inbox: 3, snoozed: 2, trending: 1 };
                    return priority[b.type] - priority[a.type];
                });
                
                console.log(`Combined ${allNudges.length} total Firebase nudges (inbox + snoozed)`);
                callback(allNudges);
            }
        }
        
        // Add timeout protection (fallback after 5 seconds)
        const timeoutId = setTimeout(() => {
            if (completedRequests < totalRequests) {
                console.warn('Firebase nudge fetch timed out, using available data');
                while (completedRequests < totalRequests) {
                    combineAndCallback();
                }
            }
        }, 5000);
        
        // Fetch inbox nudges
        fetchInboxNudges((inboxNudges) => {
            allNudges = allNudges.concat(inboxNudges);
            combineAndCallback();
            if (completedRequests === totalRequests) clearTimeout(timeoutId);
        });
        
        // Fetch snoozed nudges (that are ready to be shown)
        fetchSnoozedNudges((snoozedNudges) => {
            allNudges = allNudges.concat(snoozedNudges);
            combineAndCallback();
            if (completedRequests === totalRequests) clearTimeout(timeoutId);
        });
    }

    function truncateContent(content, maxLength = 36) {
        if (content.length <= maxLength) {
            return content;
        }
        return content.substring(0, maxLength).trim() + '...';
    }

    function renderSmartNudges(nudgesArray) {
        // Smart nudges are now handled by DSIB Smart Panel
        // This function only updates the data store
        
        if (!nudgesArray || nudgesArray.length === 0) {
            CURR_SMART_NUDGES = [];
            window.CURR_SMART_NUDGES = CURR_SMART_NUDGES;
            console.log("No smart nudges to process");
            
            // Update DSIB badge count
            updateDSIBBadgeCount();
            return;
        }

        // Sort nudges by priority
        const sortedNudges = nudgesArray.sort((a, b) => a.priority - b.priority);

        // Store all nudges in module scope and update global reference
        CURR_SMART_NUDGES = sortedNudges;
        window.CURR_SMART_NUDGES = CURR_SMART_NUDGES;
        
        console.log('Firebase: Updated CURR_SMART_NUDGES with data:', sortedNudges.length, sortedNudges);
        
        // Update DSIB badge count with new nudge data
        console.log('Firebase: Updating DSIB badge with new nudge data');
        updateDSIBBadgeCount();

        console.log(`Updated ${sortedNudges.length} smart nudges for DSIB Smart Panel`);
    }

    function initSmartNudges() {
        return new Promise((resolve, reject) => {
            // Start with hidden container - only show when we have nudges
            const container = document.getElementById('smartnudges');
            if (container) {
                container.innerHTML = '';
                container.classList.add('hidden');
            }
            
            // Only fetch nudges if user is authenticated
            if (!CURR_USER || !CURR_USER.uid) {
                console.log('Skipping smart nudges init - no authenticated user');
                resolve([]);
                return;
            }
            
            fetchSmartNudges((nudges) => {
            if (nudges && nudges.length > 0) {
                renderSmartNudges(nudges);
            } else {
                // Hide when no nudges - keep section empty by default
                if (container) {
                    container.innerHTML = '';
                    container.classList.add('hidden');
                }
            }
            resolve(nudges);
            });
        });
    }

    function handleSmartNudgeClick(nudgeId) {
        console.log("Smart nudge clicked:", nudgeId);
        
        // Close alerts panel if it's open (nudge clicked from alerts feed)
        const alertsPanel = document.getElementById('alertsFeedPanel');
        if (alertsPanel && !alertsPanel.classList.contains('translate-x-full')) {
            console.log("Closing alerts panel before nudge action");
            toggleAlertsFeed();
        }
        
        // Check if processing is already active
        const sparkForm = document.getElementById('liminal-spark-form');
        if (sparkForm && sparkForm.classList.contains('liminal-processing')) {
            showNotification('Processing', 'Please wait for current analysis to complete', 'warning', 3000);
            return;
        }
        
        // Find the nudge data from the current smart nudges
        let nudge = null;
        if (CURR_SMART_NUDGES) {
            nudge = CURR_SMART_NUDGES.find(n => n.nudge_id === nudgeId);
        }
        
        if (nudge) {
            // Analytics for nudge engagement
            if (typeof mixpanel !== 'undefined') {
                const trackingData = {
                    nudge_id: nudgeId,
                    nudge_type: nudge.type || 'unknown',
                    source_name: nudge.source_name || 'unknown',
                    content_preview: nudge.content ? nudge.content.substring(0, 50) : '',
                    auto_ipoc: nudge.auto_ipoc ? 'true' : 'false'
                };
                
                // Add tracking_id if available (for backward compatibility)
                if (nudge.tracking_id) {
                    trackingData.tracking_id = nudge.tracking_id;
                }
                
                mixpanel.track('Smart Nudge Clicked', trackingData);

                // Track overall nudge engagement pattern
                mixpanel.track('DSIB Nudge Engagement', {
                    nudge_type: 'regular',
                    engagement_action: 'clicked',
                    panel_context: nudge.is_inbox ? 'recommended_section' : 'snoozed_section'
                });
            }
            
            // Note: Nudge status will be updated to "used" by other app events
            // This ensures nudges are only shown when they haven't been used yet
            
            // Show informational modal first, then route based on auto_ipoc
            showNudgeContextModal(nudge);
        } else {
            console.error("Nudge not found:", nudgeId);
            showNotification('Error', 'Nudge data not found', 'error', 3000);
        }
    }
    
    // Expose for DSIB Smart Panel integration
    window.handleSmartNudgeClick = handleSmartNudgeClick;
    window.handleGistContinuation = handleGistContinuation;

    
    function launchReflectivePracticeWithContext(ipocContext, nudgeContent, trackingId = null, ipocKeyword = null) {
        // Launch reflective practice directly with the ipoc context (like "reflect for credit" buttons)
        console.log('Launching reflective practice with IPOC context:', ipocContext);
        
        // Track the action
        if (typeof mixpanel !== 'undefined') {
            mixpanel.track('Direct Reflective Practice Launch', {
                ipoc_context: ipocContext,
                ipoc_keyword: ipocKeyword,
                tracking_id: trackingId,
                source: 'smart_nudge',
                content_preview: nudgeContent ? nudgeContent.substring(0, 50) : ''
            });
        }
        
        // Use the enhanced showReflectivePracticePanel function
        showReflectivePracticePanel(ipocKeyword, ipocContext, trackingId);
    }
    
    function populateSparkAndTriggerAnalysis(content) {
        // Default flow: populate liminal spark textarea and trigger analysis
        console.log('Populating spark text and triggering analysis');
        
        const sparkTextarea = document.getElementById('liminal_spark');
        const startButton = document.getElementById('start-button');
        
        if (!sparkTextarea) {
            console.error('Liminal spark textarea not found');
            showNotification('Error', 'Cannot populate spark text', 'error', 3000);
            return;
        }
        
        // Populate the textarea with nudge content
        sparkTextarea.value = content;
        
        // Focus the textarea to show the populated content
        sparkTextarea.focus();
        
        // Auto-resize textarea if needed
        if (typeof adjustTextareaHeight === 'function') {
            adjustTextareaHeight();
        }
        
        // Trigger the analysis automatically after a brief moment
        setTimeout(() => {
            if (startButton && !startButton.disabled) {
                console.log('Auto-triggering spark analysis');
                startButton.click();
            } else {
                console.warn('Start button not available for auto-trigger');
            }
        }, 500);
    }

    function showNudgeContextModal(nudge) {
        console.log('showNudgeContextModal called with nudge:', nudge);
        
        // Close DSIB panel when showing confirmation modal
        const dsibPanel = document.getElementById('dsib-panel');
        const dsibOverlay = document.getElementById('dsib-overlay');
        if (dsibPanel) {
            dsibPanel.classList.remove('show');
            dsibPanel.classList.add('hidden');
        }
        if (dsibOverlay) {
            dsibOverlay.classList.remove('show');
            dsibOverlay.classList.add('hidden');
        }
        
        // Check if this is a gist continuation item
        const isGistContinuation = nudge.type === 'gist_continuation';
        console.log('Is gist continuation:', isGistContinuation);
        
        // Determine the flow type and appropriate messaging
        const isDirectReflectiveFlow = nudge.auto_ipoc && typeof nudge.auto_ipoc === 'string' && nudge.auto_ipoc.trim() !== '';
        
        let actionDescription, actionButtonText, actionButtonClass;
        
        if (isGistContinuation) {
            actionDescription = 'This will resume your saved draft with full context';
            actionButtonText = 'Continue Draft';
            actionButtonClass = 'bg-blue-600 hover:bg-blue-700';
        } else if (isDirectReflectiveFlow) {
            actionDescription = 'This will launch Reflective Practice™';
            actionButtonText = 'Start Practice';
            actionButtonClass = 'bg-purple-600 hover:bg-purple-700';
        } else {
            actionDescription = 'This will analyze for reflective opportunities and guidance';
            actionButtonText = 'Analyze';
            actionButtonClass = 'bg-teal-600 hover:bg-teal-700';
        }
        
        // Create contextual information based on nudge type
        let contextInfo;
        if (isGistContinuation) {
            const ipocCount = nudge.clarity_context?.ipoc_keywords?.length || 0;
            contextInfo = ipocCount > 0 
                ? `Saved reflection • ${ipocCount} credit ${ipocCount === 1 ? 'opportunity' : 'opportunities'}` 
                : 'Saved reflection';
        } else if (nudge.is_inbox && nudge.source_name) {
            contextInfo = `From ${nudge.source_name}`;
        } else if (nudge.is_snoozed) {
            contextInfo = 'Saved for later';
        } else {
            contextInfo = 'From System';
        }
        
        const contextHtml = `
            <div class="text-left space-y-3">
                <div>
                    <h3 class="text-base font-regular text-gray-900 mb-2">${nudge.content}</h3>
                    <p class="text-sm text-gray-600">${actionDescription}</p>
                </div>
                
                <p class="text-xs text-gray-500">${contextInfo}</p>
                
                <div class="pt-2">
                    <button type="button" class="ui-action-btn text-xs text-gray-400 hover:text-red-500 transition-colors" 
                            data-task="delete-nudge::${nudge.nudge_id}" title="Delete">
                        Delete me
                    </button>
                </div>
            </div>
        `;

        showValidationModal(
            isGistContinuation ? "Saved Draft" : "Reflection Nudge",
            contextHtml,
            actionButtonText,
            () => {
                console.log('Smart nudge confirmation clicked - starting action');
                
                // Dismiss modal first
                performTask('validationmodal-dismiss');
                
                // Route to appropriate flow based on nudge type
                if (isGistContinuation) {
                    // Resume the saved draft after a small delay
                    setTimeout(() => {
                        handleGistContinuation(nudge.nudge_id);
                    }, 200);
                } else if (isDirectReflectiveFlow) {
                    // Use auto_ipoc as context and content as keyword
                    const ipocContext = nudge.auto_ipoc; // This should be "Safety Meeting"
                    const ipocKeyword = nudge.content; // This is the actual keyword/topic
                    const trackingId = nudge.tracking_id || `nudge_${nudge.nudge_id}_${Date.now()}`;
                    
                    launchReflectivePracticeWithContext(ipocContext, nudge.content, trackingId, ipocKeyword);
                } else {
                    populateSparkAndTriggerAnalysis(nudge.content);
                }
            },
            "Cancel",
            null
        );
    }

    function handleDeleteNudge(nudgeId) {
        // First close the original nudge modal
        performTask('validationmodal-dismiss');
        
        // Show confirmation dialog 
        setTimeout(() => {
            showValidationModal(
                "Delete?",
                `<div class="text-left">
                    <div class="flex items-start space-x-3">
                        <div class="flex-shrink-0">
                            <i class="fa-solid fa-exclamation-triangle text-amber-500 text-lg"></i>
                        </div>
                        <div class="flex-1">
                            <p class="text-sm text-gray-700">Are you sure you want to delete this nudge?</p>
                            <p class="text-xs text-gray-500 mt-1">This will remove it from your feed permanently.</p>
                        </div>
                    </div>
                </div>`,
                "Delete",
                () => {
                    // Close confirmation modal
                    performTask('validationmodal-dismiss');
                    
                    // Find and delete the nudge from Firebase
                    deleteNudgeFromFirebase(nudgeId);
                    
                    // Remove from UI immediately for better UX
                    removeNudgeFromUI(nudgeId);
                    
                    showNotification('Deleted!', 'The smart nudge has been removed', 'success', 2000);
                },
                "Cancel",
                null
            );
        }, 100);
    }

    function deleteNudgeFromFirebase(nudgeId) {
        if (!CURR_USER || !CURR_USER.uid) {
            console.error('No authenticated user for nudge deletion');
            showNotification('Authentication Error', 'Please log in to delete nudges', 'error', 3000);
            return;
        }
        
        console.log('Deleting nudge from Firestore:', nudgeId, 'User:', CURR_USER.uid);
        
        // Find the nudge in the current loaded nudges to determine its type
        const nudge = CURR_SMART_NUDGES ? CURR_SMART_NUDGES.find(n => n.nudge_id === nudgeId) : null;
        console.log('Found nudge in memory:', nudge);
        
        const isInboxNudge = nudge && nudge.is_inbox;
        const isSnoozedNudge = nudge && nudge.is_snoozed;
        
        console.log('Nudge type detection:', { isInboxNudge, isSnoozedNudge, nudgeType: nudge?.type });
        
        const db = firebase.firestore();
        const userNudgesRef = db.collection('smartnudges').doc(CURR_USER.uid);
        
        console.log('Will delete document completely from Firestore');
        
        // Try the most likely collection first based on nudge type
        let primaryRef, secondaryRef, primaryType, secondaryType;
        
        if (isInboxNudge) {
            primaryRef = userNudgesRef.collection('inbox').doc(nudgeId);
            secondaryRef = userNudgesRef.collection('snoozed').doc(nudgeId);
            primaryType = 'inbox';
            secondaryType = 'snoozed';
        } else if (isSnoozedNudge) {
            primaryRef = userNudgesRef.collection('snoozed').doc(nudgeId);
            secondaryRef = userNudgesRef.collection('inbox').doc(nudgeId);
            primaryType = 'snoozed';
            secondaryType = 'inbox';
        } else {
            // Unknown type, try inbox first
            primaryRef = userNudgesRef.collection('inbox').doc(nudgeId);
            secondaryRef = userNudgesRef.collection('snoozed').doc(nudgeId);
            primaryType = 'inbox';
            secondaryType = 'snoozed';
        }
        
        console.log(`Trying ${primaryType} first, fallback to ${secondaryType}`);
        console.log('Primary path:', primaryRef.path);
        
        // Try primary location first - DELETE the document
        primaryRef.delete()
            .then(() => {
                console.log(`✅ Successfully DELETED nudge from ${primaryType}:`, nudgeId);
                showNotification('Success', 'Nudge deleted successfully', 'success', 2000);
            })
            .catch((primaryError) => {
                console.log(`❌ Not found in ${primaryType}, trying ${secondaryType}:`, primaryError.code, primaryError.message);
                
                // Try secondary location - DELETE the document
                secondaryRef.delete()
                    .then(() => {
                        console.log(`✅ Successfully DELETED nudge from ${secondaryType}:`, nudgeId);
                        showNotification('Success', 'Nudge deleted successfully', 'success', 2000);
                    })
                    .catch((secondaryError) => {
                        console.error(`❌ Error deleting nudge from both locations:`, {
                            primary: { code: primaryError.code, message: primaryError.message },
                            secondary: { code: secondaryError.code, message: secondaryError.message }
                        });
                        
                        // More specific error messages
                        let errorMsg = 'Could not delete nudge';
                        if (primaryError.code === 'permission-denied' || secondaryError.code === 'permission-denied') {
                            errorMsg = 'Permission denied - check authentication';
                        } else if (primaryError.code === 'not-found' && secondaryError.code === 'not-found') {
                            errorMsg = 'Nudge not found in database';
                        }
                        
                        showNotification('Delete Error', errorMsg, 'error', 5000);
                    });
            });
    }

    function removeNudgeFromUI(nudgeId) {
        console.log('🔄 Removing nudge from UI:', nudgeId);
        
        // Remove from current smart nudges array
        if (CURR_SMART_NUDGES) {
            const originalCount = CURR_SMART_NUDGES.length;
            CURR_SMART_NUDGES = CURR_SMART_NUDGES.filter(n => n.nudge_id !== nudgeId);
            const newCount = CURR_SMART_NUDGES.length;
            
            console.log(`📊 Nudges count: ${originalCount} → ${newCount}`);
            
            if (originalCount === newCount) {
                console.warn('⚠️ Nudge was not found in CURR_SMART_NUDGES array');
            }
            
            // Re-render the smart nudges section
            console.log('🔄 Re-rendering smart nudges with', newCount, 'nudges');
            renderSmartNudges(CURR_SMART_NUDGES);
        } else {
            console.warn('⚠️ CURR_SMART_NUDGES is not available');
        }
        
        // Update alerts feed as well
        console.log('🔄 Updating alerts feed');
        populateAlertsFeed();
        
        // Refresh DSIB panel to reflect nudge deletion
        if (typeof window !== 'undefined' && window.dsibComponent && typeof window.dsibComponent.refreshPanelNudges === 'function') {
            console.log('🔄 Refreshing DSIB panel nudges after deletion');
            window.dsibComponent.refreshPanelNudges();
        } else {
            console.warn('⚠️ DSIB component or refreshPanelNudges method not available');
        }
    }


    // Handler functions for liminal action buttons
    function handleReflectNow() {
        console.log("Reflect Now clicked - launching Reflective Practice");
        console.log("Available IPOC keywords:", CURR_CLARITY_RESULTS?.ipoc_keywords);
        
        // Close the modal first
        hideLiminalModal();
        
        // Check if we have IPOC keywords to work with
        if (CURR_CLARITY_RESULTS?.ipoc_keywords && CURR_CLARITY_RESULTS.ipoc_keywords.length > 0) {
            // Use the first keyword as the primary focus
            const primaryKeyword = CURR_CLARITY_RESULTS.ipoc_keywords[0];
            
            // Generate tracking ID for this reflection opportunity
            const trackingId = `reflect_now_${Date.now()}_${primaryKeyword.replace(/\s+/g, '_').toLowerCase()}`;
            
            // Check for gist conditions (same logic as handleReflectOnKeyword for consistency)
            let gistToPass = null;
            if (CURR_CLARITY_RESULTS.gist && CURR_CLARITY_RESULTS.intent === 'learning_capture') {
                const gist = CURR_CLARITY_RESULTS.gist.trim();
                const wordCount = gist.split(/\s+/).filter(word => word.length > 0).length;
                
                if (wordCount >= 12) {
                    // Convert to first person for reflection
                    gistToPass = convertToFirstPerson(gist);
                    console.log(`[REFLECT NOW] Gist meets criteria (${wordCount} words), converted to first person for reflection`);
                } else {
                    console.log(`[REFLECT NOW] Gist too short (${wordCount} words) - need 12+ words`);
                }
            } else {
                console.log(`[REFLECT NOW] No gist conditions met`);
            }
            
            // Show the reflective practice panel
            console.log(`[REFLECT NOW] Calling showReflectivePracticePanel with: keyword="${primaryKeyword}", gist=${gistToPass ? 'YES' : 'NO'}`);
            // we're actually not going to send the gist, so lets force that false/null
            gistToPass = null;
            console.log(`[REFLECT NOW] Forcing gistToPass to null for now`);
            showReflectivePracticePanel(primaryKeyword, "Reflective Learning Moment", trackingId, gistToPass);
        } else {
            // Fallback if no keywords available - launch general reflection
            console.log(`[REFLECT NOW] No IPOC keywords available - launching general reflection`);
            const trackingId = `reflect_now_general_${Date.now()}`;
            console.log(`[REFLECT NOW] Calling showReflectivePracticePanel with: keyword=null, gist=NO`);
            showReflectivePracticePanel(null, "General Reflection", trackingId, null);
        }
    }

    function handleSaveReflectiveInsight() {
        console.log("Save Reflective Insight clicked");
        console.log("Available thinqbits:", CURR_CLARITY_RESULTS?.thinqbits);
        console.log("Reflective gap consideration:", CURR_CLARITY_RESULTS?.reflective_gap);
        
        // Close the modal first
        hideLiminalModal();
        
    }

    function handleLaunchAgentUI() {
        console.log("Launch Agent UI clicked - no substantive content detected");
        
        showNotification(
            "AI Assistant", 
            "Agent UI for handling non-substantive content will be available soon", 
            "info", 
            3000
        );
        
    }

    function handleLaunchUrlAgent() {
        console.log("Launch URL Agent clicked - URL detected in input");
        
        showNotification(
            "URL Analysis", 
            "URL analysis agent will be available soon for extracting insights from linked content", 
            "info", 
            3000
        );
        
    }


    function handleCaptureQuickInsight() {
        console.log("Capture Quick Insight clicked");
        console.log("Reflective gap data:", CURR_CLARITY_RESULTS?.reflective_gap);
        
        if (!CURR_CLARITY_RESULTS?.reflective_gap) {
            console.warn("No reflective gap data available");
            return;
        }
        
        // Close modal and launch chat with reflective gap guidance
        hideLiminalModal();
        setTimeout(() => {
            showChatInterface(CURR_CLARITY_RESULTS.reflective_gap);
        }, 300);
    }

    function handleContinueReflectingLater() {
        console.log("Save Draft clicked");
        
        // Check subscription status - save for later is a premium feature
        if (CURR_STRIPESTATUS === false) {
            showValidationModal('⚠️ Only available to subscribers ⚠️', 
                `Save your reflection drafts and continue working on them later! This premium feature helps you capture insights as they happen and finish your reflections when you have more time.<br/><br/>Click below to unlock unlimited reflections, draft saving, topic snoozing, and more premium features for just $50/yr.`, 
                'Subscribe now',
                function(){
                    mixpanel.track('Click to Subscribe for Save Draft Feature', {});
                    performTask("start-subscription");
                }, 
                'Not now', 
                function(){
                    mixpanel.track('Subscription Prompt Dismissed for Save Draft Feature', {});
                    performTask('validationmodal-dismiss');
                }
            );
            return;
        }
        
        if (!CURR_CLARITY_RESULTS) {
            console.warn("No clarity results available for saving");
            showNotification('Error', 'No insight data available to save', 'error', 3000);
            return;
        }
        
        // Check for required data - capture original spark immediately before any UI changes
        const gist = CURR_CLARITY_RESULTS.gist || "";
        const liminalSparkElement = document.getElementById('liminal_spark');
        const originalSpark = liminalSparkElement ? liminalSparkElement.value || "" : "";
        
        console.log('Data check:', { 
            hasGist: !!gist.trim(), 
            hasOriginalSpark: !!originalSpark.trim(),
            gistLength: gist.length,
            originalSparkLength: originalSpark.length
        });
        
        if (!gist.trim() && !originalSpark.trim()) {
            console.warn("No meaningful content to save for later");
            showNotification('Warning', 'No content available to save', 'warning', 3000);
            return;
        }
        
        // Check for duplicates by comparing with existing snoozed items
        if (window.CURRENT_SNOOZED_ITEMS) {
            const existingGistItem = window.CURRENT_SNOOZED_ITEMS.find(item => 
                item.type === 'gist_continuation' && 
                (
                    (item.content && gist.trim() && item.content === gist.trim()) ||
                    (item.original_spark && originalSpark.trim() && item.original_spark === originalSpark.trim())
                )
            );
            
            if (existingGistItem) {
                console.log('Duplicate gist continuation detected:', existingGistItem);
                showNotification('Already Saved', 'This insight has already been saved for later', 'info', 3000);
                return;
            }
        }
        
        // Create comprehensive data for continuation
        const continuationData = {
            type: 'gist_continuation',
            content: gist.trim() || "Insight to continue reflecting on",
            original_spark: originalSpark.trim(),
            display_preview: gist.length > 100 ? gist.substring(0, 100) + '...' : gist,
            clarity_context: {
                intent: CURR_CLARITY_RESULTS.intent || "",
                cognitive_query: CURR_CLARITY_RESULTS.cognitive_query || "",
                ipoc_keywords: CURR_CLARITY_RESULTS.ipoc_keywords || [],
                ipoc_context: CURR_CLARITY_RESULTS.ipoc_context || "",
                thinqbits: CURR_CLARITY_RESULTS.thinqbits || [],
                reflective_gap: CURR_CLARITY_RESULTS.reflective_gap || ""
            },
            created_at: Date.now()
        };
        
        // Generate tracking ID for this save
        const trackingId = `continue_later_${Date.now()}_${btoa(encodeURIComponent(gist.substring(0, 20))).substring(0, 8).replace(/[+/=]/g, '')}`;
        
        // Save using enhanced snooze system with detailed logging
        const defaultDuration = "1 day"; // Default to tomorrow
        console.log('Saving continuation data:', {
            content: continuationData.content,
            duration: defaultDuration,
            trackingId: trackingId,
            ipocContext: CURR_CLARITY_RESULTS.ipoc_context || "Reflective Learning Moment",
            continuationData: continuationData
        });
        
        saveSnoozeToFirebase(
            continuationData.content, 
            defaultDuration, 
            null, // originalNudgeId
            trackingId,
            CURR_CLARITY_RESULTS.ipoc_context || "Reflective Learning Moment",
            continuationData // Pass full continuation data
        ).then(() => {
            console.log('Firebase save successful, continuing with UI updates...');
        
            // Close liminal modal to restore UI state
            hideLiminalModal();
            
            // Close chat interface (not liminal modal)
            const chatInterface = document.getElementById('chat-interface');
            if (chatInterface) {
                chatInterface.classList.add('hidden');
                console.log('Chat interface closed');
            }
            
            // Restore liminal form visibility (same as hideChatInterface)
            const liminalForm = document.getElementById('liminal-spark-form');
            const phraseCycleContainer = document.getElementById('phrase-cycle-container');
            
            if (liminalForm) {
                liminalForm.classList.remove('hidden');
                
                // Trigger reflow
                liminalForm.offsetHeight;
                
                liminalForm.style.transform = 'scale(1)';
                liminalForm.style.opacity = '1';
            }
            
            // Show phrase cycle container again
            if (phraseCycleContainer) {
                phraseCycleContainer.classList.remove('hidden');
                phraseCycleContainer.style.opacity = '1';
            }

            // Show quickpick container again
            const quickpickContainer = document.getElementById('quickpick-container')?.closest('.mb-6');
            if (quickpickContainer) {
                quickpickContainer.classList.remove('hidden');
                quickpickContainer.style.opacity = '1';
                quickpickContainer.style.transform = 'translateY(0)';
            }

            // Show credit button again
            const creditButton = document.getElementById('creditCheckBtn');
            if (creditButton) {
                creditButton.classList.remove('hidden');
                creditButton.style.opacity = '1';
                creditButton.style.transform = 'translateY(0)';
            }

            // Clear the liminal spark input immediately
            clearLiminalSpark();
            
            // Show success notification
            showNotification(
                "Saved",
                "Your draft has been saved for later with full context preserved",
                "success",
                3000
            );
            
            // Update DSIB badge count immediately after save
            updateDSIBBadgeCount();
            console.log('DSIB badge updated after save for later');
            
        }).catch((error) => {
            console.error('Error in save for later workflow:', error);
        });
    }
    
    // ===== INLINE DSIB SYSTEM =====
    // Simplified badge management without external dsib.js dependency
    
    /**
     * Initialize DSIB system with simple badge management
     */
    function initializeDSIB() {
        // Simple initialization - just set up click handlers
        const dsibButton = document.getElementById('dsib-button');
        const dsibPanel = document.getElementById('dsib-panel');
        const dsibOverlay = document.getElementById('dsib-overlay');
        const dsibPanelClose = document.getElementById('dsib-panel-close');
        
        if (dsibButton && dsibPanel && dsibOverlay) {
            // Badge click handler - open panel
            dsibButton.addEventListener('click', openDSIBPanel);
            
            // Close panel handlers
            dsibPanelClose.addEventListener('click', closeDSIBPanel);
            dsibOverlay.addEventListener('click', closeDSIBPanel);
            
            // Accordion toggle handlers
            const recommendedToggle = document.getElementById('dsib-recommended-toggle');
            const draftsToggle = document.getElementById('dsib-drafts-toggle');
            const snoozedToggle = document.getElementById('dsib-snoozed-toggle');
            
            if (recommendedToggle) {
                recommendedToggle.addEventListener('click', () => toggleAccordionDSIB('dsib-recommended', 'dsib-recommended-icon'));
                // Sync initial open state so first click collapses instead of doing nothing
                const recPanel = document.getElementById('dsib-recommended');
                const recIcon = document.getElementById('dsib-recommended-icon');
                if (recPanel && recIcon) {
                    // If panel starts visually open (no max-height limit), set explicit maxHeight
                    if (!recPanel.style.maxHeight || recPanel.style.maxHeight === '') {
                        // If it has content, treat as expanded
                        const sh = recPanel.scrollHeight;
                        if (sh > 0) {
                            recPanel.style.maxHeight = sh + 'px';
                            recIcon.style.transform = 'rotate(180deg)';
                        }
                    }
                }
            }
            if (draftsToggle) {
                draftsToggle.addEventListener('click', () => toggleAccordionDSIB('dsib-drafts', 'dsib-drafts-icon'));
                // Ensure drafts starts collapsed 
                const draftsPanel = document.getElementById('dsib-drafts');
                const draftsIcon = document.getElementById('dsib-drafts-icon');
                if (draftsPanel && draftsIcon) {
                    draftsPanel.style.maxHeight = '0px';
                    draftsIcon.style.transform = 'rotate(0deg)';
                }
            }
            if (snoozedToggle) {
                snoozedToggle.addEventListener('click', () => toggleAccordionDSIB('dsib-snoozed', 'dsib-snoozed-icon'));
                // Ensure snoozed starts collapsed regardless of Tailwind class, for consistency
                const snPanel = document.getElementById('dsib-snoozed');
                const snIcon = document.getElementById('dsib-snoozed-icon');
                if (snPanel && snIcon) {
                    snPanel.style.maxHeight = '0px';
                    snIcon.style.transform = 'rotate(0deg)';
                }
            }
            
            // Initially hide badge until we have data
            const dsibContainer = document.getElementById('dsib-container');
            if (dsibContainer) {
                dsibContainer.style.display = 'none';
            }
            
            console.log('DSIB: Simple badge system initialized');
        } else {
            console.warn('DSIB: Required elements not found in DOM');
        }
    }
    
    /**
     * Update DSIB badge count with current data
     */
    function updateDSIBBadgeCount() {
        console.log('🔔 DSIB: Starting badge count update...');
        
        // Use CURR_SMART_NUDGES as single source of truth
        const allSmartNudges = window.CURR_SMART_NUDGES || [];
        
        // Calculate counts for each section based on type and status
        const recommendedCount = allSmartNudges.filter(nudge => 
            nudge.type !== 'gist_continuation' && 
            !nudge.is_snoozed && 
            nudge.status !== 'snoozed'
        ).length;
        
        const savedDraftsCount = allSmartNudges.filter(nudge => nudge.type === 'gist_continuation').length;
        
        const savedTopicsCount = allSmartNudges.filter(nudge => 
            nudge.type !== 'gist_continuation' &&
            (nudge.is_snoozed === true || nudge.status === 'snoozed')
        ).length;
        
        // Total count from single source
        const totalCount = recommendedCount + savedDraftsCount + savedTopicsCount;
        
        console.log('📊 DSIB: Badge count breakdown (single source)', {
            recommended: recommendedCount,
            savedDrafts: savedDraftsCount, 
            savedTopics: savedTopicsCount,
            totalSmartNudges: allSmartNudges.length,
            totalBadgeCount: totalCount,
            allNudges: allSmartNudges.map(n => ({id: n.nudge_id, type: n.type, is_snoozed: n.is_snoozed, status: n.status, source: n.source_name})),
            timestamp: new Date().toISOString()
        });
        
        const dsibContainer = document.getElementById('dsib-container');
        const dsibBadge = document.getElementById('dsib-badge');
        const dsibCount = document.getElementById('dsib-count');
        
        if (dsibContainer && dsibBadge && dsibCount) {
            if (totalCount > 0) {
                // Show container and badge
                dsibContainer.style.display = 'block';
                dsibBadge.style.display = 'flex';
                dsibCount.textContent = totalCount > 9 ? '9+' : totalCount.toString();
                console.log(`✅ DSIB: Badge shown with count: ${dsibCount.textContent}`);
            } else {
                // Hide entire container when no notifications
                dsibContainer.style.display = 'none';
                console.log('🔔 DSIB: Badge hidden (no notifications)');
            }
        } else {
            console.warn('DSIB: Badge elements not found for update');
        }
    }
    
    /**
     * Open DSIB panel and populate content
     */
    function openDSIBPanel() {
        const dsibPanel = document.getElementById('dsib-panel');
        const dsibOverlay = document.getElementById('dsib-overlay');
        
        if (dsibPanel && dsibOverlay) {
            // Politely close chat and other open modals first
            closeChatAndOtherModalsUsingUI();
            // Show panel and overlay
            dsibPanel.classList.remove('hidden');
            dsibOverlay.classList.remove('hidden');
            
            // Animate in
            setTimeout(() => {
                dsibOverlay.classList.add('opacity-100');
                dsibPanel.querySelector('div').classList.remove('scale-95', 'opacity-0');
                dsibPanel.querySelector('div').classList.add('scale-100', 'opacity-100');
            }, 10);
            
            // Populate panel content
            populateDSIBPanel();
            
            console.log('DSIB: Panel opened');
        }
    }
    
    /**
     * Close DSIB panel
     */
    function closeDSIBPanel() {
        const dsibPanel = document.getElementById('dsib-panel');
        const dsibOverlay = document.getElementById('dsib-overlay');
        
        if (dsibPanel && dsibOverlay) {
            // Animate out
            dsibOverlay.classList.remove('opacity-100');
            dsibPanel.querySelector('div').classList.add('scale-95', 'opacity-0');
            dsibPanel.querySelector('div').classList.remove('scale-100', 'opacity-100');
            
            // Hide after animation
            setTimeout(() => {
                dsibPanel.classList.add('hidden');
                dsibOverlay.classList.add('hidden');
            }, 300);
            
            console.log('DSIB: Panel closed');
        }
    }
    
    /**
     * Populate DSIB panel with current data
     */
    function populateDSIBPanel() {
        console.log('🔄 DSIB: Starting panel population...');
        
        // Use CURR_SMART_NUDGES as single source of truth
        const allSmartNudges = window.CURR_SMART_NUDGES || [];
        
        console.log('📊 DSIB: Raw data loaded (single source)', {
            allSmartNudges: allSmartNudges.length,
            smartNudgesSample: allSmartNudges.slice(0, 2),
        });
        
        // Section 1: Recommended (inbox smart nudges - exclude snoozed and gist_continuation)
        const recommendedNudges = allSmartNudges
            .filter(nudge => 
                nudge.type !== 'gist_continuation' && 
                !nudge.is_snoozed && 
                nudge.status !== 'snoozed'
            )
            .sort((a, b) => (b.created_at || 0) - (a.created_at || 0));
        
        // Section 2: Saved Drafts (gist_continuation nudges)  
        const savedDrafts = allSmartNudges
            .filter(nudge => nudge.type === 'gist_continuation')
            .sort((a, b) => (b.created_at || 0) - (a.created_at || 0));
            
        // Section 3: Saved Topics (snoozed regular topics - not gist_continuation)
        const savedTopics = allSmartNudges
            .filter(nudge => 
                nudge.type !== 'gist_continuation' &&
                (nudge.is_snoozed === true || nudge.status === 'snoozed')
            )
            .sort((a, b) => (b.created_at || 0) - (a.created_at || 0));
        
        console.log('📋 DSIB: Data categorized', {
            recommended: {
                count: recommendedNudges.length,
                items: recommendedNudges.map(n => ({id: n.nudge_id, type: n.type, content: n.content?.substring(0, 50)}))
            },
            savedDrafts: {
                count: savedDrafts.length, 
                items: savedDrafts.map(n => ({id: n.nudge_id, type: n.type, content: n.content?.substring(0, 50)}))
            },
            savedTopics: {
                count: savedTopics.length,
                items: savedTopics.map(n => ({id: n.nudge_id, type: n.type, content: n.content?.substring(0, 50)}))
            }
        });
        
        // Populate sections
        populateRecommendedSection(recommendedNudges);
        populateSavedDraftsSection(savedDrafts);
        populateSavedTopicsSection(savedTopics);
        
        // Log the separate sections
        console.log('📝 DSIB: Saved Drafts:', savedDrafts.length, savedDrafts);
        console.log('📝 DSIB: Snoozed Topics:', savedTopics.length, savedTopics);
        
        const totalItems = recommendedNudges.length + savedDrafts.length + savedTopics.length;
        console.log('✅ DSIB: Panel populated with', {
            recommended: recommendedNudges.length,
            savedDrafts: savedDrafts.length,
            savedTopics: savedTopics.length,
            total: totalItems
        });
    }
    
    /**
     * Populate inbox (active smart nudges) section
     */
    function populateInboxSection(activeNudges) {
        const container = document.getElementById('dsib-recommended-content');
        const countBadge = document.getElementById('dsib-recommended-count');
        
        if (container && countBadge) {
            countBadge.textContent = activeNudges.length;
            
            if (activeNudges.length === 0) {
                container.innerHTML = `
                    <div class="text-center text-gray-500 py-4">
                        <i class="fa-regular fa-inbox text-2xl mb-2 block text-gray-300"></i>
                        <p class="text-sm">Your inbox is empty</p>
                        <p class="text-xs mt-1">New nudges will appear here</p>
                    </div>
                `;
            } else {
                container.innerHTML = activeNudges.map(nudge => {
                    // Determine button text and context based on auto_ipoc
                    const hasAutoIpoc = nudge.auto_ipoc && typeof nudge.auto_ipoc === 'string' && nudge.auto_ipoc.trim() !== '';
                    const buttonText = hasAutoIpoc ? 'Reflect Now' : 'Analyze';
                    // Use consistent blue styling for all primary buttons
                    const buttonClass = 'bg-blue-600 hover:bg-blue-700';
                    const contextBadge = hasAutoIpoc ? 
                        '<span class="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full ml-2">Practice Ready</span>' : 
                        '<span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full ml-2">Needs Analysis</span>';
                    
                    // Add context for practice-ready items
                    const practiceContext = hasAutoIpoc ? 
                        `<div class="text-xs text-green-600 mt-1 flex items-center">
                            <i class="fa-solid fa-play-circle text-xs mr-1"></i>
                            Ready for ${nudge.auto_ipoc}
                        </div>` : '';
                    
                    // Add metadata if available
                    const metadataInfo = nudge.metadata && nudge.metadata.specialty ? 
                        `<div class="text-xs text-gray-500 mt-1 flex items-center">
                            <i class="fa-solid fa-tag text-xs mr-1"></i>
                            ${nudge.metadata.specialty}
                        </div>` : '';
                    
                    // Add priority indicator
                    const priorityInfo = nudge.priority && nudge.priority <= 2 ? 
                        `<div class="text-xs text-orange-600 mt-1 flex items-center">
                            <i class="fa-solid fa-exclamation-triangle text-xs mr-1"></i>
                            High Priority
                        </div>` : '';
                    
                    return `
                    <div class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" 
                         data-nudge-id="${nudge.nudge_id}">
                        <div class="flex justify-between items-start mb-3">
                            <div class="flex-1">
                                <div class="flex items-center mb-2">
                                    <p class="text-sm text-gray-800">${nudge.content || 'Smart nudge'}</p>
                                    ${contextBadge}
                                </div>
                                <div class="flex items-center justify-between mb-1">
                                    <span class="text-xs text-gray-500">${nudge.source_name || 'Nudge'}</span>
                                    <span class="text-xs text-gray-400">${formatNudgeTime(nudge.created_at)}</span>
                                </div>
                                ${practiceContext}
                                ${metadataInfo}
                                ${priorityInfo}
                            </div>
                        </div>
                        <div class="flex justify-end items-center gap-2">
                            <div class="flex gap-2">
                                <button class="text-sm text-white px-3 py-2 rounded transition-colors ${buttonClass}"
                                        onclick="handleSmartNudgeClick('${nudge.nudge_id}', '${escapeForJs(nudge.content || '')}', 'recommended')">
                                    ${buttonText}
                                </button>
                                <button class="text-sm bg-red-100 text-red-700 px-3 py-2 rounded hover:bg-red-200 transition-colors ui-action-btn"
                                        data-task="delete-smart-nudge::${nudge.nudge_id}">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    `;
                }).join('');
            }
        }
    }
    
    /**
     * Populate saved for later (snoozed + gist_continuation) section
     */
    function populateSavedSection(savedItems) {
        const container = document.getElementById('dsib-snoozed-content');
        const countBadge = document.getElementById('dsib-snoozed-count');
        
        if (container && countBadge) {
            countBadge.textContent = savedItems.length;
            
            if (savedItems.length === 0) {
                container.innerHTML = `
                    <div class="text-center text-gray-500 py-4">
                        <i class="fa-regular fa-bookmark text-2xl mb-2 block text-gray-300"></i>
                        <p class="text-sm">No saved items</p>
                        <p class="text-xs mt-1">Saved items will appear here</p>
                    </div>
                `;
            } else {
                container.innerHTML = savedItems.map(item => {
                    // Determine button text, styling and context based on item type
                    const isGistContinuation = item.type === 'gist_continuation';
                    const buttonText = isGistContinuation ? 'Continue' : 'Reflect Now';
                    // Use consistent blue styling for all primary buttons
                    const buttonClass = 'bg-blue-600 hover:bg-blue-700';
                    const contextBadge = isGistContinuation ? 
                        '<span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full ml-2">Draft</span>' : 
                        '<span class="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full ml-2">Practice Ready</span>';
                    
                    // Format timestamps with action context
                    const actionType = isGistContinuation ? 'saved' : 'snoozed';
                    const savedTimeStr = formatSavedTime(item.created_at, actionType);
                    
                    // Add progress indicator for drafts
                    const progressInfo = isGistContinuation && item.clarity_context ? 
                        `<div class="flex items-center mt-1">
                            <i class="fa-solid fa-circle-notch text-xs text-blue-500 mr-1"></i>
                            <span class="text-xs text-blue-600">Analysis in progress</span>
                        </div>` : '';
                    
                    // Add draft completion estimate
                    const completionInfo = isGistContinuation && item.original_spark ? 
                        `<div class="text-xs text-blue-500 mt-1 flex items-center">
                            <i class="fa-solid fa-clock text-xs mr-1"></i>
                            ~${Math.ceil((item.original_spark.length || 50) / 100)} min to complete
                        </div>` : '';
                    
                    // Add original source context if available
                    const sourceContext = item.auto_ipoc && !isGistContinuation ? 
                        `<div class="text-xs text-gray-600 mt-1">
                            <i class="fa-solid fa-bookmark text-xs mr-1"></i>
                            ${item.auto_ipoc}
                        </div>` : '';
                    
                    return `
                    <div class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
                         data-nudge-id="${item.nudge_id}">
                        <div class="flex justify-between items-start mb-3">
                            <div class="flex-1">
                                <div class="flex items-center mb-2">
                                    <p class="text-sm text-gray-800">${item.content || item.display_preview || 'Saved item'}</p>
                                    ${contextBadge}
                                </div>
                                <div class="flex items-center justify-between mb-1">
                                    <span class="text-xs text-gray-700">${item.source_name || (isGistContinuation ? 'Saved Draft' : 'Saved Topic')}</span>
                                    <span class="text-xs text-gray-500 font-medium">${savedTimeStr}</span>
                                </div>
                                ${progressInfo}
                                ${completionInfo}
                                ${sourceContext}
                            </div>
                        </div>
                        <div class="flex justify-end items-center gap-2">
                            <div class="flex gap-2">
                                <button class="text-sm text-white px-3 py-2 rounded transition-colors ${buttonClass}"
                                        onclick="${isGistContinuation ? `handleGistContinuation('${item.nudge_id}')` : `handleSmartNudgeClick('${item.nudge_id}', '${escapeForJs(item.content || '')}', 'saved_topic')`}">
                                    ${buttonText}
                                </button>
                                <button class="text-sm bg-red-100 text-red-700 px-3 py-2 rounded hover:bg-red-200 transition-colors ui-action-btn"
                                        data-task="delete-saved-item::${item.nudge_id}">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    `;
                }).join('');
            }
        }
    }
    
    /**
     * Populate recommended (inbox smart nudges) section
     */
    function populateRecommendedSection(recommendedNudges) {
        console.log('📝 DSIB: Populating Recommended section with', recommendedNudges.length, 'items');
        
        const container = document.getElementById('dsib-recommended-content');
        const countBadge = document.getElementById('dsib-recommended-count');
        
        if (container && countBadge) {
            countBadge.textContent = recommendedNudges.length;
            
            if (recommendedNudges.length === 0) {
                container.innerHTML = `
                    <div class="text-center text-gray-500 py-4">
                        <i class="fa-regular fa-inbox text-2xl mb-2 block text-gray-300"></i>
                        <p class="text-sm">Your inbox is empty</p>
                        <p class="text-xs mt-1">New nudges will appear here</p>
                    </div>
                `;
            } else {
                container.innerHTML = recommendedNudges.map(nudge => {
                    console.log('🔷 DSIB: Rendering recommended nudge', {id: nudge.nudge_id, type: nudge.type, content: nudge.content?.substring(0, 30)});
                    return `
                        <div class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" 
                             data-nudge-id="${nudge.nudge_id}">
                            <div class="flex justify-between items-start mb-3">
                                <div class="flex-1">
                                    <p class="text-sm text-gray-800 mb-2">${nudge.content || 'Smart nudge'}</p>
                                    <div class="flex items-center justify-between">
                                        <span class="text-xs text-gray-500">${nudge.source_name || 'Recommendation'}</span>
                                        <span class="text-xs text-gray-400">${formatNudgeTime(nudge.created_at)}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-end items-center gap-2">
                                <button class="text-sm bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition-colors"
                                        onclick="handleSmartNudgeClick('${nudge.nudge_id}', '${escapeForJs(nudge.content || '')}', 'recommended')">
                                    Reflect
                                </button>
                                <button class="text-sm bg-red-100 text-red-700 px-3 py-2 rounded hover:bg-red-200 transition-colors ui-action-btn"
                                        data-task="delete-smart-nudge::${nudge.nudge_id}">
                                    Delete
                                </button>
                            </div>
                        </div>
                    `;
                }).join('');
            }
            console.log('✅ DSIB: Recommended section populated');
        } else {
            console.warn('⚠️ DSIB: Recommended section containers not found');
        }
    }
    
    /**
     * Populate saved drafts (gist_continuation) section 
     */
    function populateSavedDraftsSection(savedDrafts) {
        console.log('📝 DSIB: Populating Saved Drafts section with', savedDrafts.length, 'items');
        
        const container = document.getElementById('dsib-drafts-content');
        const countBadge = document.getElementById('dsib-drafts-count');
        
        if (container && countBadge) {
            countBadge.textContent = savedDrafts.length;
            
            if (savedDrafts.length === 0) {
                container.innerHTML = `
                    <div class="text-center text-gray-500 py-4">
                        <i class="fa-regular fa-file-text text-2xl mb-2 block text-gray-300"></i>
                        <p class="text-sm">No saved drafts</p>
                        <p class="text-xs mt-1">Draft reflections will appear here</p>
                    </div>
                `;
            } else {
                container.innerHTML = savedDrafts.map(draft => {
                    console.log('🔸 DSIB: Rendering saved draft', {id: draft.nudge_id, type: draft.type, content: draft.content?.substring(0, 30)});
                    return `
                        <div class="border border-blue-200 rounded-lg p-4 hover:shadow-md transition-shadow"
                             data-nudge-id="${draft.nudge_id}">
                            <div class="flex justify-between items-start mb-3">
                                <div class="flex-1">
                                    <p class="text-sm text-gray-800 mb-2">${draft.content || draft.display_preview || 'Saved draft'}</p>
                                    <div class="flex items-center justify-between">
                                        <span class="text-xs text-blue-700">Saved Draft</span>
                                        <span class="text-xs text-gray-400">${formatNudgeTime(draft.created_at)}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-end items-center gap-2">
                                <button class="text-sm bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition-colors"
                                        onclick="handleGistContinuation('${draft.nudge_id}')">
                                    Continue
                                </button>
                                <button class="text-sm bg-red-100 text-red-700 px-3 py-2 rounded hover:bg-red-200 transition-colors ui-action-btn"
                                        data-task="delete-saved-item::${draft.nudge_id}">
                                    Delete
                                </button>
                            </div>
                        </div>
                    `;
                }).join('');
            }
            console.log('✅ DSIB: Saved Drafts section populated');
        } else {
            console.warn('⚠️ DSIB: Saved Drafts section containers not found');
        }
    }
    
    /**
     * Populate saved topics (snoozed non-gist_continuation) section
     * TODO: This needs a third accordion section in the HTML
     */
    function populateSavedTopicsSection(savedTopics) {
        console.log('📝 DSIB: Populating Snoozed Topics section with', savedTopics.length, 'items');
        
        const container = document.getElementById('dsib-snoozed-content');
        const countBadge = document.getElementById('dsib-snoozed-count');
        
        if (container && countBadge) {
            countBadge.textContent = savedTopics.length;
            
            if (savedTopics.length === 0) {
                container.innerHTML = `
                    <div class="text-center text-gray-500 py-4">
                        <i class="fa-regular fa-clock text-2xl mb-2 block text-gray-300"></i>
                        <p class="text-sm">No snoozed topics</p>
                        <p class="text-xs mt-1">Snoozed reflection topics will appear here</p>
                    </div>
                `;
            } else {
                container.innerHTML = savedTopics.map(topic => {
                    console.log('🔸 DSIB: Rendering snoozed topic', {id: topic.nudge_id, type: topic.type, content: topic.content?.substring(0, 30)});
                    return `
                        <div class="border border-amber-200 rounded-lg p-4 hover:shadow-md transition-shadow"
                             data-nudge-id="${topic.nudge_id}">
                            <div class="flex justify-between items-start mb-3">
                                <div class="flex-1">
                                    <p class="text-sm text-gray-800 mb-2">${topic.content || topic.display_preview || 'Saved topic'}</p>
                                    <div class="flex items-center justify-between">
                                        <span class="text-xs text-blue-700">Saved Topic</span>
                                        <span class="text-xs text-gray-400">${formatNudgeTime(topic.created_at)}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-end items-center gap-2">
                                <button class="text-sm bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition-colors"
                                        onclick="handleSmartNudgeClick('${topic.nudge_id}', '${escapeForJs(topic.content || '')}', 'saved_topic')">
                                    Reflect Now
                                </button>
                                <button class="text-sm bg-red-100 text-red-700 px-3 py-2 rounded hover:bg-red-200 transition-colors ui-action-btn"
                                        data-task="delete-saved-item::${topic.nudge_id}">
                                    Delete
                                </button>
                            </div>
                        </div>
                    `;
                }).join('');
            }
        } else {
            console.warn('📝 DSIB: Snoozed topics container or count badge not found');
        }
    }
    
    /**
     * Helper function to format nudge time
     */
    function formatNudgeTime(timestamp) {
        if (!timestamp) return 'Recent';
        const date = new Date(timestamp);
        const now = new Date();
        const diffHours = Math.floor((now - date) / (1000 * 60 * 60));
        
        if (diffHours < 1) return 'Just now';
        if (diffHours < 24) return `${diffHours}h ago`;
        if (diffHours < 168) return `${Math.floor(diffHours / 24)}d ago`;
        return date.toLocaleDateString();
    }
    
    function formatSavedTime(timestamp, actionType = 'saved') {
        if (!timestamp) return `${actionType.charAt(0).toUpperCase() + actionType.slice(1)} recently`;
        const date = new Date(timestamp);
        const now = new Date();
        const diffHours = Math.floor((now - date) / (1000 * 60 * 60));
        const diffDays = Math.floor(diffHours / 24);
        
        let timeStr;
        if (diffHours < 1) timeStr = 'just now';
        else if (diffHours < 24) timeStr = `${diffHours}h ago`;
        else if (diffDays < 7) timeStr = `${diffDays}d ago`;
        else if (diffDays < 30) timeStr = `${Math.floor(diffDays / 7)}w ago`;
        else timeStr = date.toLocaleDateString();
        
        return `${actionType.charAt(0).toUpperCase() + actionType.slice(1)} ${timeStr}`;
    }
    
    /**
     * Helper function to escape strings for JavaScript
     */
    function escapeForJs(str) {
        return str.replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/\n/g, '\\n');
    }
    
    /**
     * Toggle DSIB accordion section (robust open-state detection)
     */
    function toggleAccordionDSIB(accordionId, iconId) {
        const accordion = document.getElementById(accordionId);
        const icon = document.getElementById(iconId);
        if (!accordion || !icon) {
            console.warn(`DSIB: Accordion elements not found - ${accordionId}, ${iconId}`);
            return;
        }

        // Consider it expanded if:
        // - inline maxHeight is set and not 0, OR
        // - there is no inline maxHeight yet but the element has a positive clientHeight (opened via CSS)
        const inlineMax = accordion.style.maxHeight;
        const isExpanded = (inlineMax && inlineMax !== '0px') || (!inlineMax && accordion.clientHeight > 0);

        if (isExpanded) {
            // Collapse
            accordion.style.maxHeight = '0px';
            icon.style.transform = 'rotate(0deg)';
            console.log(`DSIB: Collapsed accordion ${accordionId}`);
        } else {
            // Expand to content height
            accordion.style.maxHeight = accordion.scrollHeight + 'px';
            icon.style.transform = 'rotate(180deg)';
            console.log(`DSIB: Expanded accordion ${accordionId}`);
        }
    }
    
    /**
     * Handle smart nudge click - go to contextual modal and liminal flow
     */
    function handleSmartNudgeClick(nudgeId, content, nudgeType = 'unknown') {
        console.log('🎯 DSIB: Smart nudge clicked', { 
            nudgeId, 
            content: content?.substring(0, 50), 
            nudgeType,
            timestamp: new Date().toISOString()
        });
        
        // Close DSIB panel first
        closeDSIBPanel();
        
        // Find the nudge data - use only CURR_SMART_NUDGES as single source
        const allNudges = window.CURR_SMART_NUDGES || [];
        const nudgeData = allNudges.find(n => n.nudge_id === nudgeId);
        
        console.log('🔍 DSIB: Nudge data lookup', {
            found: !!nudgeData,
            nudgeData: nudgeData ? {
                id: nudgeData.nudge_id,
                type: nudgeData.type,
                source: nudgeData.source_name,
                auto_ipoc: nudgeData.auto_ipoc,
                content: nudgeData.content?.substring(0, 50)
            } : null,
            totalNudgesSearched: allNudges.length
        });
        
        if (!nudgeData) {
            console.error('❌ DSIB: Nudge data not found for ID:', nudgeId);
            showNotification('Error', 'Nudge data not found', 'error', 3000);
            return;
        }
        
        // Determine action flow based on auto_ipoc and nudge type
        const hasAutoIpoc = nudgeData.auto_ipoc && typeof nudgeData.auto_ipoc === 'string' && nudgeData.auto_ipoc.trim() !== '';
        const isSavedTopic = nudgeType === 'saved_topic';
        
        console.log('🔀 DSIB: Action routing decision', {
            hasAutoIpoc,
            nudgeType,
            isSavedTopic,
            auto_ipoc: nudgeData.auto_ipoc,
            actionDecision: (hasAutoIpoc || isSavedTopic) ? 'Direct to Reflective Practice' : 'Analysis Flow'
        });
        
        if (hasAutoIpoc || isSavedTopic) {
            // Route 1: Direct to reflective practice flow
            console.log('🚀 DSIB: Launching direct reflective practice flow');
            
            const ipocContext = nudgeData.auto_ipoc || "Reflective Learning Moment";
            const ipocKeyword = nudgeData.content;
            const trackingId = nudgeData.tracking_id || `nudge_${nudgeData.nudge_id}_${Date.now()}`;
            
            console.log('📝 DSIB: Reflective practice parameters', {
                ipocContext,
                ipocKeyword: ipocKeyword?.substring(0, 50),
                trackingId
            });
            
            launchReflectivePracticeWithContext(ipocContext, nudgeData.content, trackingId, ipocKeyword);
            
        } else {
            // Route 2: Analysis flow (populate liminal spark + trigger analysis)
            console.log('🔬 DSIB: Launching analysis flow');
            
            const liminalSparkElement = document.getElementById('liminal_spark');
            if (liminalSparkElement) {
                liminalSparkElement.value = content;
                liminalSparkElement.focus();
                console.log('✅ DSIB: Liminal spark populated and focused');
                
                // Trigger the analyze spark workflow
                setTimeout(() => {
                    performTask('analyze-spark');
                    console.log('✅ DSIB: Analyze-spark task triggered');
                }, 100);
            } else {
                console.error('❌ DSIB: Liminal spark element not found');
                showNotification('Error', 'Cannot start analysis - interface not ready', 'error', 3000);
            }
        }
        
        console.log('🎉 DSIB: Smart nudge action flow completed for:', { nudgeId, nudgeType });
    }
    
    /**
     * Delete smart nudge - universal function for all nudge types
     */
    function deleteSmartNudge(nudgeId, sourceType = 'unknown') {
        console.log('🗑️ DSIB: Delete smart nudge requested', { 
            nudgeId, 
            sourceType,
            timestamp: new Date().toISOString()
        });
        
        // Find the nudge data to get context for confirmation
        const allNudges = window.CURR_SMART_NUDGES || [];
        const nudgeData = allNudges.find(n => n.nudge_id === nudgeId);
        const nudgePreview = nudgeData?.content?.substring(0, 60) || 'this nudge';
        const displayPreview = nudgePreview.length > 60 ? nudgePreview + '...' : nudgePreview;
        
        // Show confirmation dialog with context
        showValidationModal(
            "Delete Nudge?",
            `<div class="text-left">
                <div class="flex items-start space-x-3">
                    <div class="flex-shrink-0">
                        <i class="fa-solid fa-exclamation-triangle text-amber-500 text-lg"></i>
                    </div>
                    <div class="flex-1">
                        <p class="text-sm text-gray-700 mb-2">Are you sure you want to delete:</p>
                        <p class="text-sm font-medium text-gray-800 bg-gray-50 p-2 rounded border-l-2 border-amber-400">
                            "${displayPreview}"
                        </p>
                        <p class="text-xs text-gray-500 mt-2">This will remove it permanently and cannot be undone.</p>
                    </div>
                </div>
            </div>`,
            "Delete",
            () => {
                // Close confirmation modal
                performTask('validationmodal-dismiss');
                
                // Perform the actual deletion
                performSmartNudgeDeletion(nudgeId);
                
                showNotification('Deleted', 'Smart nudge removed successfully', 'success', 2000);
            },
            "Cancel",
            () => {
                performTask('validationmodal-dismiss');
                console.log('❌ DSIB: Delete cancelled by user');
            }
        );
    }
    
    /**
     * Perform the actual smart nudge deletion from Firebase and update UI
     */
    function performSmartNudgeDeletion(nudgeId) {
        console.log('🔄 DSIB: Starting nudge deletion process', { nudgeId });
        
        if (!CURR_USER || !CURR_USER.uid) {
            console.error('❌ DSIB: No authenticated user for deletion');
            showNotification('Authentication Error', 'Please log in to delete nudges', 'error', 3000);
            return;
        }
        
        // Find the nudge in CURR_SMART_NUDGES to determine its Firebase collection
        const allNudges = window.CURR_SMART_NUDGES || [];
        const nudgeData = allNudges.find(n => n.nudge_id === nudgeId);
        
        console.log('📋 DSIB: Nudge data for deletion', {
            found: !!nudgeData,
            type: nudgeData?.type,
            is_inbox: nudgeData?.is_inbox,
            is_snoozed: nudgeData?.is_snoozed,
            status: nudgeData?.status
        });
        
        // Determine which Firebase collection to delete from
        const db = firebase.firestore();
        const userRef = db.collection('smartnudges').doc(CURR_USER.uid);
        
        let collectionName;
        if (nudgeData?.is_inbox || (!nudgeData?.is_snoozed && nudgeData?.status !== 'snoozed')) {
            collectionName = 'inbox';
        } else {
            collectionName = 'snoozed';
        }
        
        console.log('🎯 DSIB: Deleting from Firebase collection:', collectionName);
        
        // Delete from Firebase
        userRef.collection(collectionName).doc(nudgeId).delete()
            .then(() => {
                console.log('✅ DSIB: Successfully deleted from Firebase:', { nudgeId, collection: collectionName });
                
                // Remove from local CURR_SMART_NUDGES array
                if (window.CURR_SMART_NUDGES) {
                    const originalCount = window.CURR_SMART_NUDGES.length;
                    window.CURR_SMART_NUDGES = window.CURR_SMART_NUDGES.filter(
                        nudge => nudge.nudge_id !== nudgeId
                    );
                    console.log('📊 DSIB: Updated local nudges array', {
                        originalCount,
                        newCount: window.CURR_SMART_NUDGES.length,
                        removed: originalCount - window.CURR_SMART_NUDGES.length
                    });
                }
                
                // Update DSIB UI
                setTimeout(() => {
                    updateDSIBBadgeCount();
                    if (document.getElementById('dsib-panel') && !document.getElementById('dsib-panel').classList.contains('hidden')) {
                        populateDSIBPanel();
                    }
                    console.log('✅ DSIB: UI refreshed after deletion');
                }, 100);
            })
            .catch((error) => {
                console.error('❌ DSIB: Error deleting nudge:', { nudgeId, collection: collectionName, error: error.message });
                
                // If deletion from primary collection failed, try the other collection
                const alternateCollection = collectionName === 'inbox' ? 'snoozed' : 'inbox';
                console.log('🔄 DSIB: Trying alternate collection:', alternateCollection);
                
                userRef.collection(alternateCollection).doc(nudgeId).delete()
                    .then(() => {
                        console.log('✅ DSIB: Successfully deleted from alternate collection:', { nudgeId, collection: alternateCollection });
                        
                        // Remove from local array
                        if (window.CURR_SMART_NUDGES) {
                            window.CURR_SMART_NUDGES = window.CURR_SMART_NUDGES.filter(
                                nudge => nudge.nudge_id !== nudgeId
                            );
                        }
                        
                        // Update UI
                        setTimeout(() => {
                            updateDSIBBadgeCount();
                            if (document.getElementById('dsib-panel') && !document.getElementById('dsib-panel').classList.contains('hidden')) {
                                populateDSIBPanel();
                            }
                        }, 100);
                    })
                    .catch((altError) => {
                        console.error('❌ DSIB: Failed to delete from both collections:', { 
                            nudgeId, 
                            primaryError: error.message,
                            alternateError: altError.message 
                        });
                        showNotification('Delete Failed', 'Could not remove nudge. Please try again.', 'error', 3000);
                    });
            });
    }
    
    /**
     * Delete saved item (snoozed or gist_continuation) - called by deleteSmartNudge
     */
    function deleteSavedItem(nudgeId) {
        console.log('🗑️ DSIB: Delete saved item requested - forwarding to unified delete function', { 
            nudgeId,
            timestamp: new Date().toISOString()
        });
        
        // Use the unified delete function which handles confirmation and Firebase operations
        deleteSmartNudge(nudgeId, 'saved_item');
    }
    

    function handleGistContinuation(nudgeId) {
        console.log('Resuming gist continuation for nudge ID:', nudgeId);
        
        if (!CURR_SMART_NUDGES || !CURR_USER) {
            console.error('Missing required data for gist continuation');
            return;
        }
        
        // Find the nudge data in memory
        const nudge = CURR_SMART_NUDGES.find(n => n.nudge_id === nudgeId);
        
        if (!nudge) {
            console.error('Nudge not found in memory:', nudgeId);
            return;
        }
        
        if (nudge.type !== 'gist_continuation') {
            console.warn('Nudge is not a gist continuation:', nudge.type);
            return;
        }
        
        // Close DSIB panel (redundant but harmless if already closed)
        const dsibPanel = document.getElementById('dsib-panel');
        const dsibOverlay = document.getElementById('dsib-overlay');
        if (dsibPanel) {
            dsibPanel.classList.remove('show');
            dsibPanel.classList.add('hidden');
        }
        if (dsibOverlay) {
            dsibOverlay.classList.remove('show');
            dsibOverlay.classList.add('hidden');
        }
        
        // Restore context and launch chat interface with full restoration
        setTimeout(() => {
            resumeGistReflection(nudge);
        }, 300);
    }
    
    function resumeGistReflection(nudge) {
        console.log('Resuming reflection with full context:', nudge);
        
        // Create a comprehensive chat message with all context restored
        const originalSpark = nudge.original_spark || "";
        const gist = nudge.content || "";
        const clarityContext = nudge.clarity_context || {};
        const ipocKeywords = clarityContext.ipoc_keywords || [];
        const thinqbits = clarityContext.thinqbits || [];
        
        // Restore CURR_CLARITY_RESULTS from saved context to prevent default welcome message
        CURR_CLARITY_RESULTS = {
            gist: gist,
            intent: clarityContext.intent || "",
            cognitive_query: clarityContext.cognitive_query || "",
            ipoc_keywords: ipocKeywords,
            ipoc_context: clarityContext.ipoc_context || "",
            thinqbits: thinqbits,
            reflective_gap: clarityContext.reflective_gap || "",
            original_spark: originalSpark
        };
        
        // Also populate the liminal_spark input field so structured analysis can detect it
        const liminalSparkElement = document.getElementById('liminal_spark');
        if (liminalSparkElement && originalSpark.trim()) {
            liminalSparkElement.value = originalSpark;
        }
        
        // Set a flag to indicate this is a resumed session to avoid showing Save Draft options
        window.IS_RESUMED_REFLECTION = true;
        
        // Launch the chat interface properly (like other smart nudges)
        // But use the restored CURR_CLARITY_RESULTS for structured analysis
        showChatInterface();
        
        // Reset the flag after a delay
        setTimeout(() => {
            window.IS_RESUMED_REFLECTION = false;
        }, 1000);
        
        // Focus and scroll after everything is ready (removed automatic deletion)
        setTimeout(() => {
            // Focus on chat input after everything is ready
            const chatInput = document.getElementById('chat-input');
            if (chatInput) {
                chatInput.focus();
            }
            
            // Scroll to show content
            const chatMessages = document.getElementById('chat-messages');
            if (chatMessages) {
                chatMessages.scrollTop = chatMessages.scrollHeight;
            }
        }, 500);
    }
    
    // Helper function to mark nudge as used
    function markNudgeAsUsed(nudgeId) {
        if (!CURR_USER || !nudgeId) return;
        
        firebase.firestore()
            .collection('smartnudges')
            .doc(CURR_USER.uid)
            .collection('snoozed')
            .doc(nudgeId)
            .delete()
            .then(() => {
                console.log('Marked gist continuation as used and removed from snoozed');
                // Update DSIB badge count
                updateDSIBBadgeCount();
            })
            .catch((error) => {
                console.error('Error removing used gist continuation:', error);
            });
    }

    // Removed showVelocityHintAboveTextarea - replaced with chat interface

    function showHelpModal() {
        console.log("Showing help modal");
        var helpModal = document.getElementById('helpmodal');
        if (helpModal) {
            // Add Quick Actions as simple buttons
            var quickActionsContainer = document.getElementById('help-modal-quick-actions');
            if (quickActionsContainer) {
                quickActionsContainer.innerHTML = `
                    <!-- Quick Actions Buttons -->
                    <div class="mt-4 pt-4 border-t border-gray-200">
                      <div class="flex flex-wrap gap-2 justify-center">
                        <button class="hidden inline-flex items-center px-3 py-2 text-xs font-medium rounded-md text-slate-700 bg-slate-100 hover:bg-slate-200 transition-colors ui-action-btn" data-task="text-me">
                          <i class="fa-solid fa-comment-sms mr-2"></i>Text to Reflect
                        </button>
                        <button class="inline-flex items-center px-3 py-2 text-xs font-medium rounded-md text-slate-700 bg-slate-100 hover:bg-slate-200 transition-colors ui-action-btn" data-task="launch-whatsapp">
                          <i class="fa-brands fa-whatsapp mr-2"></i>WhatsApp
                        </button>
                        <button class="inline-flex items-center px-3 py-2 text-xs font-medium rounded-md text-slate-700 bg-slate-100 hover:bg-slate-200 transition-colors ui-action-btn" data-task="launch-calendar">
                          <i class="fa-solid fa-calendar mr-2"></i>Invite
                        </button>
                      </div>
                    </div>
                `;
            }
            helpModal.classList.remove('hidden');
        } else {
            console.error("Help modal element not found");
        }
    }

    function closeHelpModal() {
        console.log("Closing help modal");
        var helpModal = document.getElementById('helpmodal');
        if (helpModal) {
            helpModal.classList.add('hidden');
        } else {
            console.error("Help modal element not found");
        }
    }

    function handleShowGuide() {
        closeHelpModal();
        startTour();
    }

    function handleRequestHelp() {
        closeHelpModal();
        console.log("Request Help button clicked - opening HelpScout Beacon");
        if (typeof window.Beacon !== 'undefined') {
            window.Beacon('toggle');
        } else {
            console.error("HelpScout Beacon not available");
            alert("Help system not available. Please contact support.");
        }
    }

    function clearLiminalSpark() {
        console.log("Clearing liminal spark textarea");
        var textarea = document.getElementById('liminal_spark');
        if (textarea) {
            textarea.value = '';
            textarea.focus();
            // Update button visibility and styling
            updateClearButtonVisibility();
            updateStartButtonStyling();
            try { MP.track('Spark Cleared', {}); } catch(e){}
        } else {
            console.error("Liminal spark textarea not found");
        }
    }

    function updateStartButtonStyling() {
        const textarea = document.getElementById('liminal_spark');
        const startButton = document.getElementById('start-button');
        if (!startButton || !textarea) return;
        
        const hasText = textarea.value.trim().length > 0;
        
        if (hasText) {
            // Switch to teal when text is present
            startButton.classList.remove('bg-slate-100', 'text-slate-500', 'hover:text-white', 'hover:bg-slate-500');
            startButton.classList.add('bg-teal-500', 'hover:bg-teal-600', 'text-white');
        } else {
            // Switch to light gray when no text (match help button)
            startButton.classList.remove('bg-teal-500', 'hover:bg-teal-600', 'text-white');
            startButton.classList.add('bg-slate-100', 'text-slate-500', 'hover:text-white', 'hover:bg-slate-500');
        }
    }

    function updateClearButtonVisibility() {
        var textarea = document.getElementById('liminal_spark');
        var clearBtn = document.getElementById('clear-liminal-btn');
        
        if (textarea && clearBtn) {
            if (textarea.value.trim().length > 0) {
                clearBtn.classList.remove('hidden');
            } else {
                clearBtn.classList.add('hidden');
            }
        }
    }

    // Global command palette functions (for UI action system)
    function showCommandPalette() {
        commandPalette.open();
    }

    function closeCommandPalette() {
        commandPalette.close();
    }

    // Transcript Modal Functions with Iframe Communication
    function showReflectiveInsightsModal() {
        const modal = document.getElementById('transcript-modal');
        
        if (!modal) {
            console.error('Reflective insights modal not found');
            return;
        }
        
        console.log('Opening reflective insights modal...');
        modal.classList.remove('hidden');
        
        // Initialize transcript tabs functionality (reusing existing)
        initTranscriptTabs();
        
        // Populate with reflective insights data
        populateReflectiveInsightsData();
        
        // Initialize analysis action handlers
        initReflectiveInsightsActions();
        
        // Update timestamp
        updateTranscriptTimestamp();
    }

    // Legacy function - now redirects to reflective insights
    function showTranscriptModal() {
        showReflectiveInsightsModal();
    }

    function closeTranscriptModal() {
        const modal = document.getElementById('transcript-modal');
        if (modal) {
            console.log('Closing transcript modal...');
            modal.classList.add('hidden');
        }
    }

    function populateTranscriptData() {
        console.log('Populating native transcript data...');
        
        // Calculate competency scores based on reflectivity data
        const transcriptData = calculateCompetencyScores();
        
        // Update competency score displays
        updateCompetencyScores(transcriptData);
        
        // Update insights counts
        updateInsightsCounts(transcriptData);
        
        // Update recent insights
        updateRecentInsights(transcriptData);
        
        // Update thinqbit counts  
        updateThinqbitCounts(transcriptData);
    }

    async function populateReflectiveInsightsData() {
        console.log('Populating reflective insights data...');
        
        try {
            const user = firebase.auth().currentUser;
            if (!user) {
                console.error('No authenticated user for reflective insights');
                return;
            }

            // Fetch both reflective-thinking and reflective-practice data
            const [thinkingSnapshot, practiceSnapshot] = await Promise.all([
                firebase.firestore()
                    .collection('reflections')
                    .doc(user.uid)
                    .collection('reflective-thinking')
                    .orderBy('timestamp', 'desc')
                    .get(),
                firebase.firestore()
                    .collection('reflections')
                    .doc(user.uid)
                    .collection(CURR_REFLECTIONKIT || 'general')
                    .orderBy('timestamp', 'desc')
                    .get()
            ]);

            const insights = [];
            const reflections = [];
            
            thinkingSnapshot.forEach(doc => {
                const data = doc.data();
                insights.push({
                    id: doc.id,
                    ...data,
                    timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
                    type: 'thinking'
                });
            });

            practiceSnapshot.forEach(doc => {
                const data = doc.data();
                reflections.push({
                    id: doc.id,
                    ...data,
                    timestamp: data.timestamp ? new Date(data.timestamp) : new Date(),
                    type: 'practice'
                });
            });

            console.log(`Found ${insights.length} reflective thinking entries and ${reflections.length} reflective practice entries`);

            // Calculate clinically meaningful metrics
            const now = new Date();
            const threeMonthsAgo = new Date(now.getTime() - (90 * 24 * 60 * 60 * 1000));

            // 1. Clinical Learning Metrics
            
            // Total learning instances (thinking + formal reflections)
            const totalLearningInstances = insights.length + reflections.length;
            
            // Weekly reflection consistency (last 8 weeks)
            const eightWeeksAgo = new Date(now.getTime() - (8 * 7 * 24 * 60 * 60 * 1000));
            const recentAllActivity = [...insights, ...reflections].filter(item => item.timestamp >= eightWeeksAgo);
            const weeksWithActivity = new Set();
            recentAllActivity.forEach(item => {
                const weekStart = new Date(item.timestamp);
                weekStart.setDate(weekStart.getDate() - weekStart.getDay());
                weekStart.setHours(0, 0, 0, 0);
                weeksWithActivity.add(weekStart.getTime());
            });
            const consistencyWeeks = weeksWithActivity.size;
            

            // Calculate recent momentum (activity in last 2 weeks)
            const twoWeeksAgo = new Date(now.getTime() - (14 * 24 * 60 * 60 * 1000));
            const allActivity = [...insights, ...reflections];
            const recentMomentum = allActivity.filter(item => item.timestamp >= twoWeeksAgo).length;

            console.log('Calculated values:', {
                totalActivity: allActivity.length,
                recentMomentum,
                consistencyWeeks
            });

            // Learning momentum labels
            let momentumLabel = 'Getting Started';
            if (recentMomentum >= 10) momentumLabel = 'Very Active';
            else if (recentMomentum >= 5) momentumLabel = 'Active';
            else if (recentMomentum >= 2) momentumLabel = 'Building';
            
            document.getElementById('learning-momentum').textContent = momentumLabel;

            // 2. Learning Streak Calculation
            const sortedActivity = allActivity.sort((a, b) => b.timestamp - a.timestamp);
            let streakWeeks = 0;
            
            if (allActivity.length > 0) {
                const activityWeeks = new Set();
                allActivity.forEach(item => {
                    const weekStart = new Date(item.timestamp);
                    weekStart.setDate(weekStart.getDate() - weekStart.getDay());
                    weekStart.setHours(0, 0, 0, 0);
                    activityWeeks.add(weekStart.getTime());
                });

                // Count consecutive weeks with activity
                let currentWeekStart = new Date(now);
                currentWeekStart.setDate(currentWeekStart.getDate() - currentWeekStart.getDay());
                currentWeekStart.setHours(0, 0, 0, 0);
                
                while (activityWeeks.has(currentWeekStart.getTime())) {
                    streakWeeks++;
                    currentWeekStart.setDate(currentWeekStart.getDate() - 7);
                }
                
                // If no activity this week, check if we had activity in previous weeks
                if (streakWeeks === 0 && activityWeeks.size > 0) {
                    const lastWeek = new Date(currentWeekStart.getTime() + (7 * 24 * 60 * 60 * 1000));
                    if (activityWeeks.has(lastWeek.getTime())) {
                        streakWeeks = 1;
                    }
                }
            }


            // Note: current-streak-days and current-streak-weeks elements removed from UI

            // 3. Enhanced Thinqbits Analysis
            const thinqbitAnalysis = analyzeThinqbitsPatterns(insights);
            
            // Update basic counts
            document.getElementById('obs-count').textContent = thinqbitAnalysis.counts.observations;
            document.getElementById('idea-count').textContent = thinqbitAnalysis.counts.ideas;
            document.getElementById('risk-count').textContent = thinqbitAnalysis.counts.risks;
            document.getElementById('decision-count').textContent = thinqbitAnalysis.counts.decisions;
            
            // Update advanced insights
            document.getElementById('thinking-style').textContent = thinqbitAnalysis.thinkingStyle;
            document.getElementById('focus-areas').textContent = thinqbitAnalysis.clinicalFocus;
            document.getElementById('learning-approach').textContent = thinqbitAnalysis.learningApproach;
            document.getElementById('growth-pattern').textContent = thinqbitAnalysis.growthPattern;

            // 4. Key Learning Moments (mix of recent insights and reflections)
            const keyMoments = sortedActivity.slice(0, 4); // Show top 4 most recent
            const recentInsightsElement = document.getElementById('recent-insights-list');
            
            if (keyMoments.length === 0) {
                recentInsightsElement.innerHTML = `
                    <div class="bg-white rounded p-3 border-l-4 border-orange-400">
                        <p class="text-sm text-gray-700">No learning moments captured yet. Start reflecting to build your professional growth record!</p>
                        <div class="mt-2 text-xs text-gray-500">Tip: Each reflection adds to your reflective portfolio</div>
                    </div>
                `;
            } else {
                const momentsHtml = keyMoments.map(moment => {
                    const gist = moment.gist || moment.reflection_text || moment.title || 'Learning moment captured';
                    const displayGist = gist.length > 100 ? gist.substring(0, 100) + '...' : gist;
                    const diffMs = now - moment.timestamp;
                    const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000));
                    const timeAgo = diffDays === 0 ? 'Today' : diffDays === 1 ? 'Yesterday' : `${diffDays} days ago`;
                    
                    const borderColor = moment.type === 'thinking' ? 'border-teal-400' : 'border-orange-400';
                    const typeLabel = moment.type === 'thinking' ? 'Quick Insight' : 'Reflection';
                    
                    return `
                        <div class="bg-white rounded p-3 border-l-4 ${borderColor}">
                            <div class="flex justify-between items-start mb-1">
                                <div class="text-xs font-medium text-gray-600">${typeLabel}</div>
                                <div class="text-xs text-gray-500">${timeAgo}</div>
                            </div>
                            <p class="text-sm text-gray-700">"${displayGist}"</p>
                        </div>
                    `;
                }).join('');
                recentInsightsElement.innerHTML = momentsHtml;
            }

        } catch (error) {
            console.error('Error loading reflective insights:', error);
            document.getElementById('learning-momentum').textContent = '--';
            document.getElementById('obs-count').textContent = '--';
            document.getElementById('idea-count').textContent = '--';
            document.getElementById('risk-count').textContent = '--';
            document.getElementById('decision-count').textContent = '--';
            document.getElementById('thinking-style').textContent = 'Unable to analyze patterns at this time';
            document.getElementById('focus-areas').textContent = '--';
            document.getElementById('learning-approach').textContent = '--';
            document.getElementById('growth-pattern').textContent = '--';
        }
    }

    // Advanced Thinqbits Pattern Analysis
    function analyzeThinqbitsPatterns(insights) {
        const counts = { observations: 0, risks: 0, ideas: 0, decisions: 0 };
        const detailedPatterns = {
            clinical: [], safety: [], learning: [], decision: [], 
            patient: [], system: [], team: [], quality: []
        };
        const timePatterns = [];
        const contextPatterns = [];

        // Process all thinqbits
        insights.forEach(insight => {
            if (insight.thinqbits && Array.isArray(insight.thinqbits)) {
                insight.thinqbits.forEach(thinqbit => {
                    const code = (thinqbit.code || '').toLowerCase();
                    const reason = (thinqbit.reason || '').toLowerCase();
                    
                    // Basic categorization
                    if (code.includes('obs') || code.includes('observation') || code.includes('notice')) {
                        counts.observations++;
                        detailedPatterns.clinical.push(thinqbit);
                    } else if (code.includes('risk') || code.includes('danger') || code.includes('safety') || code.includes('concern')) {
                        counts.risks++;
                        detailedPatterns.safety.push(thinqbit);
                    } else if (code.includes('idea') || code.includes('insight') || code.includes('learn') || code.includes('innovation')) {
                        counts.ideas++;
                        detailedPatterns.learning.push(thinqbit);
                    } else if (code.includes('decision') || code.includes('choice') || code.includes('action')) {
                        counts.decisions++;
                        detailedPatterns.decision.push(thinqbit);
                    }

                    // Contextual analysis
                    if (reason.includes('patient') || reason.includes('family')) {
                        detailedPatterns.patient.push(thinqbit);
                    } else if (reason.includes('team') || reason.includes('colleague') || reason.includes('staff')) {
                        detailedPatterns.team.push(thinqbit);
                    } else if (reason.includes('system') || reason.includes('process') || reason.includes('workflow')) {
                        detailedPatterns.system.push(thinqbit);
                    } else if (reason.includes('quality') || reason.includes('improvement') || reason.includes('outcome')) {
                        detailedPatterns.quality.push(thinqbit);
                    }

                    // Time-based pattern tracking
                    timePatterns.push({
                        timestamp: insight.timestamp,
                        type: code,
                        context: reason
                    });
                });
            }
        });

        // Advanced analysis
        const total = counts.observations + counts.risks + counts.ideas + counts.decisions;
        
        // Thinking Style Analysis
        let thinkingStyle = 'Developing Reflective Practice';
        if (total === 0) {
            thinkingStyle = 'Starting Your Reflection Journey - Keep capturing your thinking patterns!';
        } else if (counts.observations > counts.ideas && counts.observations > counts.decisions) {
            thinkingStyle = 'Clinical Observer - You excel at noticing and capturing important clinical details';
        } else if (counts.ideas > counts.observations && counts.ideas > counts.risks) {
            thinkingStyle = 'Innovative Thinker - You generate creative solutions and learning insights';
        } else if (counts.risks > total * 0.3) {
            thinkingStyle = 'Safety-Focused - You have strong awareness of risks and patient safety concerns';
        } else if (counts.decisions > total * 0.25) {
            thinkingStyle = 'Decision-Oriented - You focus on clinical decision-making and action planning';
        } else {
            thinkingStyle = 'Balanced Reflector - You integrate observations, insights, and decisions effectively';
        }

        // Clinical Focus Areas
        let clinicalFocus = 'Building clinical focus areas';
        const focusAreas = [];
        if (detailedPatterns.patient.length > 2) focusAreas.push('Patient Care');
        if (detailedPatterns.safety.length > 1) focusAreas.push('Safety & Risk Management');
        if (detailedPatterns.team.length > 1) focusAreas.push('Team Collaboration');
        if (detailedPatterns.system.length > 1) focusAreas.push('System Improvement');
        if (detailedPatterns.quality.length > 1) focusAreas.push('Quality Enhancement');
        
        if (focusAreas.length > 0) {
            clinicalFocus = `Primary focus: ${focusAreas.slice(0, 3).join(', ')}`;
        }

        // Learning Approach
        let learningApproach = 'Establishing learning patterns';
        const obsToIdeasRatio = counts.observations > 0 ? counts.ideas / counts.observations : 0;
        
        if (obsToIdeasRatio > 1.5) {
            learningApproach = 'Theory-to-Practice - You transform observations into actionable insights';
        } else if (obsToIdeasRatio < 0.5 && counts.observations > counts.ideas) {
            learningApproach = 'Evidence-Based - You focus on careful observation and data collection';
        } else if (counts.risks > total * 0.25) {
            learningApproach = 'Risk-Aware Learning - Safety considerations guide your professional development';
        } else {
            learningApproach = 'Experiential Learning - You learn through direct clinical experience';
        }

        // Growth Pattern Analysis
        let growthPattern = 'Building reflection consistency';
        
        if (timePatterns.length > 0) {
            // Analyze temporal patterns
            const recentPatterns = timePatterns.filter(p => {
                const daysDiff = (Date.now() - p.timestamp) / (1000 * 60 * 60 * 24);
                return daysDiff <= 30;
            });
            
            if (recentPatterns.length > 10) {
                growthPattern = 'Accelerating Growth - High reflection activity shows strong professional development';
            } else if (recentPatterns.length > 5) {
                growthPattern = 'Steady Development - Consistent reflection pattern building professional insight';
            } else if (recentPatterns.length > 2) {
                growthPattern = 'Emerging Awareness - Beginning to develop structured reflection practice';
            }
        }

        return {
            counts,
            thinkingStyle,
            clinicalFocus,
            learningApproach,
            growthPattern,
            totalPatterns: total,
            detailedPatterns
        };
    }

    // Handle pre-fab analysis button clicks
    function initReflectiveInsightsActions() {
        const actionButtons = document.querySelectorAll('.ui-action-btn[data-task]');
        
        actionButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const task = button.getAttribute('data-task');
                handleAnalysisTask(task);
            });
        });
    }

    function handleAnalysisTask(task) {
        console.log('Analysis task requested:', task);
        
        // Check if ReflectiveInsights is available
        if (typeof window.reflectiveInsights === 'undefined') {
            console.error('ReflectiveInsights instance not found');
            return;
        }
        
        // Map tasks to appropriate methods
        switch (task) {
            case 'analyze-patterns':
                window.reflectiveInsights.handleAnalyzePatterns();
                break;
            case 'find-learning-gaps':
                window.reflectiveInsights.handleAskGaps();
                break;
            case 'generate-work-products':
                window.reflectiveInsights.handleCreateSummary();
                break;
            case 'track-growth-areas':
                window.reflectiveInsights.handleAskGrowth();
                break;
            case 'create-development-plan':
                window.reflectiveInsights.handleCreatePlan();
                break;
            case 'export-portfolio':
                window.reflectiveInsights.handleExportPortfolio();
                break;
            default:
                console.warn('Unknown analysis task:', task);
        }
    }







    // Native transcript tab functionality
    function initTranscriptTabs() {
        const tabButtons = document.querySelectorAll('[data-transcript-tab]');
        const exportBtn = document.getElementById('export-transcript-btn');
        const shareBtn = document.getElementById('share-transcript-btn');
        
        // Handle tab switching
        tabButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const tabName = button.getAttribute('data-transcript-tab');
                if (tabName) {
                    showTranscriptTab(tabName);
                }
            });
        });
        
        // Handle export button
        if (exportBtn) {
            exportBtn.addEventListener('click', () => handleTranscriptExport());
        }
        
        // Handle share button  
        if (shareBtn) {
            shareBtn.addEventListener('click', () => handleTranscriptShare());
        }
        
        console.log('Transcript tabs initialized');
    }
    
    function showTranscriptTab(tabName) {
        console.log('Switching to transcript tab:', tabName);
        
        // Hide all tab contents
        document.querySelectorAll('.transcript-tab-content').forEach(content => {
            content.classList.add('hidden');
        });
        
        // Remove active state from all tabs
        document.querySelectorAll('[data-transcript-tab]').forEach(tab => {
            tab.classList.remove('text-learner-blue', 'border-learner-blue', 'border-b-2');
            tab.classList.add('text-gray-500');
        });
        
        // Show selected tab content
        const selectedContent = document.getElementById(`transcript-content-${tabName}`);
        if (selectedContent) {
            selectedContent.classList.remove('hidden');
        }
        
        // Activate selected tab
        const selectedTab = document.getElementById(`transcript-tab-${tabName}`);
        if (selectedTab) {
            selectedTab.classList.remove('text-gray-500');
            selectedTab.classList.add('text-learner-blue', 'border-learner-blue', 'border-b-2');
        }
    }
    
    function calculateCompetencyScores() {
        // Calculate scores based on reflectivity meter and stored reflections
        const baseDiscernment = 7.5 + (reflectivityMeter.currentLevel * 0.2);
        const baseClarity = 7.0 + (reflectivityMeter.progressPercent / 100 * 2);
        const baseDepth = 8.0 + (reflectivityMeter.reflectionStreak * 0.1);
        const baseImpact = 7.8 + (reflectivityMeter.totalReflections * 0.05);
        
        return {
            totalReflections: reflectivityMeter.totalReflections || 0,
            discernmentScore: Math.min(10, baseDiscernment).toFixed(1),
            clarityScore: Math.min(10, baseClarity).toFixed(1),
            depthScore: Math.min(10, baseDepth).toFixed(1),
            impactScore: Math.min(10, baseImpact).toFixed(1),
            // Thinqbit counts - calculated from actual reflection data
            obsCount: reflectiveInsights.getThinqbitCount('obs') || 0,
            riskCount: reflectiveInsights.getThinqbitCount('risk') || 0,
            ideaCount: reflectiveInsights.getThinqbitCount('idea') || 0,
            decisionCount: reflectiveInsights.getThinqbitCount('dec') || 0
        };
    }
    
    function updateCompetencyScores(data) {
        // Update main competency scores
        const elements = {
            'discernment-score': data.discernmentScore,
            'clarity-score': data.clarityScore,
            'depth-score': data.depthScore,
            'impact-score': data.impactScore,
            'discernment-detailed': `${data.discernmentScore}/10`,
            'clarity-detailed': `${data.clarityScore}/10`,
            'depth-detailed': `${data.depthScore}/10`,
            'impact-detailed': `${data.impactScore}/10`
        };
        
        Object.entries(elements).forEach(([id, value]) => {
            const element = document.getElementById(id);
            if (element) {
                element.textContent = value;
            }
        });
        
        // Update progress bars
        const bars = {
            'discernment-bar': parseFloat(data.discernmentScore) * 10,
            'clarity-bar': parseFloat(data.clarityScore) * 10,
            'depth-bar': parseFloat(data.depthScore) * 10,
            'impact-bar': parseFloat(data.impactScore) * 10
        };
        
        Object.entries(bars).forEach(([id, width]) => {
            const bar = document.getElementById(id);
            if (bar) {
                bar.style.width = `${Math.min(100, width)}%`;
            }
        });
    }
    
    function updateInsightsCounts(data) {
        const insightsCount = document.getElementById('insights-count');
        if (insightsCount) {
            insightsCount.textContent = data.totalReflections || '0';
        }
    }
    
    function updateThinqbitCounts(data) {
        const counts = {
            'obs-count': data.obsCount,
            'risk-count': data.riskCount,
            'idea-count': data.ideaCount,
            'decision-count': data.decisionCount
        };
        
        Object.entries(counts).forEach(([id, count]) => {
            const element = document.getElementById(id);
            if (element) {
                element.textContent = count;
            }
        });
    }
    
    function updateRecentInsights(data) {
        const container = document.getElementById('recent-insights');
        if (!container) return;
        
        console.log('Recent insights updated');
    }
    
    function updateTranscriptTimestamp() {
        const element = document.getElementById('transcript-last-updated');
        if (element) {
            const now = new Date();
            element.textContent = now.toLocaleString();
        }
    }

    // Handle transcript export
    function handleTranscriptExport() {
        console.log('Handling transcript export');
        showNotification("Export Started", "Your reflective intelligence profile is being prepared for download.", "info", 3000);
        
        // Future implementation: generate and download PDF/JSON export
    }

    // Handle transcript sharing
    function handleTranscriptShare() {
        console.log('Handling transcript share');
        showNotification("Share Feature", "Profile sharing will showcase your authentic human thinking patterns.", "info", 3000);
        
        // Future implementation: generate shareable profile link
    }

    // Command Palette Implementation
    let commandPalette = {
        isOpen: false,
        selectedIndex: 0,
        filteredItems: [],
        
        init() {
            this.bindEvents();
            this.cacheElements();
        },
        
        cacheElements() {
            this.modal = document.getElementById('commandpalette');
            this.searchInput = document.getElementById('palette-search');
            this.resultsContainer = document.getElementById('palette-results');
            this.noResultsMessage = document.getElementById('palette-no-results');
            this.allItems = this.modal ? this.modal.querySelectorAll('[data-task^="palette-"]') : [];
        },
        
        bindEvents() {
            // Global keyboard shortcut (Ctrl/Cmd + K)
            document.addEventListener('keydown', (e) => {
                if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
                    e.preventDefault();
                    this.toggle();
                }
                
                if (this.isOpen) {
                    this.handleKeydown(e);
                }
            });
            
            // Search input events
            if (this.searchInput) {
                this.searchInput.addEventListener('input', (e) => {
                    this.handleSearch(e.target.value);
                });
            }
            
            // Close on backdrop click
            if (this.modal) {
                this.modal.addEventListener('click', (e) => {
                    if (e.target === this.modal || e.target.hasAttribute('data-task') && e.target.getAttribute('data-task') === 'close-command-palette') {
                        this.close();
                    }
                });
            }
        },
        
        open() {
            if (this.isOpen || !this.modal) return;
            
            this.isOpen = true;
            this.selectedIndex = 0;
            this.modal.classList.remove('hidden');
            
            // Reset search
            if (this.searchInput) {
                this.searchInput.value = '';
                this.searchInput.focus();
            }
            
            // Show all items initially
            this.showAllItems();
        },
        
        close() {
            if (!this.isOpen || !this.modal) return;
            
            this.isOpen = false;
            this.modal.classList.add('hidden');
            
            if (this.searchInput) {
                this.searchInput.blur();
            }
        },
        
        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
        
        handleKeydown(e) {
            switch (e.key) {
                case 'Escape':
                    e.preventDefault();
                    this.close();
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    this.moveSelection(1);
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    this.moveSelection(-1);
                    break;
                case 'Enter':
                    e.preventDefault();
                    this.selectCurrent();
                    break;
            }
        },
        
        handleSearch(query) {
            const searchTerm = query.toLowerCase().trim();
            this.filteredItems = [];
            
            this.allItems.forEach(item => {
                const text = item.textContent.toLowerCase();
                const container = item.closest('.group') || item.parentElement;
                
                if (searchTerm === '' || text.includes(searchTerm)) {
                    if (container) container.style.display = '';
                    this.filteredItems.push(item);
                } else {
                    if (container) container.style.display = 'none';
                }
            });
            
            // Show/hide no results message
            if (this.noResultsMessage) {
                if (this.filteredItems.length === 0 && searchTerm !== '') {
                    this.noResultsMessage.style.display = 'block';
                } else {
                    this.noResultsMessage.style.display = 'none';
                }
            }
            
            // Reset selection
            this.selectedIndex = 0;
            this.updateSelection();
        },
        
        showAllItems() {
            this.filteredItems = [...this.allItems];
            this.allItems.forEach(item => {
                const container = item.closest('.group') || item.parentElement;
                if (container) container.style.display = '';
            });
            
            if (this.noResultsMessage) {
                this.noResultsMessage.style.display = 'none';
            }
            
            this.updateSelection();
        },
        
        moveSelection(direction) {
            if (this.filteredItems.length === 0) return;
            
            this.selectedIndex = Math.max(0, Math.min(this.filteredItems.length - 1, this.selectedIndex + direction));
            this.updateSelection();
        },
        
        updateSelection() {
            // Remove previous selection
            this.allItems.forEach(item => {
                const container = item.closest('.group');
                if (container) {
                    container.classList.remove('bg-gray-200');
                }
            });
            
            // Add current selection
            if (this.filteredItems[this.selectedIndex]) {
                const container = this.filteredItems[this.selectedIndex].closest('.group');
                if (container) {
                    container.classList.add('bg-gray-200');
                    container.scrollIntoView({ block: 'nearest' });
                }
            }
        },
        
        selectCurrent() {
            if (this.filteredItems[this.selectedIndex]) {
                const selectedItem = this.filteredItems[this.selectedIndex];
                const task = selectedItem.getAttribute('data-task');
                
                // Execute the task
                if (task) {
                    this.close();
                    performTask(task);
                }
            }
        }
    };

    // Command Palette Action Handlers - Secure internal delegation
    function handlePaletteGenerateCertificate() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleGenerateCertificate();
        } else {
            showNotification("Generate Certificate", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteExportPortfolio() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleExportPortfolio();
        } else {
            showNotification("Export Portfolio", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteAnalyzePatterns() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleAnalyzePatterns();
        } else {
            showNotification("Analyze Patterns", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteAskPatterns() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleAskPatterns();
        } else {
            showNotification("Ask About Patterns", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteAskGaps() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleAskGaps();
        } else {
            showNotification("Ask About Gaps", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteAskGrowth() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleAskGrowth();
        } else {
            showNotification("Ask About Growth", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteAskConnections() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleAskConnections();
        } else {
            showNotification("Ask About Connections", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteCreateSummary() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleCreateSummary();
        } else {
            showNotification("Create Summary", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteCreatePlan() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleCreatePlan();
        } else {
            showNotification("Create Development Plan", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handlePaletteCreateCaseStudy() {
        if (reflectiveInsights && reflectiveInsights.isInitialized) {
            reflectiveInsights.handleCreateCaseStudy();
        } else {
            showNotification("Create Case Study", "Reflective insights system not ready", "error", 3000);
        }
    }

    function handleReflectOnKeyword(keyword, index = 0) {
        console.log("Reflect Now clicked for keyword:", keyword, "at index:", index);
        
        // Close the modal first
        hideLiminalModal();

        // Disable this keyword's buttons in the chat UI to prevent double-dipping
        try {
            if (!disableLastActionButtonHolder('launched')) {
                // Fallback to keyword-based disable if holder not found
                disableKeywordInChat(keyword, 'launched');
            }
        } catch (e) {
            console.debug('Could not disable keyword holder in chat (non-fatal):', e);
        }
        
        // Generate tracking ID for this reflection opportunity
        const trackingId = `spark_reflection_${Date.now()}_${keyword.replace(/\s+/g, '_').toLowerCase()}`;
        
        // Check for gist conditions (in-the-moment only) - only for the first keyword (most likely)
        let gistToPass = null;
        if (index === 0 && CURR_CLARITY_RESULTS && 
            CURR_CLARITY_RESULTS.gist && 
            CURR_CLARITY_RESULTS.intent === 'learning_capture') {
            
            const gist = CURR_CLARITY_RESULTS.gist.trim();
            const wordCount = gist.split(/\s+/).filter(word => word.length > 0).length;
            
            if (wordCount >= 12) {
                // Convert to first person for reflection
                gistToPass = convertToFirstPerson(gist);
                console.log(`Gist meets criteria (${wordCount} words), converted to first person for reflection (first keyword only)`);
            }
        } else if (index > 0) {
            console.log(`Not passing gist for keyword "${keyword}" at index ${index} - only first keyword gets gist`);
        } else {
            console.log(`No gist conditions met for keyword "${keyword}" at index ${index}`);
        }
        
        // Show the reflective practice panel with enhanced parameters
        console.log(`Calling showReflectivePracticePanel with: keyword="${keyword}", index=${index}, gist=${gistToPass ? 'YES' : 'NO'}`);
        showReflectivePracticePanel(keyword, "Reflective Learning Moment", trackingId, gistToPass);
    }
    
    function handleOpenFinalizeReflection(url) {
        console.log("Opening finalize reflection URL:", url);
        
        // Close the modal first
        hideLiminalModal();
        
        // Show the reflective practice panel with the finalize-reflection URL
        showReflectivePracticePanelWithURL(url);
    }
    
    function handleDiscoverMoreCredits() {
        console.log("Transitioning from discovery mode to chat mode");
        
        // Remove the smart chat message so user can't click it again
        const smartChatMessage = document.getElementById('smart-chat-message');
        if (smartChatMessage) {
            // Find the parent wrapper div to remove the entire message
            const smartChatWrapper = smartChatMessage.parentNode;
            if (smartChatWrapper && smartChatWrapper.className.includes('flex items-start space-x-3')) {
                smartChatWrapper.remove();
                console.log("Removed smart chat message after click");
            } else {
                smartChatMessage.remove();
                console.log("Removed smart chat message (fallback removal)");
            }
        }
        
        // Check if gist is available and intent is reflective-chat
        if (CURR_CLARITY_RESULTS && CURR_CLARITY_RESULTS.gist && CURR_CLARITY_RESULTS.intent === 'learning_capture') {
            const gist = CURR_CLARITY_RESULTS.gist.trim();
            if (gist.length > 0) {
                console.log("Auto-sending gist to continue reflective conversation:", gist);
                
                // Exit discovery mode first
                exitDiscoveryMode();
                
                // Wait a moment for discovery mode to exit, then simulate typing the gist
                setTimeout(() => {
                    const chatInput = document.getElementById('chat-input');
                    if (chatInput) {
                        // Set the gist as input value
                        chatInput.value = gist;
                        
                        // Trigger the regular sendChatMessage flow
                        // This will handle adding to UI, typing indicators, and sending to API
                        const sendEvent = new KeyboardEvent('keydown', {
                            key: 'Enter',
                            shiftKey: false
                        });
                        chatInput.dispatchEvent(sendEvent);
                        
                        console.log('Auto-sent gist via chat system:', gist);
                    }
                }, 500); // Slightly longer delay to ensure chat is ready
                
                return;
            }
        }
        
        // Fallback: just exit discovery mode normally
        exitDiscoveryMode();
    }

    // Fetch and populate the context dropdown with user's most common ipoc_contexts from past 360 days
    async function populateContextDropdown() {
        const dropdown = document.getElementById('narrative-context-dropdown');
        if (!dropdown) return;

        try {
            // Get Firebase token
            const utoken = await firebase.auth().currentUser.getIdToken();
            
            // Calculate date 360 days ago
            const now = new Date();
            const days360Ago = new Date(now.getTime() - (360 * 24 * 60 * 60 * 1000));
            
            // Query user's reflections from past 360 days
            const uid = firebase.auth().currentUser.uid;
            console.log('Fetching contexts for user:', uid);
            
            // Query reflections using reflectedOn as timestamp (confirmed by user)
            let querySnapshot;
            try {
                const days360AgoTimestamp = days360Ago.getTime();
                console.log(`Querying reflections with reflectedOn > ${days360AgoTimestamp}`);
                
                const reflectionsRef = firebase.firestore().collection('reflections').doc(uid).collection('reflective-practice')
                    .where('reflectedOn', '>', days360AgoTimestamp)
                    .orderBy('reflectedOn', 'desc')
                    .limit(100);
                
                querySnapshot = await reflectionsRef.get();
                console.log(`Found ${querySnapshot.size} reflections using reflectedOn field (timestamp)`);
                
                // If no results with date filter, get recent reflections without filter
                if (querySnapshot.size === 0) {
                    console.log('No reflections found with date filter, trying without date filter...');
                    const reflectionsRef2 = firebase.firestore().collection('reflections').doc(uid).collection('reflective-practice')
                        .orderBy('reflectedOn', 'desc')
                        .limit(100);
                    
                    querySnapshot = await reflectionsRef2.get();
                    console.log(`Fallback: Found ${querySnapshot.size} reflections without date filter`);
                }
            } catch (error) {
                console.error('Error querying reflections:', error);
                // Final fallback: get any reflections
                try {
                    const reflectionsRef3 = firebase.firestore().collection('reflections').doc(uid).collection('reflective-practice')
                        .limit(50);
                    querySnapshot = await reflectionsRef3.get();
                    console.log(`Final fallback: Found ${querySnapshot.size} reflections without any filters`);
                } catch (finalError) {
                    console.error('Final fallback also failed:', finalError);
                    querySnapshot = { size: 0, forEach: () => {} }; // Empty result
                }
            }
            
            // Count ipoc_context frequency
            const contextCounts = {};
            let totalDocs = 0;
            let docsWithContext = 0;
            
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                totalDocs++;
                
                // Debug: log first few documents to see structure
                if (totalDocs <= 3) {
                    console.log(`Reflection ${totalDocs} data:`, {
                        id: doc.id,
                        ipoc_context: data.ipoc_context,
                        reflectedOn: data.reflectedOn,
                        timestamp: data.timestamp,
                        keys: Object.keys(data)
                    });
                }
                
                if (data.ipoc_context && data.ipoc_context.trim()) {
                    const context = data.ipoc_context.trim();
                    contextCounts[context] = (contextCounts[context] || 0) + 1;
                    docsWithContext++;
                }
            });
            
            console.log(`Context analysis: ${totalDocs} total docs, ${docsWithContext} with contexts, ${Object.keys(contextCounts).length} unique contexts`);
            console.log('Context counts:', contextCounts);
            
            // Sort contexts by frequency
            const sortedContexts = Object.entries(contextCounts)
                .sort(([,a], [,b]) => b - a)
                .slice(0, 15); // Top 15 most common contexts
            
            // Clear dropdown and add options
            dropdown.innerHTML = '<option value="">Select a learning context</option>';
            
            const generateBtn = document.querySelector('[data-task="generate-context-summary"]');
            
            if (sortedContexts.length === 0) {
                dropdown.innerHTML += '<option value="" disabled>No contexts found in past year</option>';
                if (generateBtn) generateBtn.disabled = true;
                
                // Add debugging option to see what we found
                if (totalDocs > 0) {
                    dropdown.innerHTML += `<option value="" disabled>Found ${totalDocs} reflections but ${docsWithContext} had contexts</option>`;
                }
            } else {
                sortedContexts.forEach(([context, count]) => {
                    const option = document.createElement('option');
                    option.value = context;
                    option.textContent = `${context} (${count})`;
                    dropdown.appendChild(option);
                });
                
                // Enable generate button when context is selected
                dropdown.addEventListener('change', function() {
                    if (generateBtn) {
                        generateBtn.disabled = !this.value;
                    }
                });
            }
            
            console.log(`Populated context dropdown with ${sortedContexts.length} contexts from past 360 days`);
            
        } catch (error) {
            console.error('Error populating context dropdown:', error);
            dropdown.innerHTML = '<option value="">Error loading contexts</option>';
            
            // Additional debugging - try a simple query to see if we can access reflections at all
            console.log('Attempting simple reflection query for debugging...');
            try {
                const simpleRef = firebase.firestore().collection('reflections').doc(uid).collection('reflective-practice').limit(3);
                const simpleSnapshot = await simpleRef.get();
                console.log('Simple query result:', {
                    size: simpleSnapshot.size,
                    docs: simpleSnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() }))
                });
            } catch (simpleError) {
                console.error('Even simple query failed:', simpleError);
            }
        }
    }

    // Generate and display narrative for stakeholder sharing
    async function handleShareNarrative(stakeholderType) {
        console.log(`handleShareNarrative called for stakeholder: ${stakeholderType}`);
        
        // Check subscription status - narratives are a premium feature
        if (CURR_STRIPESTATUS === false) {
            const stakeholderTitle = stakeholderType.charAt(0).toUpperCase() + stakeholderType.slice(1);
            showValidationModal('⚠️ Only available to subscribers ⚠️', 
                `Generate professional narratives from your reflections for key stakeholders! These comprehensive summaries showcase your learning journey, insights, and professional growth.<br/><br/>Perfect for performance reviews, coaching sessions, and professional development discussions.<br/><br/>Click below to unlock unlimited narratives, transcripts, and more premium features for just $50/yr.`, 
                'Subscribe now',
                function(){
                    mixpanel.track('Click to Subscribe for Narratives Feature', {stakeholderType: stakeholderType});
                    try { if (typeof analytics !== 'undefined' && analytics && analytics.track) { analytics.track('learnerplus_click_to_subscribe_for_narratives', {stakeholderType: stakeholderType}); } } catch(e){}
                    performTask("start-subscription");
                }, 
                'Not now', 
                function(){
                    mixpanel.track('Subscription Prompt Dismissed for Narratives Feature', {stakeholderType: stakeholderType});
                    performTask('validationmodal-dismiss');
                }
            );
            return;
        }
        
        // Close the credit modal since user is taking action
        const modal = document.getElementById('creditDrawer');
        if (modal && !modal.classList.contains('hidden')) {
            toggleCreditDrawer();
        }
        
        // Validate stakeholder type (pre-fab narratives only)
        const validStakeholders = ['coach', 'manager', 'risk', 'quality'];
        if (!validStakeholders.includes(stakeholderType)) {
            showNotification("Invalid Request", "Unknown stakeholder type requested.", "error", 3000);
            return;
        }
        
        try {
            // Show initial non-blocking notification with stakeholder-specific message
            const stakeholderTitle = stakeholderType.charAt(0).toUpperCase() + stakeholderType.slice(1);
            showNotification("Generating Narrative", `Analyzing your reflective practice to create a comprehensive ${stakeholderType} narrative... We'll let you know when it's ready!`, "info", 4000);
            
            // Get Firebase token
            const utoken = await firebase.auth().currentUser.getIdToken();
            
            // Determine API endpoint based on stakeholder type
            const endpointMap = {
                'coach': '/generate-coaching-narrative',
                'manager': '/generate-manager-narrative',
                'risk': '/generate-risk-narrative',
                'quality': '/generate-quality-narrative'
            };
            const endpoint = endpointMap[stakeholderType];
            
            // Create axios instance without interceptors to avoid loading overlay
            const axiosNoLoading = axios.create();
            
            // Show subtle progress bar for background activity
            showProgressBar();
            
            // Prepare request payload (no context - analyze all reflections)
            const requestPayload = {
                utoken: utoken
            };
            
            // Make non-blocking API call
            axiosNoLoading.post(endpoint, requestPayload).then((response) => {
                console.log(`${stakeholderTitle} narrative response:`, response.data);
                
                // Check for insufficient data
                if (response.data.error === 'insufficient_data') {
                    showNotification("More Reflections Needed", response.data.message, "info", 6000);
                    return;
                }
                
                // Check for not implemented
                if (response.data.error === 'not_implemented') {
                    showNotification("Feature Coming Soon", response.data.message || "This narrative type is not yet available", "info", 6000);
                    return;
                }
                
                // Check for generation failure
                if (response.data.error) {
                    showNotification("Generation Failed", response.data.message || "Unable to generate narrative at this time", "error", 6000);
                    return;
                }
                
                // Show success notification when ready
                showNotification("Narrative Ready!", `Your ${stakeholderType} narrative has been generated and is ready to view.`, "success", 4000);
                
                // Show the narrative in a modal after a brief delay to let user see the success message
                setTimeout(() => {
                    showNarrativeModal(response.data.narrative, stakeholderType, response.data.metadata);
                }, 500);
                
            }).catch((error) => {
                console.error('Error generating narrative:', error);
                
                let errorMessage = "Unable to generate narrative at this time";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                
                showNotification("Generation Failed", errorMessage, "error", 6000);
            }).finally(() => {
                // Always hide progress bar when operation completes
                hideProgressBar();
            });
            
        } catch (error) {
            console.error('Error in narrative generation setup:', error);
            showNotification("Error", "Unable to start narrative generation", "error", 5000);
            // Hide progress bar on setup error
            hideProgressBar();
        }
    }
    
    // Handle context-specific summary generation
    async function handleContextSummary() {
        console.log('handleContextSummary called');
        
        // Check subscription status - context summaries are a premium feature
        if (CURR_STRIPESTATUS === false) {
            showValidationModal('⚠️ Only available to subscribers ⚠️', 
                `Generate focused summaries of your learning by specific contexts! Perfect for preparing for reviews, analyzing specific events, or creating targeted professional development reports.<br/><br/>Context-focused narratives help you showcase learning from specific situations, projects, or time periods.<br/><br/>Click below to unlock context summaries, narratives, transcripts, and more premium features for just $50/yr.`, 
                'Subscribe now',
                function(){
                    mixpanel.track('Click to Subscribe for Context Summary Feature', {});
                    try { if (typeof analytics !== 'undefined' && analytics && analytics.track) { analytics.track('learnerplus_click_to_subscribe_for_context_summary', {}); } } catch(e){}
                    performTask("start-subscription");
                }, 
                'Not now', 
                function(){
                    mixpanel.track('Subscription Prompt Dismissed for Context Summary Feature', {});
                    performTask('validationmodal-dismiss');
                }
            );
            return;
        }
        
        // Get selected context
        const dropdown = document.getElementById('narrative-context-dropdown');
        const selectedContext = dropdown ? dropdown.value : '';
        
        if (!selectedContext) {
            showNotification("No Context Selected", "Please select a learning context to generate a summary.", "error", 3000);
            return;
        }
        
        // Close the credit modal since user is taking action
        const modal = document.getElementById('creditDrawer');
        if (modal && !modal.classList.contains('hidden')) {
            toggleCreditDrawer();
        }
        
        try {
            showNotification("Generating Context Summary", `Analyzing reflections from "${selectedContext}" context... We'll let you know when it's ready!`, "info", 4000);
            
            // Get Firebase token
            const utoken = await firebase.auth().currentUser.getIdToken();
            
            // Create axios instance without interceptors to avoid loading overlay
            const axiosNoLoading = axios.create();
            
            // Show subtle progress bar for background activity
            showProgressBar();
            
            // Make non-blocking API call
            axiosNoLoading.post('/generate-context-summary', {
                utoken: utoken,
                ipoc_context: selectedContext
            }).then((response) => {
                console.log('Context summary response:', response.data);
                
                // Check for insufficient data
                if (response.data.error === 'insufficient_data') {
                    showNotification("More Reflections Needed", response.data.message, "info", 6000);
                    return;
                }
                
                // Check for not implemented
                if (response.data.error === 'not_implemented') {
                    showNotification("Feature Coming Soon", response.data.message || "Context summary generation is not yet available", "info", 6000);
                    return;
                }
                
                // Check for generation failure
                if (response.data.error) {
                    showNotification("Generation Failed", response.data.message || "Unable to generate context summary at this time", "error", 6000);
                    return;
                }
                
                // Show success notification when ready
                showNotification("Context Summary Ready!", `Your "${selectedContext}" summary has been generated and is ready to view.`, "success", 4000);
                
                // Show the summary in a modal after a brief delay
                setTimeout(() => {
                    showNarrativeModal(response.data.summary, `${selectedContext} Summary`, response.data.metadata);
                }, 500);
                
            }).catch((error) => {
                console.error('Error generating context summary:', error);
                
                let errorMessage = "Unable to generate context summary at this time";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                
                showNotification("Generation Failed", errorMessage, "error", 6000);
            }).finally(() => {
                // Always hide progress bar when operation completes
                hideProgressBar();
            });
            
        } catch (error) {
            console.error('Error in context summary generation setup:', error);
            showNotification("Error", "Unable to start context summary generation", "error", 5000);
            hideProgressBar();
        }
    }
    
    // Simple, safe-ish markdown parser (used for chat + narrative)
    function parseMarkdownToHTML(markdown) {
        if (!markdown) return '';
        
        // Escape HTML first to prevent injection
        const escaped = String(markdown)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        
        let html = escaped
            // Convert bold text (**text** or __text__)
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/__(.*?)__/g, '<strong>$1</strong>')
            
            // Convert headers
            .replace(/^### (.*$)/gm, '<h3 class="text-md font-semibold text-gray-900 mt-6 mb-3">$1</h3>')
            .replace(/^## (.*$)/gm, '<h2 class="text-lg font-semibold text-gray-900 mt-6 mb-3">$1</h2>')
            .replace(/^# (.*$)/gm, '<h1 class="text-lg font-bold text-gray-900 mt-6 mb-4">$1</h1>')
            
            // Convert bullet points (• or -)
            .replace(/^[•-] (.*$)/gm, '<li class="mb-1">$1</li>')
            
            // Convert simple numbered lists (1. item)
            .replace(/^\d+\. (.*$)/gm, '<li class="mb-1">$1</li>')
            
            // Convert italic text (*text* or _text_)
            .replace(/\*(.*?)\*/g, '<em>$1</em>')
            .replace(/_(.*?)_/g, '<em>$1</em>')
            
            // Linkify plain URLs
            .replace(/((https?:\/\/)[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener" class="text-teal-600 underline break-all">$1<\/a>')
            
            // Convert line breaks to paragraphs
            .replace(/\n\n/g, '</p><p class="mb-4">')
            .replace(/\n/g, '<br>');
        
        // Wrap consecutive <li> blocks into a single <ul>
        html = html.replace(/(?:^|\n)(<li class=\"mb-1\">[\s\S]*?<\/li>)(?=\n|$)/g, function(match, li) {
            return '<ul class="list-disc list-inside mb-2 ml-4">' + li + '</ul>';
        });
        
        // Merge adjacent ULs created by the wrapper above
        html = html.replace(/<\/ul>\s*<ul class=\"list-disc list-inside mb-4 ml-4\">/g, '');
        
        // Wrap content in paragraph if it doesn't start with a tag
        if (!html.startsWith('<')) {
            html = '<p class="mb-4">' + html + '</p>';
        } else {
            html = html.replace(/^/, '<p class="mb-4">').replace(/$/, '</p>');
        }
        
        // Clean up empty paragraphs
        html = html.replace(/<p class="mb-4"><\/p>/g, '');
        
        return html;
    }

    // Display narrative in a copyable modal interface
    function showNarrativeModal(narrative, stakeholderType, metadata) {
        const stakeholderTitle = stakeholderType.charAt(0).toUpperCase() + stakeholderType.slice(1);
        
        const modalHTML = `
            <div id="narrativeModal" class="fixed inset-0 z-[99999] bg-black bg-opacity-50 flex items-center justify-center p-4 backdrop-blur-sm">
                <div class="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                    <!-- Header -->
                    <div class="flex items-center justify-between p-6 border-b border-gray-200">
                        <div>
                            <h2 class="text-xl font-semibold text-gray-900">${stakeholderTitle} Narrative</h2>
                            <p class="text-sm text-gray-600 mt-1">Based on ${metadata.reflection_count} reflections from ${metadata.data_period.replace(/_/g, ' ')}</p>
                        </div>
                        <button onclick="closeNarrativeModal()" class="text-gray-400 hover:text-gray-600 rounded-lg p-2 hover:bg-gray-100 transition-colors">
                            <i class="fa-solid fa-times text-xl"></i>
                        </button>
                    </div>
                    
                    <!-- Content -->
                    <div class="flex-1 p-6 overflow-y-auto">
                        <div class="bg-gray-50 rounded-lg p-6 mb-4">
                            <div class="flex items-center justify-between mb-4">
                                <h3 class="font-medium text-gray-900">Generated Narrative</h3>
                                <button onclick="copyNarrativeToClipboard()" class="bg-learner-plus-blue text-white px-4 py-2 rounded-lg hover:bg-learner-dark-blue transition-colors text-sm font-medium">
                                    <i class="fa-solid fa-copy mr-2"></i>Copy to Clipboard
                                </button>
                            </div>
                            <div id="narrativeContent" class="prose max-w-none text-gray-800 leading-relaxed bg-white p-4 rounded border">
${parseMarkdownToHTML(narrative)}
                            </div>
                        </div>
                        
                        <div class="bg-blue-50 rounded-lg p-4 border border-blue-200">
                            <div class="flex items-start">
                                <i class="fa-solid fa-shield-halved text-blue-600 mr-3 mt-1 flex-shrink-0"></i>
                                <div>
                                    <h4 class="font-medium text-blue-900 mb-1">Privacy Protected</h4>
                                    <p class="text-blue-700 text-sm">This narrative contains only curated insights from your reflective practice. No personal patient information, raw reflections, or sensitive details are included.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Footer -->
                    <div class="border-t border-gray-200 px-6 py-4 bg-gray-50 rounded-b-xl">
                        <div class="flex items-center justify-between">
                            <p class="text-xs text-gray-500">Generated on ${new Date(metadata.generated_at).toLocaleDateString()}</p>
                            <div class="flex gap-3">
                                <button onclick="closeNarrativeModal()" class="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors text-sm">
                                    Close
                                </button>
                                <button onclick="copyNarrativeAndClose()" class="bg-slate-600 text-white px-4 py-2 rounded-lg hover:bg-slate-700 transition-colors text-sm font-medium">
                                    Copy & Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;
        
        // Add modal to page
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        
        // Store narrative globally for copying
        window.currentNarrative = narrative;
        
        // Show success notification
        showNotification("Narrative Ready", `Your ${stakeholderType} narrative has been generated and is ready to share.`, "success", 3000);
    }
    
    // Copy narrative to clipboard
    window.copyNarrativeToClipboard = function() {
        if (window.currentNarrative) {
            navigator.clipboard.writeText(window.currentNarrative).then(() => {
                showNotification("Copied!", "Narrative copied to clipboard", "success", 2000);
            }).catch((err) => {
                console.error('Failed to copy to clipboard:', err);
                showNotification("Copy Failed", "Please select and copy the text manually", "error", 3000);
            });
        }
    };
    
    // Copy narrative to clipboard and close modal
    window.copyNarrativeAndClose = function() {
        if (window.currentNarrative) {
            navigator.clipboard.writeText(window.currentNarrative).then(() => {
                showNotification("Copied!", "Narrative copied to clipboard", "success", 2000);
                // Close modal after successful copy
                closeNarrativeModal();
            }).catch((err) => {
                console.error('Failed to copy to clipboard:', err);
                showNotification("Copy Failed", "Please select and copy the text manually", "error", 3000);
            });
        }
    };
    
    // Close narrative modal
    window.closeNarrativeModal = function() {
        const modal = document.getElementById('narrativeModal');
        if (modal) {
            modal.remove();
        }
        delete window.currentNarrative;
    };

    function convertToFirstPerson(text) {
        if (!text || text.trim().length === 0) return text;
        
        // Simple pronoun and verb replacements
        let converted = text
            // Pronouns
            .replace(/\bYou\b/g, 'I')
            .replace(/\byou\b/g, 'I')
            .replace(/\bYour\b/g, 'My')
            .replace(/\byour\b/g, 'my')
            .replace(/\bYou're\b/g, 'I am')
            .replace(/\byou're\b/g, 'I am')
            .replace(/\bYou've\b/g, 'I have')
            .replace(/\byou've\b/g, 'I have')
            
            // Common verb forms
            .replace(/\bYou have\b/g, 'I have')
            .replace(/\byou have\b/g, 'I have')
            .replace(/\bYou are\b/g, 'I am')
            .replace(/\byou are\b/g, 'I am')
            .replace(/\bYou were\b/g, 'I was')
            .replace(/\byou were\b/g, 'I was')
            .replace(/\bYou can\b/g, 'I can')
            .replace(/\byou can\b/g, 'I can')
            .replace(/\bYou should\b/g, 'I should')
            .replace(/\byou should\b/g, 'I should')
            .replace(/\bYou need\b/g, 'I need')
            .replace(/\byou need\b/g, 'I need')
            
            // Fix capitalization after sentence starts
            .replace(/^i\b/, 'I')
            .replace(/\. i\b/g, '. I');
        
        return converted;
    }

    
    function showReflectivePracticePanel(keyword = null, context = null, trackingId = null, gist = null) {
        console.log("Opening reflective practice panel", keyword ? `for keyword: ${keyword}` : "");
        
        // Reset reflection completion flag for new session
        reflectionCompleted = false;
        
        const panel = document.getElementById('reflectivePracticePanel');
        const iframe = document.getElementById('reflectivePracticeIframe');
        
        if (!panel || !iframe) {
            console.error("Reflective practice panel elements not found");
            return;
        }
        
        // Construct the enhanced URL with proper parameters
        let practiceUrl = '/reflective-practice';
        const params = new URLSearchParams();
        
        // Add ipoc_keyword if provided
        if (keyword) {
            params.append('ipoc_keyword', keyword);
        }
        
        // Add ipoc_context, defaulting to "Reflective Learning Moment" if not provided
        const ipocContext = context || "Reflective Learning Moment";
        params.append('ipoc_context', ipocContext);
        
        // Add tracking_id if provided, or generate one intelligently
        let finalTrackingId = trackingId;
        if (!finalTrackingId && keyword) {
            finalTrackingId = `learnerplus-go_${Date.now()}_${keyword.replace(/\s+/g, '_').toLowerCase()}`;
        } else if (!finalTrackingId) {
            finalTrackingId = `learnerplus-go_${Date.now()}_reflection`;
        }
        params.append('tracking_id', finalTrackingId);
        
        // Add wrapup_url for auto-close behavior
        params.append('wrapup_url', '/reflection-done');
        
        // Add source parameter to identify learnerplus-go and enable duplicate prevention
        params.append('source', 'learnerplus-go');
        
        // Add timestamp to ensure unique URL for each reflection (prevent caching)
        params.append('_t', Date.now().toString());
        
        // OFF: Add gist parameter if provided (immediate reflection only)
        // if (gist && gist.trim().length > 0) {
        //     params.append('gist', gist.trim());
        //     console.log(`Added gist parameter for immediate reflection: "${gist.trim().substring(0, 50)}..."`);
        // } else {
        //     console.log('No gist parameter added - gist was null, undefined, or empty');
        // }
        
        if (params.toString()) {
            practiceUrl += '?' + params.toString();
        }
        
        console.log('Generated reflective practice URL:', practiceUrl);
        
        // Clear iframe first to ensure fresh start
        iframe.src = 'about:blank';
        
        // Small delay to ensure clearing happens before loading new URL
        setTimeout(() => {
            iframe.src = practiceUrl;
        }, 50);
        
        // Show the panel with animation
        panel.classList.remove('hidden');
        // Use setTimeout to ensure the display change happens before the animation
        setTimeout(() => {
            panel.classList.add('show');
        }, 10);
        
        // Prevent body scroll when panel is open
        document.body.style.overflow = 'hidden';
        // Show accredited activity notification modal
        showAccreditedActivityNotification();
        //
    }
    
    function showReflectivePracticePanelWithURL(url) {
        console.log("Opening reflective practice panel with URL:", url);
        
        // Reset reflection completion flag for new session
        reflectionCompleted = false;
        
        const panel = document.getElementById('reflectivePracticePanel');
        const iframe = document.getElementById('reflectivePracticeIframe');
        
        if (!panel || !iframe) {
            console.error("Reflective practice panel elements not found");
            return;
        }
        
        // Load the provided URL directly in the iframe
        iframe.src = url;
        
        // Show the panel with animation
        panel.classList.remove('hidden');
        // Use setTimeout to ensure the display change happens before the animation
        setTimeout(() => {
            panel.classList.add('show');
        }, 10);
        
        // Prevent body scroll when panel is open
        document.body.style.overflow = 'hidden';
        
        // Show accredited activity notification modal
        showAccreditedActivityNotification();
        
        showNotification(
            "Reflective Practice", 
            "Opening finalize reflection interface", 
            "info", 
            2000
        );
    }
    
    function hideReflectivePracticePanel() {
        console.log("Closing reflective practice panel");
        
        const panel = document.getElementById('reflectivePracticePanel');
        const iframe = document.getElementById('reflectivePracticeIframe');
        
        if (!panel) {
            return;
        }
        
        // Reset reflection completion flag for next session
        reflectionCompleted = false;
        
        // Hide with animation
        panel.classList.remove('show');
        
        // Wait for animation to complete before hiding
        setTimeout(() => {
            panel.classList.add('hidden');
            // Clear the iframe src to stop any ongoing processes
            if (iframe) {
                iframe.src = 'about:blank';
            }
            
            // Restore body scroll
            document.body.style.overflow = '';
        }, 300);
    }
    
    
    // Flag to prevent multiple /reflection-done triggers (module-level)
    let reflectionCompleted = false;
    
    // Show accredited activity notification modal
    function showAccreditedActivityNotification() {
        // Create modal element
        const modal = document.createElement('div');
        modal.className = 'fixed inset-0 z-[10001] flex items-center justify-center backdrop-blur-lg';
        modal.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        
        modal.innerHTML = `
            <div class="bg-white rounded-lg shadow-xl max-w-md mx-4 p-6 transform transition-all">
                <div class="flex items-center mb-4">
                    <div class="bg-green-100 p-2 rounded-full mr-3">
                        <i class="fa-solid fa-certificate text-green-600 text-lg"></i>
                    </div>
                    <h3 class="text-lg font-semibold text-gray-900">Accredited Activity</h3>
                </div>
                <p class="text-gray-700 text-sm mb-4">
                    You are now entering the accredited Reflective Practice™ activity.
                    <a href="https://reflective.credit/activities/ReflectivePractice_ADP_CreditInfo_JSKJM.pdf" target="_blank" class="text-blue-600 hover:underline">About CME/CE Credit</a>
                </p>
                <div class="flex justify-center">
                    <div class="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
            </div>
        `;
        
        // Add to body
        document.body.appendChild(modal);
        
        // Auto-remove after 7 seconds
        setTimeout(() => {
            if (modal && modal.parentNode) {
                modal.parentNode.removeChild(modal);
            }
        }, 7000);
    }
    
    // Initialize panel event listeners
    function initializeReflectivePracticePanel() {
        const panelOverlay = document.getElementById('reflectivePracticePanel');
        const iframe = document.getElementById('reflectivePracticeIframe');
        
        // Overlay clicking and escape key closing removed - using alternative approach
        
        // Listen for postMessage from iframe (primary method for learner+go)
        window.addEventListener('message', (event) => {
            // Verify message is from our iframe
            if (iframe && event.source === iframe.contentWindow) {
                console.log('Received postMessage from iframe:', event.data);
                
                if (event.data === 'reflection-complete' && !reflectionCompleted) {
                    handleReflectionComplete();
                } else if (event.data === 'reflection-cancelled') {
                    console.log('Reflection cancelled - closing panel');
                    hideReflectivePracticePanel();
                    
                    // Clear iframe src
                    iframe.src = 'about:blank';
                    
                    // Show brief notification
                    showNotification(
                        "Your reflection has been cancelled", 
                        "You can start a new one anytime.", 
                        "info", 
                        2000
                    );
                }
            }
        });
        
        // Monitor iframe URL changes for auto-close behavior (fallback method)
        if (iframe) {
            // Monitor iframe load events to detect /reflection-done
            iframe.addEventListener('load', () => {
                try {
                    const iframeUrl = iframe.contentWindow.location.pathname;
                    console.log('Iframe navigated to:', iframeUrl);
                    
                    if (iframeUrl === '/reflection-done' && !reflectionCompleted) {
                        handleReflectionComplete();
                    }
                } catch (error) {
                    // Cross-origin issues are expected, ignore them
                    // The iframe URL monitoring will work for same-origin navigation
                    console.debug('Cannot access iframe URL (likely cross-origin):', error.message);
                }
            });
        }
        
        // Centralized reflection completion handler
        function handleReflectionComplete() {
            console.log('Reflection completed - auto-closing panel');
            reflectionCompleted = true; // Prevent multiple triggers
            
            // Show success notification
            showNotification(
                "Reflection Complete!", 
                "Your draft has been saved successfully", 
                "success", 
                3000
            );
            
            // Auto-close the panel after a short delay
            setTimeout(() => {
                hideReflectivePracticePanel();
                
                // Clear iframe src for next reflection
                iframe.src = 'about:blank';
                
                // Reset flag for next reflection session
                reflectionCompleted = false;
            }, 1500);
        }
    }

    function handleSnoozeKeyword(keyword, duration) {
        console.log("Snooze clicked for keyword:", keyword, "duration:", duration);
        
        // Check subscription status - snooze is a premium feature
        if (CURR_STRIPESTATUS === false) {
            showValidationModal('⚠️ Only available to subscribers ⚠️', 
                `Save topics for later reflection and never lose track of important learning opportunities! Snoozing helps you organize your reflective practice and ensures you can revisit topics when you have more time.<br/><br/>Click below to unlock unlimited reflections, topic snoozing, draft saving, and more premium features for just $50/yr.`, 
                'Subscribe now',
                function(){
                    mixpanel.track('Click to Subscribe for Snooze Feature', {keyword: keyword, duration: duration});
                    performTask("start-subscription");
                }, 
                'Not now', 
                function(){
                    mixpanel.track('Subscription Prompt Dismissed for Snooze Feature', {keyword: keyword, duration: duration});
                    performTask('validationmodal-dismiss');
                }
            );
            return;
        }
        
        // Check if keyword already exists in active snoozed nudges (case insensitive)
        const existingSnooze = CURR_SMART_NUDGES.find(nudge => 
            nudge.content.toLowerCase() === keyword.toLowerCase() && nudge.status !== 'used'
        );
        
        if (existingSnooze) {
            showNotification(
                "Already Saved", 
                `"${keyword}" is already in your saved items`, 
                "warning", 
                3000
            );
            return;
        }
        
        // Get IPOC context from clarity results or use default
        const ipocContext = (CURR_CLARITY_RESULTS && CURR_CLARITY_RESULTS.ipoc_context) 
            ? CURR_CLARITY_RESULTS.ipoc_context 
            : "Reflective Learning Moment";
        
        // 1. Disable keyword in chat display (prefer the closest holder)
        if (!disableLastActionButtonHolder('saved')) {
            disableKeywordInChat(keyword, 'saved');
        }
        
        // Generate tracking ID for analytics
        const trackingId = `reflectionnudge_snoozed_${Date.now()}_${keyword.replace(/\s+/g, '_').toLowerCase()}`;
        
        // 2. Save to Firebase and refresh UI from Firebase with IPOC context
        addSnoozedNudge(keyword, duration, null, trackingId, ipocContext);
        
        showNotification(
            "Saved", 
            `"${keyword}" saved for later`, 
            "success", 
            2000
        );
    }
    
    function removeKeywordFromChat(keyword) {
        // Remove the specific keyword from the credit opportunities UI
        const chatMessages = document.getElementById('chat-messages');
        if (!chatMessages) return;
        
        // Look for the IPOC keywords section in both UI elements and chat messages
        const ipocDivs = chatMessages.querySelectorAll('.animate-fadeIn-ui, .animate-fadeIn');
        ipocDivs.forEach(div => {
            const keywordSpans = div.querySelectorAll('span');
            keywordSpans.forEach(span => {
                if (span.textContent.trim() === keyword) {
                    // Remove the entire keyword container
                    const keywordContainer = span.closest('.flex.items-center.justify-between');
                    if (keywordContainer) {
                        keywordContainer.remove();
                        console.log(`Removed keyword "${keyword}" from credit opportunities display`);
                        
                        // Check if all keywords are gone from the Credit Opportunities container
                        const creditContainer = document.getElementById('credit-opportunities-container');
                        if (creditContainer) {
                            const remainingKeywords = creditContainer.querySelectorAll('.flex.items-center.justify-between');
                            if (remainingKeywords.length === 0) {
                                creditContainer.remove();
                                console.log('✅ Removed empty "Credit Opportunities" container');
                            }
                            
                            // Check if we should exit discovery mode (no more IPOC keywords visible)
                            const discoveryContainer = document.getElementById('discovery-mode-container');
                            if (discoveryContainer) {
                                // Check for any remaining keyword buttons in the chat
                                const remainingKeywordButtons = chatMessages.querySelectorAll('[data-task^="reflect-now::"]');
                                if (remainingKeywordButtons.length === 0) {
                                    console.log('No more IPOC keywords - exiting discovery mode');
                                    exitDiscoveryMode();
                                }
                            }
                        }
                    }
                }
            });
        });
    }
    
    // Disable a specific keyword holder in the chat (keeps visual trail)
    function disableKeywordInChat(keyword, status = 'done') {
        const chatMessages = document.getElementById('chat-messages');
        if (!chatMessages) return false;
        let updated = false;
        const holders = chatMessages.querySelectorAll('.flex.items-center.justify-between');
        holders.forEach(holder => {
            const span = holder.querySelector('span');
            if (span && span.textContent.trim() === keyword) {
                disableHolderElement(holder, status);
                updated = true;
            }
        });
        return updated;
    }

    // Helper: disable the immediate button holder from the last clicked ui-action-btn
    function disableLastActionButtonHolder(status = 'done') {
        const btn = window.LAST_UI_ACTION_BUTTON;
        if (!btn) return false;
        const holder = btn.closest('.flex.items-center.justify-between');
        if (holder) {
            disableHolderElement(holder, status);
            return true;
        }
        return false;
    }

    function disableHolderElement(holder, status = 'done') {
        // Dim the holder
        holder.classList.add('opacity-60');
        // Mark the keyword text as completed
        const span = holder.querySelector('span');
        if (span) span.classList.add('text-gray-400');
        
        // Disable all buttons inside
        holder.querySelectorAll('button').forEach(b => {
            b.setAttribute('disabled', 'true');
            b.classList.add('cursor-not-allowed', 'pointer-events-none', 'opacity-60');
            // Update reflect-now button text if applicable
            const task = b.getAttribute('data-task') || '';
            if (task.startsWith('reflect-now::') && /Reflect for Credit/.test(b.textContent)) {
                b.innerHTML = '<i class="fa-solid fa-check mr-1"></i>' + (status === 'saved' ? 'Saved' : 'Launched');
            }
        });
    }

    // Helper: remove the immediate button holder from the last clicked ui-action-btn
    function removeLastActionButtonHolder() {
        const btn = window.LAST_UI_ACTION_BUTTON;
        if (!btn) return false;
        const chatMessages = document.getElementById('chat-messages');
        const holder = btn.closest('.flex.items-center.justify-between');
        if (holder) {
            holder.remove();
            // If a credit container exists and is empty, remove it
            const creditContainer = document.getElementById('credit-opportunities-container');
            if (creditContainer) {
                const remaining = creditContainer.querySelectorAll('.flex.items-center.justify-between');
                if (remaining.length === 0) {
                    creditContainer.remove();
                    console.log('✅ Removed empty "Credit Opportunities" container');
                }
            }
            // If no REFLECT-NOW buttons remain and discovery mode is active, exit it
            if (chatMessages) {
                const remainingButtons = chatMessages.querySelectorAll('[data-task^="reflect-now::"]');
                if (remainingButtons.length === 0) {
                    const discoveryContainer = document.getElementById('discovery-mode-container');
                    if (discoveryContainer) {
                        console.log('No more IPOC keywords - exiting discovery mode');
                        exitDiscoveryMode();
                    }
                }
            }
            return true;
        }
        return false;
    }
    
    // Note: Snoozed nudges now stored in Firebase, no local array needed
    
    function addSnoozedNudge(keyword, duration, originalNudgeId = null, trackingId = null, ipocContext = null) {
        // Save to Firebase and then refresh UI from Firebase
        saveSnoozeToFirebase(keyword, duration, originalNudgeId, trackingId, ipocContext)
            .then((docRef) => {
                console.log('Snooze saved successfully, refreshing smart nudges from Firebase');
                // Refresh the entire smart nudges from Firebase after successful save
                fetchSmartNudges((nudges) => {
                    if (nudges && nudges.length > 0) {
                        renderSmartNudges(nudges);
                    } else {
                        const container = document.getElementById('smartnudges');
                        if (container) {
                            container.innerHTML = '';
                            container.classList.add('hidden');
                        }
                    }
                });
            })
            .catch((error) => {
                console.error('Failed to save snoozed nudge:', error);
                showNotification('Error', 'Failed to snooze item', 'error', 3000);
            });
    }
    
    function updateSmartNudges() {
        console.log('updateSmartNudges called - refreshing from Firebase instead of local array');
        // Refresh from Firebase instead of using local SNOOZED_NUDGES array
        fetchSmartNudges((nudges) => {
            if (nudges && nudges.length > 0) {
                renderSmartNudges(nudges);
            } else {
                const container = document.getElementById('smartnudges');
                if (container) {
                    container.innerHTML = '';
                    container.classList.add('hidden');
                }
            }
        });
    }

    // Removed dropdown functionality - snooze is now a simple direct action

    // Speech Recognition functionality
    function initSpeechRecognition() {
        const speechBtn = document.getElementById('liminal-speech-btn');
        const textarea = document.getElementById('liminal_spark');
        
        if (!speechBtn || !textarea) return;
        
        // Hide microphone button as requested - it's not working well
        speechBtn.style.display = 'none';
        console.log('Microphone button hidden as requested');
        return;
        
        // Check if browser supports speech recognition
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            speechBtn.style.display = 'none';
            console.warn('Speech recognition not supported in this browser');
            return;
        }
        
        const recognition = new SpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = 'en-US';
        
        let isRecording = false;
        let finalTranscript = '';
        let interimTranscript = '';
        
        // Update UI based on recording state
        function updateSpeechButton(recording) {
            const icon = speechBtn.querySelector('i');
            if (recording) {
                speechBtn.classList.remove('bg-slate-100', 'text-slate-500');
                speechBtn.classList.add('bg-red-500', 'text-white', 'animate-pulse');
                icon.className = 'fa fa-stop text-md font-medium';
                speechBtn.title = 'Stop voice input';
            } else {
                speechBtn.classList.remove('bg-red-500', 'text-white', 'animate-pulse');
                speechBtn.classList.add('bg-slate-100', 'text-slate-500');
                icon.className = 'fa fa-microphone text-md font-medium';
                speechBtn.title = 'Start voice input';
            }
        }
        
        // Handle speech recognition results
        recognition.onresult = function(event) {
            interimTranscript = '';
            
            for (let i = event.resultIndex; i < event.results.length; i++) {
                const transcript = event.results[i][0].transcript;
                
                if (event.results[i].isFinal) {
                    finalTranscript += transcript + ' ';
                } else {
                    interimTranscript += transcript;
                }
            }
            
            // Update textarea with both final and interim results
            const currentValue = textarea.value;
            const baseText = currentValue.replace(interimTranscript, ''); // Remove any previous interim text
            textarea.value = finalTranscript + interimTranscript;
            
            // Trigger textarea resize if it has auto-expand functionality
            const inputEvent = new Event('input', { bubbles: true });
            textarea.dispatchEvent(inputEvent);
        };
        
        recognition.onstart = function() {
            isRecording = true;
            updateSpeechButton(true);
            finalTranscript = textarea.value; // Preserve existing text
        };
        
        recognition.onend = function() {
            isRecording = false;
            updateSpeechButton(false);
            
            // Clean up final transcript
            if (finalTranscript) {
                textarea.value = finalTranscript.trim();
                finalTranscript = '';
                interimTranscript = '';
                
                // Trigger textarea resize
                const inputEvent = new Event('input', { bubbles: true });
                textarea.dispatchEvent(inputEvent);
            }
        };
        
        recognition.onerror = function(event) {
            console.error('Speech recognition error:', event.error);
            isRecording = false;
            updateSpeechButton(false);
            
            // Show user-friendly error message
            let errorMessage = 'Speech recognition error occurred.';
            switch(event.error) {
                case 'no-speech':
                    errorMessage = 'No speech detected. Please try again.';
                    break;
                case 'network':
                    errorMessage = 'Network error. Please check your connection.';
                    break;
                case 'not-allowed':
                    errorMessage = 'Microphone access denied. Please enable microphone permissions.';
                    break;
                case 'service-not-allowed':
                    errorMessage = 'Speech recognition service not available.';
                    break;
            }
            
            // Show notification if the function exists
            if (typeof showNotification === 'function') {
                showNotification('Speech Recognition', errorMessage, 'warning', 4000);
            } else {
                console.warn(errorMessage);
            }
        };
        
        // Toggle speech recognition on button click
        speechBtn.addEventListener('click', function() {
            if (isRecording) {
                recognition.stop();
            } else {
                try {
                    recognition.start();
                } catch (error) {
                    console.error('Failed to start speech recognition:', error);
                    if (typeof showNotification === 'function') {
                        showNotification('Speech Recognition', 'Failed to start voice input. Please try again.', 'error', 3000);
                    }
                }
            }
        });
    }

    // Auto-expanding textarea functionality
    function initAutoExpandingTextarea() {
        const textarea = document.getElementById('liminal_spark');
        if (!textarea) return;

        // Function to adjust textarea height
        function adjustTextareaHeight() {
            // Get computed styles for accurate measurements
            const computedStyle = window.getComputedStyle(textarea);
            const lineHeight = parseInt(computedStyle.lineHeight) || 20; // fallback to 20px
            const paddingTop = parseInt(computedStyle.paddingTop) || 0;
            const paddingBottom = parseInt(computedStyle.paddingBottom) || 0;
            const borderTop = parseInt(computedStyle.borderTopWidth) || 0;
            const borderBottom = parseInt(computedStyle.borderBottomWidth) || 0;
            
            const minRows = 3;
            const maxRows = 14;
            const totalPadding = paddingTop + paddingBottom + borderTop + borderBottom;
            const minHeight = (minRows * lineHeight) + totalPadding;
            
            // Reset to minimum height first to allow proper shrinking
            textarea.style.height = minHeight + 'px';
            
            // Calculate rows needed based on scroll height after reset
            const contentHeight = textarea.scrollHeight - totalPadding;
            const calculatedRows = Math.ceil(contentHeight / lineHeight);
            const targetRows = Math.max(minRows, Math.min(maxRows, calculatedRows));
            
            // Set the height based on target rows
            const targetHeight = (targetRows * lineHeight) + totalPadding;
            textarea.style.height = targetHeight + 'px';
            textarea.setAttribute('rows', targetRows);
        }


        // Add event listeners for input changes
        textarea.addEventListener('input', () => {
            adjustTextareaHeight();
            updateClearButtonVisibility();
            updateStartButtonStyling();
            try {
                if (!SPARK_TYPED_ONCE && (textarea.value || '').trim().length > 0) {
                    SPARK_TYPED_ONCE = true;
                    MP.track('Spark Started Typing', { spark_length: (textarea.value || '').length });
                }
            } catch(e) {}
        });
        textarea.addEventListener('keyup', () => {
            adjustTextareaHeight();
            updateClearButtonVisibility();
            updateStartButtonStyling();
        }); // Handle deletions/backspace
        textarea.addEventListener('paste', (e) => {
            try {
                const pasted = e && e.clipboardData ? (e.clipboardData.getData('text') || '') : '';
                if (pasted) {
                    const urlRegex = /(https?:\/\/[^\s]+)/gi;
                    const links = pasted.match(urlRegex) || [];
                    if (links.length > 0) {
                        const first = links[0];
                        let domain = '';
                        try { domain = (new URL(first)).hostname; } catch(_e) {}
                        MP.track('Spark Link Pasted', { url_domain: domain || 'unknown' });
                    }
                    MP.track('Spark Pasted', { pasted_length: pasted.length, link_count: links.length });
                }
            } catch(e2) {}
            // Small delay to allow paste content to be processed
            setTimeout(() => {
                adjustTextareaHeight();
                updateClearButtonVisibility();
                updateStartButtonStyling();
            }, 10);
        });
        textarea.addEventListener('cut', () => {
            // Small delay to allow cut content to be processed
            setTimeout(() => {
                adjustTextareaHeight();
                updateClearButtonVisibility();
                updateStartButtonStyling();
            }, 10);
        });

        // Initial adjustment in case there's pre-filled content
        adjustTextareaHeight();
        updateStartButtonStyling();
        
        // Initial clear button visibility check
        updateClearButtonVisibility();
    }

    // Conversation history array - global scope so auto-send can access it
    let conversationHistory = [];

    // Chat Interface Functions
    function initChatInterface() {
        const liminalTextarea = document.getElementById('liminal_spark');
        const chatInterface = document.getElementById('chat-interface');
        const liminalForm = document.getElementById('liminal-spark-form');
        const closeChatBtn = document.getElementById('close-chat');
        const chatInput = document.getElementById('chat-input');
        const sendChatBtn = document.getElementById('send-chat-message');
        const chatMessages = document.getElementById('chat-messages');
        
        if (!liminalTextarea || !chatInterface || !liminalForm) {
            console.warn('Chat interface elements not found');
            return;
        }
        
        
        // Close chat functionality
        if (closeChatBtn) {
            closeChatBtn.addEventListener('click', function() {
                hideChatInterface();
            });
        }
        
        // Mobile keyboard detection and handling
        if (chatInput && (/iPhone|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 768)) {
            const chatInputAreaEl = document.getElementById('chatInputArea');

            const getKeyboardOffset = () => {
                if (window.visualViewport) {
                    const vv = window.visualViewport;
                    const height = vv.height || window.innerHeight;
                    return Math.max(0, window.innerHeight - height - (vv.offsetTop || 0));
                }
                return chatInterface.classList.contains('mobile-keyboard-active') ? 150 : 0;
            };

            // Keep messages scrolled to bottom when near bottom already
            const scrollMessagesToBottomIfNear = () => {
                if (!chatMessages) return;
                const distanceFromBottom = chatMessages.scrollHeight - chatMessages.scrollTop - chatMessages.clientHeight;
                if (distanceFromBottom < 160) {
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
            };

            const updateChatPadding = () => {
                if (!chatMessages) return;
                const kb = getKeyboardOffset();
                const inputH = chatInputAreaEl ? chatInputAreaEl.getBoundingClientRect().height : 80;
                const padding = Math.max(120, Math.round(inputH + kb + 16));
                chatMessages.style.paddingBottom = padding + 'px';
                scrollMessagesToBottomIfNear();
            };
            // Removed legacy innerHeight-based keyboard detection in favor of visualViewport
            
            // Focus and blur events for additional handling
            chatInput.addEventListener('focus', () => {
                // Ensure z-index is set immediately
                chatInterface.style.zIndex = '30';
            });
            
            chatInput.addEventListener('blur', () => {
                setTimeout(() => {
                    chatInterface.classList.remove('mobile-keyboard-active');
                }, 300); // Delay to let keyboard disappear
            });

            // Prefer visualViewport when available for reliable keyboard handling on iOS/Android
            if (window.visualViewport) {
                const vv = window.visualViewport;
                const chatInputAreaEl = document.getElementById('chatInputArea');

                const updateForVisualViewport = () => {
                    const height = vv.height || window.innerHeight;
                    const offset = Math.max(0, window.innerHeight - height - (vv.offsetTop || 0));

                    if (offset > 0) {
                        chatInterface.classList.add('mobile-keyboard-active');
                    } else {
                        chatInterface.classList.remove('mobile-keyboard-active');
                    }

                    // Keep the input area above the keyboard
                    if (chatInputAreaEl) {
                        chatInputAreaEl.style.transform = offset ? `translateY(-${offset}px)` : '';
                    }

                    // Adjust messages bottom padding so last message isn't hidden
                    updateChatPadding();

                    // Ensure chat container matches the visible viewport height
                    chatInterface.style.height = `${height}px`;
                };

                vv.addEventListener('resize', updateForVisualViewport);
                vv.addEventListener('scroll', updateForVisualViewport);
                chatInput.addEventListener('focus', () => setTimeout(() => { updateForVisualViewport(); updateChatPadding(); }, 50));
                chatInput.addEventListener('blur', () => {
                    if (chatInputAreaEl) chatInputAreaEl.style.transform = '';
                    chatInterface.style.height = '';
                    setTimeout(() => chatInterface.classList.remove('mobile-keyboard-active'), 200);
                });
            } else {
                // Tiny fallback for rare browsers without visualViewport
                chatInput.addEventListener('focus', () => {
                    chatInterface.classList.add('mobile-keyboard-active');
                    // Best-effort: bump padding using default offset
                    updateChatPadding();
                });
                chatInput.addEventListener('blur', () => {
                    chatInterface.classList.remove('mobile-keyboard-active');
                    if (chatInputAreaEl) chatInputAreaEl.style.transform = '';
                    chatInterface.style.height = '';
                    // Restore base padding
                    setTimeout(updateChatPadding, 50);
                });
            }

            // Also update on input size changes and general resizes
            chatInput.addEventListener('input', () => {
                updateChatPadding();
            });
            window.addEventListener('resize', updateChatPadding);
            window.addEventListener('orientationchange', () => setTimeout(updateChatPadding, 300));
            // Initial adjustment
            setTimeout(updateChatPadding, 50);
        }
        
        // Chat input auto-resize
        if (chatInput) {
            chatInput.addEventListener('input', function() {
                this.style.height = 'auto';
                this.style.height = Math.min(this.scrollHeight, 120) + 'px';
            });
            
            // Handle paste events - only allow links
            chatInput.addEventListener('paste', function(e) {
                e.preventDefault();
                
                const paste = e.clipboardData ? e.clipboardData.getData('text') : '';
                const urlRegex = /(https?:\/\/[^\s]+)/gi;
                const links = paste.match(urlRegex);
                
                if (links && links.length > 0) {
                    try {
                        let domain = '';
                        try { domain = (new URL(links[0])).hostname; } catch(_e) {}
                        MP.track('Chat Link Pasted', { url_domain: domain || 'unknown' });
                    } catch(e){}
                    // Allow pasting only the first valid link found
                    const currentValue = this.value;
                    const start = this.selectionStart;
                    const end = this.selectionEnd;
                    
                    this.value = currentValue.substring(0, start) + links[0] + currentValue.substring(end);
                    
                    // Position cursor after the pasted link
                    const newCursorPos = start + links[0].length;
                    this.setSelectionRange(newCursorPos, newCursorPos);
                    
                    // Trigger input event for auto-resize
                    this.dispatchEvent(new Event('input'));
                    
                    // Show success notification
                    showNotification('Link Pasted', 'Link successfully added to chat', 'success', 2000);
                } else {
                    // Show warning for non-link content
                    showNotification('Chat Input', 'Only links can be pasted. Please type your message or paste a valid URL.', 'warning', 3000);
                }
            });
            
            // Handle Enter key for sending messages
            chatInput.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    sendChatMessage();
                } else if (e.key === 'Escape') {
                    hideChatInterface();
                }
            });
        }
        
        // Send chat message functionality
        if (sendChatBtn) {
            sendChatBtn.addEventListener('click', sendChatMessage);
        }
        
        // Chat interface functions are now globally accessible
        
        async function sendChatMessage() {
            if (!chatInput || !chatMessages) return;
            
            const message = chatInput.value.trim();
            if (!message) return;
            try {
                const hasUrl = /https?:\/\/\S+/.test(message);
                MP.track('Chat Message Sent', { length: message.length, has_url: hasUrl });
            } catch(e){}
            
            // Add user message to conversation history
            conversationHistory.push({
                content: message,
                role: 'user'
            });
            
            // Add user message to chat UI
            addChatMessage(message, 'user');
            
            // Clear input
            chatInput.value = '';
            chatInput.style.height = 'auto';
            
            // Show typing indicator
            addTypingIndicator();
            
            try {
                // Send message to Reflective Guides API
                const response = await sendToReflectiveGuides(message);
                removeTypingIndicator();
                
                // Add AI response to conversation history
                conversationHistory.push({
                    content: response,
                    role: 'assistant'
                });
                
                // Add AI response to chat UI
                addChatMessage(response, 'ai');
            } catch (error) {
                console.error('Chat API error:', error);
                removeTypingIndicator();
                
                const errorMessage = 'I apologize, but I\'m having trouble connecting right now. Please try again in a moment.';
                
                // Add error response to conversation history
                conversationHistory.push({
                    content: errorMessage,
                    role: 'assistant'
                });
                
                // Add error response to chat UI
                addChatMessage(errorMessage, 'ai');
            }
        }
        
        async function sendToReflectiveGuides(userMessage) {
            try {
                // Get Firebase auth token
                const utoken = await getFirebaseToken();
                if (!utoken) {
                    throw new Error('Authentication token not available');
                }
                
                // Use the maintained conversation history array
                
                // Check for link intent in clarity engine results
                const { intent, message } = determineIntentAndMessage(userMessage);
                
                console.log('Sending to reflective guides endpoint:', { 
                    messagesCount: conversationHistory.length + 1,
                    intent: intent,
                    userMessage: userMessage,
                    conversationHistory: conversationHistory
                });
                
                const response = await fetch('/reflective-guides-chat', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        intent: intent,
                        message: message,
                        conversationHistory: conversationHistory,
                        sessionId: CURR_SESSION_ID,
                        utoken: utoken
                    })
                });
                
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('Reflective guides API error:', response.status, errorText);
                    throw new Error(`API request failed: ${response.status} - ${errorText}`);
                }
                
                const data = await response.json();
                console.log('Reflective guides response:', data);
                
                if (!data.success) {
                    throw new Error(data.error || 'Server returned error');
                }
                
                return data.text || 'I\'m sorry, I couldn\'t generate a response right now.';
                
            } catch (error) {
                console.error('Error in sendToReflectiveGuides:', error);
                throw error;
            }
        }

        function determineIntentAndMessage(userMessage) {
            // Check if we have clarity engine results with intent patterns
            if (CURR_CLARITY_RESULTS && CURR_CLARITY_RESULTS.intent) {
                const clarityIntent = CURR_CLARITY_RESULTS.intent;
                
                // Check for link:[url] pattern
                const linkMatch = clarityIntent.match(/^link:(.+)$/);
                if (linkMatch) {
                    const url = linkMatch[1].trim();
                    console.log('Link intent detected:', { url, originalIntent: clarityIntent });
                    
                    return {
                        intent: 'link-guide',
                        message: userMessage // Use the actual user message, not just the URL
                    };
                }
            }
            
            // Default to reflective-chat with original message
            return {
                intent: 'reflective-chat',
                message: userMessage
            };
        }
        
        // Legacy getChatHistory function - no longer needed
        // Conversation history is now maintained in the conversationHistory array
        // This function is kept for reference but should not be used
        function getChatHistory() {
            console.warn('getChatHistory() is deprecated - using conversationHistory array instead');
            return conversationHistory;
        }
        

        function addChatMessage(message, sender) {
            if (!chatMessages) return;
            
            // If this is an AI response, check for reflective insights before displaying
            let displayMessage = message; // Default to original message
            if (sender === 'ai') {
                try {
                    const detectedInsights = detectReflectiveInsights(message);
                    if (detectedInsights.length > 0) {
                        console.log(`Detected ${detectedInsights.length} reflective insights in AI response`);
                        
                        // Get the most recent user message from conversation history for context
                        let originalUserMessage = "";
                        for (let i = conversationHistory.length - 1; i >= 0; i--) {
                            if (conversationHistory[i].role === 'user') {
                                originalUserMessage = conversationHistory[i].content;
                                break;
                            }
                        }
                        
                        // Save the insights in the background
                        saveDetectedInsights(detectedInsights, originalUserMessage);
                        
                        // Clean the message for UI display (remove insight patterns)
                        displayMessage = message.replace(
                            /Reflective insight detected \[([^\]]+)\]: (.+?)(?=\n|$|Reflective insight detected)/g, 
                            ''
                        ).trim();
                        
                        console.log('Cleaned message for display:', { original: message, cleaned: displayMessage });
                    }
                } catch (error) {
                    console.error("Error processing reflective insights:", error);
                }
            }
            
            const messageDiv = document.createElement('div');
            messageDiv.className = 'flex items-start space-x-3 animate-fadeIn mb-4';
            
            if (sender === 'user') {
                messageDiv.className = 'flex justify-end mb-6';
                messageDiv.innerHTML = `
                    <div class="chat-bubble-user text-white px-5 py-4">
                        <p class="text-sm leading-relaxed font-medium">${escapeHtml(displayMessage)}</p>
                    </div>
                `;
            } else {
                messageDiv.className = 'flex justify-start mb-6';
                messageDiv.innerHTML = createChatResponseHTML(displayMessage);
            }
            
            chatMessages.appendChild(messageDiv);
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }
        
        function addTypingIndicator() {
            if (!chatMessages) return;
            
            const typingDiv = document.createElement('div');
            typingDiv.id = 'typing-indicator';
            typingDiv.className = 'flex justify-start mb-6';
            typingDiv.innerHTML = `
                <div class="chat-bubble-assistant px-5 py-4">
                    <div class="flex space-x-1">
                        <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
                        <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
                        <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
                    </div>
                </div>
            `;
            
            chatMessages.appendChild(typingDiv);
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }
        
        function removeTypingIndicator() {
            const typingIndicator = document.getElementById('typing-indicator');
            if (typingIndicator) {
                typingIndicator.remove();
            }
        }
        
    }

    // Global Chat Interface Functions (moved outside initChatInterface for accessibility)
    var showChatInterface, hideChatInterface, resetChatConversation, updateChatPerspectiveAlert;
    
    // Note: Previously this was gated to show once per session.
    // We now allow REFLECT-NOW buttons to appear whenever the assistant includes them.

    // Global utility function for escaping HTML
    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // Global function for creating chat response HTML
    function createChatResponseHTML(responseText) {
        // Always clean REFLECT-NOW patterns first to prevent them from affecting conversation history
        const reflectNowRegex = /\[REFLECT-NOW::([^\]]+)\]/g;
        
        // Extract keywords from REFLECT-NOW patterns before cleaning
        const keywords = [];
        let match;
        const keywordRegex = /\[REFLECT-NOW::([^\]]+)\]/g;
        while ((match = keywordRegex.exec(responseText)) !== null) {
            keywords.push(match[1]);
        }
        
        // Clean the text by removing REFLECT-NOW patterns (this is what goes into conversation history)
        let cleanedText = responseText.replace(reflectNowRegex, '').trim();
        
        // Check if response contains finalize-reflection link (on cleaned text)
        const finalizeReflectionRegex = /https:\/\/learner\.plus\/finalize-reflection\/[^\s]*/g;
        const finalizeMatches = cleanedText.match(finalizeReflectionRegex);
        
        if (finalizeMatches && finalizeMatches.length > 0) {
            // Extract the link and convert to relative URL
            const fullLink = finalizeMatches[0];
            const finalizeLink = fullLink.replace('https://learner.plus', '');
            // Remove the link from the text to avoid duplication
            const cleanText = cleanedText.replace(finalizeReflectionRegex, '').trim();
            
            return `
                <div class="chat-bubble-assistant px-5 py-4">
                    ${cleanText ? `<div class="text-sm leading-relaxed font-medium text-gray-700 mb-3">${parseMarkdownToHTML(cleanText)}</div>` : ''}
                    <button class="inline-flex items-center px-4 py-2 bg-teal-500 text-white text-sm font-medium rounded-lg hover:bg-teal-600 transition-colors ui-action-btn" data-task="open-finalize-reflection::${escapeHtml(finalizeLink)}">
                        <i class="fa-solid fa-pen-to-square mr-2"></i>
                        Reflect for Credit
                    </button>
                </div>
            `;
        } else if (keywords.length > 0) {
            // Always show REFLECT-NOW buttons when keywords are present
            
            // Create buttons for each keyword
            const keywordButtons = keywords.map((keyword, index) => `
                <div class="flex items-center justify-between p-2 bg-teal-50 rounded-lg border border-teal-200">
                    <span class="text-sm font-medium text-teal-800">${escapeHtml(keyword)}</span>
                    <div class="flex items-center space-x-2">
                        <button class="inline-flex items-center ml-2 px-3 py-1.5 text-xs font-medium rounded bg-teal-500 text-white hover:bg-teal-600 transition-colors ui-action-btn" data-task="reflect-now::${escapeHtml(keyword)}::${index}">
                            Reflect for Credit
                        </button>
                        <button class="inline-flex items-center justify-center w-8 h-8 rounded border border-gray-300 text-gray-600 bg-white hover:bg-gray-50 hover:text-gray-700 transition-colors ui-action-btn" data-task="snooze::${escapeHtml(keyword)}::tomorrow" title="Save topic for later">
                            <i class="fa-solid fa-clock text-xs"></i>
                        </button>
                    </div>
                </div>
            `).join('');
            
            return `
                <div class="chat-bubble-assistant px-5 py-4">
                    <div class="space-y-2">
                        ${keywordButtons}
                    </div>
                    ${cleanedText ? `<div class="text-sm leading-relaxed font-medium text-gray-700 my-3">${parseMarkdownToHTML(cleanedText)}</div>` : ''}
                </div>
            `;
        } else {
            // Regular response without finalize-reflection link or REFLECT-NOW patterns
            return `
                <div class="chat-bubble-assistant px-5 py-4">
                    <div class="text-sm leading-relaxed font-medium text-gray-700">${parseMarkdownToHTML(cleanedText)}</div>
                </div>
            `;
        }
    }
    
    // Protected function for exiting discovery mode (not exposed on window)
    function exitDiscoveryMode() {
        console.log('Exiting discovery mode - showing chat input');
        
        // Find and remove discovery container
        const discoveryContainer = document.getElementById('discovery-mode-container');
        if (discoveryContainer) {
            discoveryContainer.remove();
        }
        
        // Show the original chat input
        const chatInputArea = document.getElementById('chatInputArea');
        if (chatInputArea) {
            chatInputArea.style.display = '';
            
            // Focus the chat input
            const chatInput = document.getElementById('chat-input');
            if (chatInput) {
                setTimeout(() => chatInput.focus(), 100);
            }
        }
        
        // Show hidden reflective gap if it exists
        if (HIDDEN_REFLECTIVE_GAP) {
            const chatMessages = document.getElementById('chat-messages');
            if (chatMessages) {
                const gapDiv = document.createElement('div');
                gapDiv.className = 'flex justify-start mb-6 animate-fadeIn-ui';
                gapDiv.innerHTML = `
                    <div class="chat-bubble-assistant px-5 py-4">
                        <p class="text-sm font-semibold text-gray-900 mb-3">Let’s explore your thoughts — Chat & Reflect</p>
                        <div class="bg-slate-50 border border-teal-200 rounded-md p-2 mb-3">
                            <p class="text-sm text-slate-800">${HIDDEN_REFLECTIVE_GAP.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')}</p>
                        </div>
                    </div>
                `;
                chatMessages.appendChild(gapDiv);
                
                // Clear the hidden gap after showing
                HIDDEN_REFLECTIVE_GAP = null;
            }
        }
    }
    
    function initGlobalChatFunctions() {
        const liminalForm = document.getElementById('liminal-spark-form');
        const chatInterface = document.getElementById('chat-interface');
        const chatInput = document.getElementById('chat-input');
        const chatMessages = document.getElementById('chat-messages');
        const liminalTextarea = document.getElementById('liminal_spark');
        
        
        
        // Removed updateChatPerspectiveAlert function - perspective feature removed
        
        showChatInterface = function(reflectiveGapMessage = null) {
            console.log('Transforming to chat interface', reflectiveGapMessage ? 'with reflective gap guidance' : '');
            
            
            // Reset chat conversation with optional custom message
            resetChatConversation(reflectiveGapMessage);
            
            // Hide phrase cycle container
            const phraseCycleContainer = document.getElementById('phrase-cycle-container');
            if (phraseCycleContainer) {
                phraseCycleContainer.style.opacity = '0';
                phraseCycleContainer.style.transform = 'translateY(-10px)';
                setTimeout(() => phraseCycleContainer.classList.add('hidden'), 200);
            }

            // Hide quickpick container
            const quickpickContainer = document.getElementById('quickpick-container')?.closest('.mb-6');
            if (quickpickContainer) {
                quickpickContainer.style.opacity = '0';
                quickpickContainer.style.transform = 'translateY(-10px)';
                setTimeout(() => quickpickContainer.classList.add('hidden'), 200);
            }
            
            // Hide smart nudges, reflective insights button, and credit button
            const smartNudges = document.getElementById('smartnudges');
            const reflectiveInsightsBtn = document.querySelector('[data-task="reflective-insights"]')?.closest('.fixed');
            const creditButton = document.getElementById('creditCheckBtn');

            if (smartNudges) {
                smartNudges.style.opacity = '0';
                smartNudges.style.transform = 'translateY(-10px)';
                setTimeout(() => smartNudges.classList.add('hidden'), 200);
            }

            if (reflectiveInsightsBtn) {
                reflectiveInsightsBtn.classList.add('hidden');
            }

            if (creditButton) {
                creditButton.style.opacity = '0';
                creditButton.style.transform = 'translateY(-10px)';
                setTimeout(() => creditButton.classList.add('hidden'), 200);
            }
            
            // Hide the liminal form with smooth transition
            if (liminalForm) {
                liminalForm.style.transform = 'scale(0.95)';
                liminalForm.style.opacity = '0';
            }
            
            // Hide dsib container completely
            console.log('Hiding DSIB container');
            const dsibContainer = document.getElementById('dsib-container');
            if (dsibContainer) dsibContainer.style.opacity = '0';

            setTimeout(() => {
                if (liminalForm) liminalForm.classList.add('hidden');

                
                // Show chat interface with smooth transition
                if (chatInterface) {
                    chatInterface.classList.remove('hidden');
                    
                    // Trigger reflow to ensure transition works
                    chatInterface.offsetHeight;
                    
                    chatInterface.style.transform = 'scale(1)';
                    chatInterface.style.opacity = '1';
                }
                
                // Hide header elements on mobile (small devices only)
                if (window.innerWidth <= 768) {
                    document.body.classList.add('mobile-chat-active');
                }
                
                // Check if we should hide chat input for IPOC keywords discovery flow
                const hasIpocKeywords = CURR_CLARITY_RESULTS && CURR_CLARITY_RESULTS.ipoc_keywords && CURR_CLARITY_RESULTS.ipoc_keywords.length > 0;
                trackEvent('learnerplus_chat_opened', {
                    with_reflective_gap: !!reflectiveGapMessage,
                    ipoc_keywords_present: !!hasIpocKeywords,
                    user_profile: CURR_USERPROFILE,
                    subscription_status: CURR_STRIPESTATUS
                });
                
                if (hasIpocKeywords) {
                    // Hide chat input area and show discovery button instead
                    setupDiscoveryMode();
                } else {
                    // Focus the chat input (normal flow)
                    if (chatInput) {
                        setTimeout(() => chatInput.focus(), 100);
                    }
                }
                
                // Update perspective alert now that chat is visible (disabled for now)
                // updateChatPerspectiveAlert();
                
                // Chat interface is now visible - no notification needed
            }, 300);
        };
        
        function setupDiscoveryMode() {
            console.log('🔄 Setting up discovery mode - hiding chat input');
            
            // Find the chat input area
            const chatInputArea = document.getElementById('chatInputArea');
            if (!chatInputArea) {
                console.warn('❌ Chat input area not found');
                return;
            }
            
            // Check if discovery container already exists
            const existingContainer = document.getElementById('discovery-mode-container');
            if (existingContainer) {
                console.log('⚠️ Discovery container already exists - reusing it');
                chatInputArea.style.display = 'none';
                existingContainer.style.display = 'block';
                return;
            }
            
            // Hide the original chat input
            chatInputArea.style.display = 'none';
            
            // Discovery button now appears as separate assistant message after "Reflect Later"
            console.log('✅ Discovery button integrated as assistant message');
        }
        
        
        hideChatInterface = function() {
            console.log('Hiding chat interface');
            try { MP.track('Chat Closed', {}); } catch(e){}
            
            // Clear thinqbits badges
            const badgesContainer = document.getElementById('chat-thinqbits-badges');
            if (badgesContainer) {
                badgesContainer.innerHTML = '';
                badgesContainer.classList.add('hidden');
            }
            
            // Clear perspective alert
            const perspectiveAlert = document.getElementById('chat-perspective-alert');
            if (perspectiveAlert) {
                perspectiveAlert.classList.add('hidden');
            }
            
            // Hide chat interface with smooth transition
            if (chatInterface) {
                chatInterface.style.transform = 'scale(0.95)';
                chatInterface.style.opacity = '0';
            }
            
            setTimeout(() => {
                if (chatInterface) chatInterface.classList.add('hidden');
                
                // Show header elements back on mobile
                document.body.classList.remove('mobile-chat-active');
                
                // Show liminal form with smooth transition
                if (liminalForm) {
                    liminalForm.classList.remove('hidden');
                    
                    // Trigger reflow
                    liminalForm.offsetHeight;
                    
                    liminalForm.style.transform = 'scale(1)';
                    liminalForm.style.opacity = '1';
                }

                //
                const dsibContainer = document.getElementById('dsib-container');
                if (dsibContainer) dsibContainer.style.opacity = '1';
                
                
                // Show phrase cycle container again
                const phraseCycleContainer = document.getElementById('phrase-cycle-container');
                if (phraseCycleContainer) {
                    phraseCycleContainer.classList.remove('hidden');
                    setTimeout(() => {
                        phraseCycleContainer.style.opacity = '1';
                        phraseCycleContainer.style.transform = 'translateY(0)';
                    }, 100);
                }

                // Show quickpick container again
                const quickpickContainer = document.getElementById('quickpick-container')?.closest('.mb-6');
                if (quickpickContainer) {
                    quickpickContainer.classList.remove('hidden');
                    setTimeout(() => {
                        quickpickContainer.style.opacity = '1';
                        quickpickContainer.style.transform = 'translateY(0)';
                    }, 100);
                }
                
                // Show smart nudges, reflective insights button, and credit button again
                const smartNudges = document.getElementById('smartnudges');
                const reflectiveInsightsBtn = document.querySelector('[data-task="reflective-insights"]')?.closest('.fixed');
                const creditButton = document.getElementById('creditCheckBtn');

                if (smartNudges) {
                    smartNudges.classList.remove('hidden');
                    setTimeout(() => {
                        smartNudges.style.opacity = '1';
                        smartNudges.style.transform = 'translateY(0)';
                    }, 100);
                }

                if (reflectiveInsightsBtn) {
                    reflectiveInsightsBtn.classList.remove('hidden');
                }

                if (creditButton) {
                    creditButton.classList.remove('hidden');
                    setTimeout(() => {
                        creditButton.style.opacity = '1';
                        creditButton.style.transform = 'translateY(0)';
                    }, 100);
                }
                
                // Focus the liminal textarea
                if (liminalTextarea) {
                    setTimeout(() => liminalTextarea.focus(), 100);
                }
            }, 300);
        };
        
        resetChatConversation = function() {
            if (!chatMessages) return;
            
            // Clear conversation history array
            conversationHistory = [];
            console.log('Cleared conversation history array');
            
            // No session flag needed; REFLECT-NOW can show multiple times
            
            // Clean up any existing discovery mode containers and credit opportunities
            const existingDiscovery = document.getElementById('discovery-mode-container');
            if (existingDiscovery) {
                existingDiscovery.remove();
                console.log('Cleaned up existing discovery container during reset');
            }
            
            const existingCreditContainer = document.getElementById('credit-opportunities-container');
            if (existingCreditContainer) {
                existingCreditContainer.remove();
                console.log('Cleaned up existing credit opportunities container during reset');
            }
            
            // Reset chat input display
            const chatInputArea = document.getElementById('chatInputArea');
            if (chatInputArea) {
                chatInputArea.style.display = 'block';
            }
            
            // Clear all messages
            chatMessages.innerHTML = '';
            
            // Create structured analysis message based on clarity results
            if (CURR_CLARITY_RESULTS) {
                createStructuredAnalysisMessage();
            } else {
                // Fallback to simple welcome message
                createDefaultWelcomeMessage();
            }
            
            // Clear chat input
            if (chatInput) {
                chatInput.value = '';
                chatInput.style.height = 'auto';
            }
            
            console.log('Chat conversation reset with structured analysis');
        };

        function createStructuredAnalysisMessage(isResumedSession = false) {
            // Check for global resumed session flag
            isResumedSession = isResumedSession || window.IS_RESUMED_REFLECTION;
            const results = CURR_CLARITY_RESULTS;
            
            // Check if this is a link-guide intent
            const isLinkGuide = results.intent && results.intent.startsWith('link:');
            
            // Store gist and thinqbits for potential use in credit opportunities message
            const thinqbits = results.thinqbits || [];
            const gist = results.gist || "";
            const gistWordCount = gist.trim().split(/\s+/).filter(word => word.length > 0).length;
            
            // Display IPOC Keywords with action buttons if available
            const hasIpocKeywords = results.ipoc_keywords && results.ipoc_keywords.length > 0;
            if (hasIpocKeywords) {
                const ipocDiv = document.createElement('div');
                ipocDiv.id = 'credit-opportunities-container';
                ipocDiv.className = 'flex items-start space-x-3 animate-fadeIn-ui mb-4';
                ipocDiv.innerHTML = createIPOCKeywordsHTML(results.ipoc_keywords, gist, gistWordCount);
                chatMessages.appendChild(ipocDiv);
            }
            
            // Add Save Draft option if we have substantial thinking to save (but not for resumed sessions)
            const hasMeaningfulGist = gistWordCount >= 5;
            const hasThinqbits = results.thinqbits && results.thinqbits.length > 0;
            const hasOriginalSpark = document.getElementById('liminal_spark')?.value?.trim();
            const hasMeaningfulContent = hasMeaningfulGist && hasThinqbits;// || hasOriginalSpark;
            
            if (hasMeaningfulContent && !isResumedSession && !isLinkGuide) {
                const continueLaterWrapper = document.createElement('div');
                continueLaterWrapper.className = 'flex items-start space-x-3 animate-fadeIn-ui mb-4';
                const continueLaterElement = createContinueLaterHTML(gist);
                continueLaterWrapper.appendChild(continueLaterElement);
                chatMessages.appendChild(continueLaterWrapper);
                
                // Add smart chat button as separate assistant message
                const smartChatWrapper = document.createElement('div');
                smartChatWrapper.className = 'flex items-start space-x-3 animate-fadeIn-ui mb-4';
                const smartChatElement = createSmartChatHTML();
                smartChatWrapper.appendChild(smartChatElement);
                chatMessages.appendChild(smartChatWrapper);
            }else if (!isLinkGuide){
                // Add smart chat button as separate assistant message
                const smartChatWrapper = document.createElement('div');
                smartChatWrapper.className = 'flex items-start space-x-3 animate-fadeIn-ui mb-4';
                const smartChatElement = createSmartChatHTML('Start a reflective chat to explore this topic further');
                smartChatWrapper.appendChild(smartChatElement);
                chatMessages.appendChild(smartChatWrapper);
            }
            
            // Display reflective gap as conversational opener if available (skip for link-guide and when IPOC keywords are present)
            const hasReflectiveGap = results.reflective_gap && results.reflective_gap.trim() !== '';
            if (hasReflectiveGap && !isLinkGuide && !hasIpocKeywords) {
                const gapDiv = document.createElement('div');
                gapDiv.className = 'flex items-start space-x-3 animate-fadeIn-ui mb-4';
                gapDiv.innerHTML = createReflectiveGapHTML(results.reflective_gap);
                chatMessages.appendChild(gapDiv);
            }
            
            // Store reflective gap data for later use
            HIDDEN_REFLECTIVE_GAP = hasIpocKeywords && hasReflectiveGap ? results.reflective_gap : null;
            
            // Show link guidance message for link-guide intent
            if (isLinkGuide) {
                const linkDiv = document.createElement('div');
                linkDiv.className = 'flex items-start space-x-3 animate-fadeIn-ui mb-4';
                linkDiv.innerHTML = createLinkGuideHTML(results.intent);
                chatMessages.appendChild(linkDiv);
            }
            
            // If no content to show, display encouragement message
            if (!hasIpocKeywords && !hasReflectiveGap && !isLinkGuide) {
                const encouragementDiv = document.createElement('div');
                encouragementDiv.className = 'flex items-start space-x-3 animate-fadeIn-ui mb-4';
                encouragementDiv.innerHTML = createEncouragementHTML();
                chatMessages.appendChild(encouragementDiv);
            }
            
            // Auto-send for link-guide intent
            if (isLinkGuide) {
                // Add a small delay to let the UI settle, then trigger auto-send
                setTimeout(() => {
                    if (autoSendLinkGuideMessage) {
                        autoSendLinkGuideMessage(results.intent);
                    }
                }, 500);
            }
            
            // Update chat input placeholder for reflective-chat intent
            if (!isLinkGuide && hasIpocKeywords) {
                // Update chat input placeholder to encourage deeper reflection
                setTimeout(() => {
                    const chatInput = document.getElementById('chat-input');
                    if (chatInput) {
                        chatInput.placeholder = 'Continue reflective chat...';
                    }
                }, 500);
            }
        }


        function createIPOCKeywordsHTML(keywords, gist = '', gistWordCount = 0) {
            const topKeywords = keywords.slice(0, 5); // Limit to 5
            let keywordButtons = '';
            
            // Add gist quote if word count >= 12
            let gistSection = '';
            if (gistWordCount >= 12 && gist.trim()) {
                gistSection = `<p class="text-sm text-slate-700 mb-3">${gist.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')}</p>`;
            }
            
            topKeywords.forEach((keyword, index) => {
                keywordButtons += `
                    <div class="flex items-center justify-between p-2 bg-white rounded-md shadow-lg border border-slate-200 mb-2">
                        <span class="text-sm font-medium text-gray-900">${escapeHtml(keyword)}</span>
                        <div class="flex items-center space-x-2">
                            <button class="inline-flex items-center px-1.5 py-1.5 text-xs font-medium rounded bg-teal-500 text-white hover:bg-teal-600 transition-colors ui-action-btn" data-task="reflect-now::${escapeHtml(keyword)}::${index}">
                                <span class="hidden md:inline">Reflect for Credit</span>
                                <i class="fa-solid fa-arrow-right md:ml-1"></i>
                            </button>
                            <button class="inline-flex items-center px-1.5 py-1.5 text-xs font-medium rounded bg-gray-400 text-white hover:bg-gray-500 transition-colors ui-action-btn" data-task="snooze::${escapeHtml(keyword)}::tomorrow" title="Save topic for later">
                                <i class="fa-solid fa-clock text-xs"></i>
                            </button>
                        </div>
                    </div>
                `;
            });

            return `
                <div class="chat-bubble-assistant-full px-5 py-4">
                    <p class="text-md font-semibold text-slate-700 mb-3">Reflect Now:</p>
                    ${gistSection}
                    <div class="space-y-2">
                        ${keywordButtons}
                    </div>
                    <p class="text-xs text-gray-500 mt-3 text-right">Launches the Reflective Practice™ accredited activity</p>
                </div>
            `;
        }

        function createContinueLaterHTML(gist = '') {
            const displayText = gist.length > 80 ? gist.substring(0, 80) + '...' : gist;
            
            // Create the element using ui-action-btn pattern
            const continueLaterDiv = document.createElement('div');
            continueLaterDiv.className = 'chat-bubble-assistant px-5 py-4';
            continueLaterDiv.innerHTML = `
                <div class="flex items-start space-x-3">
                    <div class="flex-1">
                        <p class="text-md font-semibold text-gray-900 mb-2">Continue this later:</p>
                        ${gist.trim() ? `
                            <p class="text-xs text-gray-700 mb-3 italic">"${displayText.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')}"</p>
                        ` : ''}
                        <!--<p class="text-xs text-gray-600 mb-3">Save this draft with full context — notes, insights, and credit opportunities included.</p> -->
                        <div class="flex items-center justify-between">
                            <p class="text-xs text-gray-500 mr-1">Saves this draft with full context</p>
                            <button type="button" class="ui-action-btn inline-flex items-center justify-center px-4 py-2 text-xs font-medium rounded text-white bg-teal-500 hover:bg-teal-600 transition-colors ml-1" data-task="save-draft">
                                <i class="fa-solid fa-bookmark mr-2"></i>
                                Save Draft
                            </button>
                        </div>
                    </div>
                </div>
            `;
            
            return continueLaterDiv;
        }

        function createSmartChatHTML(textPrompt = 'Not sure? Start reflective chat') {
            const smartChatDiv = document.createElement('div');
            smartChatDiv.className = 'chat-bubble-assistant px-5 py-4';
            smartChatDiv.id = 'smart-chat-message'; // Add unique ID for removal
            smartChatDiv.innerHTML = `
                <div class="flex items-start space-x-3">
                    <div class="flex-1 text-center">
                        <button type="button" class="ui-action-btn inline-flex items-center justify-center px-4 py-2 text-xs font-medium rounded text-slate-600 bg-white hover:bg-teal-100/10 transition-colors" data-task="discover-more-credits">
                            ${textPrompt}
                        </button>
                    </div>
                </div>
            `;
            
            return smartChatDiv;
        }

        function createReflectiveGapHTML(reflectiveGap) {
            return `
                <div class="chat-bubble-assistant px-5 py-4">
                    <p class="text-sm font-semibold text-gray-900 mb-3">Let’s explore your thoughts — Chat & Reflect</p>
                    <div class="bg-slate-50 border border-teal-200 rounded-md p-2 mb-3">
                        <p class="text-sm text-slate-800">${escapeHtml(reflectiveGap)}</p>
                    </div>
                </div>
            `;
        }

        function createLinkGuideHTML(intentValue) {
            // Extract URL from the intent
            const linkMatch = intentValue.match(/^link:(.+)$/);
            const url = linkMatch ? linkMatch[1].trim() : '';
            
            return `
                <div class="chat-bubble-assistant px-5 py-4">
                    <p class="text-sm font-semibold text-gray-900 mb-3">Link Detected</p>
                    <div class="bg-indigo-50 border border-indigo-200 rounded-lg p-3 mb-3">
                        <p class="text-sm text-indigo-800 font-mono break-all">${escapeHtml(url)}</p>
                    </div>
                    <p class="text-sm text-gray-700">Link detected in your entry. Let's review its content and explore how it connects to your learning goals.</p>
                </div>
            `;
        }

        function createEncouragementHTML() {
            return `
                <div class="chat-bubble-assistant px-5 py-4">
                    <p class="text-sm text-gray-700 mb-3">Let's reflect and capture meaningful insights.</p>
                    <p class="text-sm text-gray-700">You can share what you found most valuable from this experience, ask me to help identify key takeaways, or discuss anything about your learning journey.</p>
                    <p class="text-sm text-gray-600 mt-3">What would you like to explore?</p>
                </div>
            `;
        }

        function createDefaultWelcomeMessage() {
            const welcomeDiv = document.createElement('div');
            welcomeDiv.className = 'flex justify-start mb-6';
            welcomeDiv.innerHTML = `
                <div class="chat-bubble-assistant px-5 py-4">
                    <p class="text-sm text-gray-700">👋 Welcome to Learner+ — your reflection-powered AI companion. I can help you:</p>
                    <ul class="text-sm text-gray-600 mt-2 space-y-1">
                        <li>• Surface themes and patterns in your reflections</li>
                        <li>• Connect insights to new learning opportunities</li>
                        <li>• Turn notes into practical takeaways</li>
                        <li>• Build study guides or portfolios from your reflections</li>
                    </ul>
                    <p class="text-sm text-gray-700 mt-2">Where would you like to begin?</p>
                </div>
            `;
            chatMessages.appendChild(welcomeDiv);
        }


        // Auto-send function for link-guide intent
        const autoSendLinkGuideMessage = async function(intentValue) {
            try {
                // Extract URL from the intent
                const linkMatch = intentValue.match(/^link:(.+)$/);
                if (!linkMatch) return;
                
                const url = linkMatch[1].trim();
                console.log('Auto-sending URL to link-guide:', url);
                
                // Show typing indicator manually
                if (chatMessages) {
                    const typingDiv = document.createElement('div');
                    typingDiv.id = 'auto-typing-indicator';
                    typingDiv.className = 'flex justify-start mb-6';
                    typingDiv.innerHTML = `
                        <div class="chat-bubble-assistant px-5 py-4">
                            <div class="flex items-center space-x-2">
                                <div class="flex space-x-1">
                                    <div class="w-2 h-2 bg-gray-400 rounded-full animate-pulse"></div>
                                    <div class="w-2 h-2 bg-gray-400 rounded-full animate-pulse" style="animation-delay: 0.1s"></div>
                                    <div class="w-2 h-2 bg-gray-400 rounded-full animate-pulse" style="animation-delay: 0.2s"></div>
                                </div>
                                <span class="text-xs text-gray-500">Analyzing link...</span>
                            </div>
                        </div>
                    `;
                    chatMessages.appendChild(typingDiv);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
                
                // Send to reflective guides endpoint directly
                const utoken = await getFirebaseToken();
                if (!utoken) {
                    throw new Error('Authentication token not available');
                }
                
                // Add the URL as a user message to conversation history
                conversationHistory.push({
                    content: url,
                    role: 'user'
                });
                
                console.log('Auto-sending to reflective guides endpoint:', { 
                    intent: 'link-guide',
                    url: url
                });
                
                const response = await fetch('/reflective-guides-chat', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        intent: 'link-guide',
                        message: url,
                        conversationHistory: conversationHistory,
                        sessionId: CURR_SESSION_ID,
                        utoken: utoken
                    })
                });
                
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('Reflective guides API error:', response.status, errorText);
                    throw new Error(`API request failed: ${response.status} - ${errorText}`);
                }
                
                const data = await response.json();
                console.log('Auto-send link guide response:', data);
                
                if (!data.success) {
                    throw new Error(data.error || 'Server returned error');
                }
                
                const aiResponse = data.text || 'I\'m sorry, I couldn\'t generate a response right now.';
                
                // Remove typing indicator
                const typingIndicator = document.getElementById('auto-typing-indicator');
                if (typingIndicator) {
                    typingIndicator.remove();
                }
                
                // Add AI response to conversation history (auto-send bypasses sendChatMessage)
                conversationHistory.push({
                    content: aiResponse,
                    role: 'assistant'
                });
                
                // Add AI response manually to UI
                if (chatMessages) {
                    const messageDiv = document.createElement('div');
                    messageDiv.className = 'flex items-start space-x-3 animate-fadeIn mb-4';
                    
                    // Use the centralized function for consistency
                    messageDiv.innerHTML = createChatResponseHTML(aiResponse);
                    
                    chatMessages.appendChild(messageDiv);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
                
            } catch (error) {
                console.error('Error in auto-send link guide:', error);
                
                // Remove typing indicator on error
                const typingIndicator = document.getElementById('auto-typing-indicator');
                if (typingIndicator) {
                    typingIndicator.remove();
                }
                
                // Add error message manually
                if (chatMessages) {
                    const messageDiv = document.createElement('div');
                    messageDiv.className = 'flex justify-start mb-6';
                    messageDiv.innerHTML = `
                        <div class="chat-bubble-assistant px-5 py-4">
                            <p class="text-sm text-gray-700">I'm having trouble analyzing this link right now. Please try asking me about it directly.</p>
                        </div>
                    `;
                    chatMessages.appendChild(messageDiv);
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
            }
        };
        
    }

    // Smart Trigger Phrases with time/context logic
    const smartTriggerPhrases = {
        // EARLY MORNING (5:00-8:00)
        earlyMorning: [
            "What stuck with you from yesterday?",
            "Morning reflection on yesterday's cases?",
            "Start today by capturing yesterday's learning",
            "What insight kept you thinking overnight?",
            "Ready to log yesterday's key takeaway?"
        ],
        
        // MORNING (8:00-12:00)
        morning: [
            "What have you learned this morning?",
            "Interesting case or discussion today?",
            "Morning rounds insight to capture?",
            "Notice anything unusual in today's work?",
            "Got notes from morning meetings?"
        ],
        
        // AFTERNOON (12:00-17:00)
        afternoon: [
            "Afternoon reflection time - what's notable?",
            "Reached a key decision today?",
            "Want to paste case notes?",
            "Spotted an unusual result or outlier?",
            "Have notes from a teaching session?"
        ],
        
        // END OF SHIFT (17:00-20:00)
        endOfShift: [
            "What's your biggest learning from today?",
            "Time to capture today's clinical insights",
            "Observed a meaningful pattern today?",
            "Want to reflect on today's outcomes?",
            "End-of-shift reflection - what stood out?"
        ],
        
        // EVENING (20:00-24:00)
        evening: [
            "Have a link to an article or podcast?",
            "Evening study session insights?",
            "Read something interesting? Share the link",
            "Learned something new from your reading?",
            "Exploring a new idea or innovation?"
        ],
        
        // MONDAY SPECIFIC
        monday: [
            "Weekend conference or course insights?",
            "What did you learn over the weekend?",
            "Monday reflection - fresh perspectives?",
            "Have notes from weekend learning?",
            "How will you apply weekend insights?"
        ],
        
        // FRIDAY SPECIFIC
        friday: [
            "Week's most impactful learning?",
            "What was the biggest challenge this week?",
            "What approach will you change next week?",
            "This week's key clinical insight?",
            "Weekly wrap-up - what surprised you?"
        ],
        
        // WEEKEND
        weekend: [
            "Catching up on journals? Share insights",
            "Weekend reading - any key takeaways?",
            "Conference or course today?",
            "Have a link to share from your studies?",
            "Weekend learning to capture?"
        ],
        
        // STREAK MAINTENANCE (shown when user has active streak)
        streakActive: [
            "Keep your streak going - quick reflection?",
            "Continue your learning momentum",
            "Another day, another insight to capture",
            "What's today's reflection?",
            "Maintain your streak with today's learning"
        ],
        
        // DEFAULT/UNIVERSAL (fallbacks and general use)
        universal: [
            "What have you learned today?",
            "Have notes from a coaching session?",
            "Noticed a risk or safety concern?",
            "Picked up a new concept?",
            "Noticed a shift in perspective?",
            "Want to paste meeting or case notes?",
            "Noticed an opportunity for improvement?",
            "Learned something worth sharing?",
            "Have an insight to capture?",
            "Time for a quick reflection?"
        ]
    };

    // Configuration for the phrase cycle
    const cycleConfig = {
        intervalMs: 4000, // 4 seconds per phrase
        fadeTransitionMs: 300, // Smooth fade between phrases
        pauseOnHover: true, // Stop cycling when user hovers
        resumeAfterInteraction: false, // Don't resume after user starts typing
        maxBeforeRepeat: 10 // Maximum phrases to cycle through before repeating
    };

    // Utility function to shuffle array
    function shuffleArray(array) {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }

    // Get contextually relevant phrase cycle based on time and user data
    function getPhraseCycle() {
        const now = new Date();
        const hour = now.getHours();
        const day = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
        const hasStreak = reflectivityMeter && reflectivityMeter.reflectionStreak > 0;
        
        let phrases = [];
        
        // 1. Time-based phrases (primary)
        if (hour >= 5 && hour < 8) {
            phrases = [...smartTriggerPhrases.earlyMorning];
        } else if (hour >= 8 && hour < 12) {
            phrases = [...smartTriggerPhrases.morning];
        } else if (hour >= 12 && hour < 17) {
            phrases = [...smartTriggerPhrases.afternoon];
        } else if (hour >= 17 && hour < 20) {
            phrases = [...smartTriggerPhrases.endOfShift];
        } else if (hour >= 20 && hour < 24) {
            phrases = [...smartTriggerPhrases.evening];
        } else {
            // Late night/early morning default
            phrases = [...smartTriggerPhrases.universal];
        }
        
        // 2. Add day-specific phrases (mixed in)
        if (day === 1) { // Monday
            phrases.push(...smartTriggerPhrases.monday);
        } else if (day === 5) { // Friday  
            phrases.push(...smartTriggerPhrases.friday);
        } else if (day === 0 || day === 6) { // Weekend
            phrases.push(...smartTriggerPhrases.weekend);
        }
        
        // 3. Add streak phrases if applicable
        if (hasStreak && Math.random() < 0.3) { // 30% chance to show streak message
            phrases.unshift(smartTriggerPhrases.streakActive[
                Math.floor(Math.random() * smartTriggerPhrases.streakActive.length)
            ]);
        }
        
        // 4. Always include some universal phrases for variety
        phrases.push(...smartTriggerPhrases.universal.slice(0, 5));
        
        // 5. Shuffle to ensure variety and limit length
        const shuffled = shuffleArray(phrases);
        return shuffled.slice(0, cycleConfig.maxBeforeRepeat);
    }

    // Initialize smart phrase cycling animation
    function initPhraseCycling() {
        const phraseCycle = document.querySelector('#smart-phrase-cycle');
        if (!phraseCycle) return;
        
        // Get contextually relevant phrases
        const smartPhrases = getPhraseCycle();
        
        // Create phrase elements dynamically
        phraseCycle.innerHTML = '';
        smartPhrases.forEach((phraseText, index) => {
            const phraseElement = document.createElement('span');
            phraseElement.className = 'phrase';
            phraseElement.textContent = phraseText;
            phraseElement.style.opacity = index === 0 ? '1' : '0';
            phraseCycle.appendChild(phraseElement);
        });
        
        const phrases = phraseCycle.querySelectorAll('.phrase');
        const phraseCount = phrases.length;
        
        if (phraseCount === 0) return;
        
        let currentIndex = 0;
        let cycleInterval = null;
        let isPaused = false;
        
        // Enhanced cycling function with smooth transitions
        function cyclePhrases() {
            if (isPaused) return;
            
            // Fade out current phrase
            phrases[currentIndex].style.opacity = '0';
            
            // Move to next phrase
            currentIndex = (currentIndex + 1) % phraseCount;
            
            // Fade in next phrase after transition delay
            setTimeout(() => {
                if (!isPaused) {
                    phrases[currentIndex].style.opacity = '1';
                }
            }, cycleConfig.fadeTransitionMs);
        }
        
        // Start cycling
        function startCycling() {
            if (cycleInterval) clearInterval(cycleInterval);
            cycleInterval = setInterval(cyclePhrases, cycleConfig.intervalMs);
        }
        
        // Stop cycling
        function stopCycling() {
            if (cycleInterval) {
                clearInterval(cycleInterval);
                cycleInterval = null;
            }
        }
        
        // Pause/resume functionality
        if (cycleConfig.pauseOnHover) {
            phraseCycle.addEventListener('mouseenter', () => {
                isPaused = true;
                stopCycling();
            });
            
            phraseCycle.addEventListener('mouseleave', () => {
                isPaused = false;
                startCycling();
            });
        }
        
        // Check for form interaction to pause cycling
        const liminalTextarea = document.getElementById('liminal_spark');
        
        if (liminalTextarea && !cycleConfig.resumeAfterInteraction) {
            liminalTextarea.addEventListener('focus', () => {
                isPaused = true;
                stopCycling();
            });
        }
        
        // Start the cycling after initial display time
        setTimeout(() => {
            startCycling();
        }, cycleConfig.intervalMs);
    }

    // Initialize certificate reminder banner (shows until Jan 2, 2026)
    function initCertificateReminderBanner() {
        const banner = document.getElementById('certificate-reminder-banner');
        if (!banner) return;

        // Check if current date is before Jan 2, 2026
        const expiryDate = new Date('2026-01-02T23:59:59');
        const now = new Date();

        if (now < expiryDate) {
            banner.style.display = 'block';
        }
    }

    // DOM initialization function
    async function initializeDOMElements() {
        console.log('DOM initialization started - readyState:', document.readyState);

        console.log("Credit modal initialized (no separate overlay needed)");

        // Initialize certificate reminder banner
        initCertificateReminderBanner();
        console.log("Certificate reminder banner initialized");

        // Initialize reflective practice panel
        initializeReflectivePracticePanel();
        console.log("Reflective practice panel initialized");
        
        // Note: Smart nudges are loaded after authentication in InitiateMainApp()
        
        const alertsOverlay = document.getElementById('alertsFeedOverlay');
        if (alertsOverlay) {
            alertsOverlay.addEventListener('click', toggleAlertsFeed);
        }
        console.log("Alerts feed overlay initialized");
        
        // Initialize keyboard shortcuts
        initKeyboardShortcuts();
        console.log("Keyboard shortcuts initialized");

        // Initialize command palette
        commandPalette.init();
        console.log("Command palette initialized");
        
        // Keep reflectivityMeter for backward compatibility but don't initialize UI
        // reflectivityMeter.init();
        console.log("Legacy reflectivity meter preserved for data compatibility");

        // Initialize smart autofocus for liminal textarea
        initLiminalAutofocus();
        console.log("Smart autofocus for liminal textarea initialized");
        
        // Initialize auto-expanding textarea
        initAutoExpandingTextarea();
        console.log("Auto-expanding textarea initialized");

        // Initialize speech recognition
        initSpeechRecognition();
        console.log("Speech recognition initialized");

        // Initialize global chat functions
        initGlobalChatFunctions();
        console.log("Global chat functions initialized");        
        
        // Initialize chat interface
        initChatInterface();
        console.log("Chat interface initialized");

        // Update keyboard shortcuts for platform
        updateKeyboardShortcutHints();
        console.log("Keyboard shortcuts updated based on platform");

        // Initialize phrase cycling animation
        initPhraseCycling();
        console.log("Phrase cycling animation initialized");

        console.log("DOM initialization completed successfully");
    }
    
    // Initialize when DOM is loaded - with fallback for already loaded DOM
    console.log('Script loaded - document.readyState:', document.readyState);
    
    (async () => {
        if (document.readyState === 'loading') {
            // DOM is still loading, wait for DOMContentLoaded
            console.log('DOM is loading, waiting for DOMContentLoaded event...');
            document.addEventListener('DOMContentLoaded', async () => await initializeDOMElements());
        } else {
            // DOM is already loaded, initialize immediately
            console.log('DOM is already ready, initializing immediately...');
            await initializeDOMElements();
        }
    })();

    // Update keyboard shortcut hints based on platform
    function updateKeyboardShortcutHints() {
        const isMac = navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;
        const modifierKey = isMac ? '⌘' : 'Ctrl';
        
        // Update keyboard shortcut display
        const shortcutHints = document.querySelectorAll('.keyboard-shortcuts kbd');
        if (shortcutHints.length >= 2) {
            shortcutHints[0].textContent = modifierKey;
            shortcutHints[2].textContent = modifierKey; // Second set of shortcuts
        }
        
        // Update analyze button tooltip
        const analyzeButton = document.getElementById('start-button');
        if (analyzeButton) {
            const currentTitle = analyzeButton.getAttribute('title');
            if (currentTitle) {
                analyzeButton.setAttribute('title', currentTitle.replace('⌘', modifierKey));
            }
        }
    }

    // Smart autofocus for liminal textarea
    function initLiminalAutofocus() {
        // Handle paste operations specifically
        document.addEventListener('keydown', function(event) {
            // Handle Cmd+V / Ctrl+V paste
            if ((event.metaKey || event.ctrlKey) && event.key === 'v') {
                const activeElement = document.activeElement;
                
                // If not focused on an input and no modals are open, focus liminal textarea for paste
                if (!activeElement || !['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName)) {
                    if (!commandPalette.isOpen) {
                        const modalContainers = document.querySelectorAll('#liminalmodal, #validationmodal, #helpmodal, #commandpalette');
                        let hasVisibleModal = false;
                        modalContainers.forEach(modal => {
                            if (!modal.classList.contains('hidden') && modal.style.display !== 'none') {
                                hasVisibleModal = true;
                            }
                        });
                        
                        if (!hasVisibleModal) {
                            const liminalTextarea = document.getElementById('liminal_spark');
                            if (liminalTextarea && !liminalTextarea.disabled) {
                                liminalTextarea.focus();
                                // Let the browser handle the paste naturally
                                return;
                            }
                        }
                    }
                }
                return;
            }
        });
        
        // Handle regular typing
        document.addEventListener('keydown', function(event) {
            // Only handle printable characters (letters, numbers, punctuation, space)
            if (event.key.length !== 1) return;
            
            // Don't interfere with keyboard shortcuts (Ctrl, Cmd, Alt combinations)
            if (event.ctrlKey || event.metaKey || event.altKey) return;
            
            // Don't interfere if user is already typing in an input field
            const activeElement = document.activeElement;
            if (activeElement && ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName)) {
                return;
            }
            
            // Don't interfere if command palette is open
            if (commandPalette.isOpen) {
                return;
            }
            
            // Don't interfere if any modal is open - check specific modal containers only
            const modalContainers = document.querySelectorAll('#liminalmodal, #validationmodal, #helpmodal, #commandpalette');
            let hasVisibleModal = false;
            modalContainers.forEach(modal => {
                if (!modal.classList.contains('hidden') && modal.style.display !== 'none') {
                    hasVisibleModal = true;
                }
            });
            
            if (hasVisibleModal) return;
            
            // Don't interfere if any overlay is visible
            const overlays = document.querySelectorAll('[id*="overlay"]:not(.hidden), [class*="overlay"]:not(.hidden)');
            for (let overlay of overlays) {
                if (overlay.style.display !== 'none' && !overlay.classList.contains('hidden')) {
                    return;
                }
            }
            
            // All clear - auto-focus and insert the character into liminal textarea
            const liminalTextarea = document.getElementById('liminal_spark');
            if (liminalTextarea && !liminalTextarea.disabled) {
                // Focus the textarea
                liminalTextarea.focus();
                
                // Insert the character at current cursor position
                const start = liminalTextarea.selectionStart;
                const end = liminalTextarea.selectionEnd;
                const currentValue = liminalTextarea.value;
                
                // Insert the typed character
                liminalTextarea.value = currentValue.substring(0, start) + event.key + currentValue.substring(end);
                
                // Move cursor to after the inserted character
                liminalTextarea.setSelectionRange(start + 1, start + 1);
                
                // Trigger input event for auto-resize
                liminalTextarea.dispatchEvent(new Event('input', { bubbles: true }));
                
                // Prevent the default behavior since we've handled the input
                event.preventDefault();
            }
        });
    }

    // Keyboard shortcuts
    function initKeyboardShortcuts() {
        document.addEventListener('keydown', function(event) {
            // Only log if it's not a regular typing key
            if (event.key.length === 1 && /[a-zA-Z0-9]/.test(event.key)) {
                // Don't log regular typing
            } else {
                console.log("Keyboard shortcut keydown:", event.key);
            }
            
            // Escape key to close command palette
            if (event.key === 'Escape') {
                console.log("Escape key pressed");
                const commandPalette = document.getElementById('commandpalette');
                console.log("Command palette hidden?", commandPalette?.classList.contains('hidden'));
                if (commandPalette && !commandPalette.classList.contains('hidden')) {
                    console.log("Closing command palette via Escape");
                    event.preventDefault();
                    closeCommandPalette();
                    return;
                }
            }
            
            // Cmd+Enter (Mac) or Ctrl+Enter (Windows/Linux) to trigger Start button
            if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
                // Only trigger if we're focused on the liminal spark textarea or if no modal is open
                const liminalTextarea = document.getElementById('liminal_spark');
                const chatInterface = document.getElementById('chat-interface');
                const isModalOpen = !document.getElementById('liminalmodal').classList.contains('hidden') ||
                                   !document.getElementById('validationmodal').classList.contains('hidden') ||
                                   !document.getElementById('commandpalette').classList.contains('hidden');
                const isChatOpen = chatInterface && !chatInterface.classList.contains('hidden');
                
                if (liminalTextarea && !isModalOpen && !isChatOpen && liminalTextarea.value.trim() !== '') {
                    event.preventDefault();
                    performTask('analyze-spark');
                }
            }
        });
    }
})();
